/* GENERATED by shopify/build_assets.sh — do not edit.
   Source files, in load order, live in collection/rescue-rainbows/. */

/* ---- content.js ---- */
// RESCUE RAINBOWS — every number, name and city lives here, not in the markup.
// Edit this file, refresh, done. No build step.
//
// !! ANYTHING MARKED DRAFT IS A PLACEHOLDER !! Prices, the split, the tour
// cities after Chicago, and the whole photographer bio are shaped right but not
// decided. See HANDOFF.md before any of it goes near a person.

window.CONTENT = {
  meta: {
    // RESCUE RAINBOW is the public brand. PET PHOTO BOOTH describes the
    // activation without competing with the name.
    name: 'RESCUE RAINBOW',
    parent: 'RESCUE RAINBOW',
    // IT IS PHOTO BOOTH AGAIN. This was renamed to PET PORTRAIT STUDIO on 2 Sep
    // 2026 on the argument that a booth hands you a strip before you stand up
    // and this hands you edited portraits a week later — Paul reversed it on
    // 3 Sep and the product titles went with it. The handles never changed
    // (pet-photo-booth-*), so the URLs were always saying this anyway.
    // If it swings back, this line and the three product titles are the whole
    // job — nothing else hardcodes either name.
    descriptor: 'PHOTO BOOTH',

    // The orb sits BESIDE the type, not inside it. It briefly replaced the O in
    // PHOTO — the move the brand bible makes with RAINBOWS — and it is out
    // again: at header size the orb-as-letter is a 20px circle competing with
    // the counters of two other Os in the same word, and it reads as a smudge
    // rather than as the mark. Set this back to { word, index } to restore it.
    orbLetter: null,

    tagline: 'GOOD LIGHT GETS THEM SEEN',
    // Displaced by the brand bible's supporting line but too good to bin.
    // Campaign line — posters, tote, the shop. Not the lockup.
    campaign: 'YOU GLOW DOG',
    // Heads the giving side only.
    purpose: 'GLOW FOR GOOD',
    // THE CAROUSEL (6 Sep 2026), the words on it that are nowhere else. Only
    // _reel.html reads these.
    //
    // The headline frame. "RESCUE RAINBOWS!" is Paul's typed copy (third
    // pass) — the plural and the bang are his; meta.name above is singular
    // and the post says what he typed. THE SUBTITLE UNDER IT, chosen 7 Sep
    // 2026 from a shortlist to say what it is and how it helps in one
    // breath. THE LINE IS PAUL'S, 7 Sep 2026, later that morning: "A
    // portrait studio helping local fur babies" — set on two lines, and
    // `glow` names the words the spectrum runs through. It replaced "Your
    // pet gets a rainbow. A shelter animal gets one too." (his pick from
    // my shortlist an hour earlier), which replaced "A rainbow photo booth
    // for your pets / Every session gives a session to a shelter animal".
    carousel: {
      headline: ['RESCUE', 'RAINBOWS!'],
      // the same name without the bang, for the tour page's lockup and its
      // foot — plural, as he says it; meta.name above stays singular
      wordmark: 'RESCUE RAINBOWS',
      // the byline at the foot of the headline frame and the tour page
      // (Paul, 7 Sep: "a black RESCUE RAINBOWS BY PAUL OCTAVIOUS on the
      // bottom center")
      byline: 'RESCUE RAINBOWS BY PAUL OCTAVIOUS',
      lines: ['A PORTRAIT STUDIO',
              'HELPING LOCAL FUR BABIES'],
      glow: 'FUR BABIES',
      // THE FRONT PAGE'S DOGS DO THE TALKING. Paul, 7 Sep: "maybe on the
      // front page the dogs say what this is and what we do, maybe they also
      // say the cities — See Ya Soon Chicago! ATL ♥ — maybe they're funny and
      // odd, the sentences aren't long." One line a step, eight steps a loop,
      // in this order; the first two city lines are his verbatim. Whoever is
      // standing in the queue says it, and says it jumping. The heart is the
      // text heart, not the emoji — a colour emoji in a pixel bubble is a
      // sticker on a drawing.
      queue: [
        'Rescue Rainbows! Is this the line?',
        'See ya soon Chicago!',
        'ATL \u2665',
        'I\u2019m here for the rainbow.',
        'Every session helps a shelter pup.',
        'Nashville, save me a spot.',
        'Detroit in November. Bring a coat.',
        'Do my good side. Both sides.',
      ],
      // The one word inside the factory that is not a bark: what the
      // piston says when it lands on a nose (Paul, 7 Sep: "bark only,
      // maybe BOOP!").
      boop: 'BOOP!',
    },
    // The last frame: "see you soon" and THE TOUR — these cities, with their
    // days read out of `tour.dates` above (all five have them since 7 Sep),
    // dated ones first, each city in its own colour out of `cities`.
    seeYouSoon: {
      head: ['SEE YOU', 'SOON'],
      cities: ['CHICAGO', 'ATLANTA', 'NASHVILLE', 'NEW HAVEN', 'DETROIT'],
    },
    line: 'You bring your dog. We bring the lights. A shelter dog gets its picture taken.',
    home: 'CHICAGO',
    studio: 'RAVENSWOOD',
    email: 'Support@pauloctavious.com',
    // THE LITTLE BOX after the sign-up (7 Sep 2026, Paul: "if they're
    // subscribing to get notified, can we just put up a message that says
    // received, you'll hear from us soon — just a little box"). `lineCity`
    // is used when the city is known; {city} is the title-cased name.
    received: {
      head: 'Received.',
      line: 'You\u2019ll hear from us soon.',
      lineCity: 'You\u2019ll hear from us the moment {city} goes on sale.',
    },
    // NOT RENDERED since 6 Sep 2026 — it came off the footer (Paul), and the
    // handle was never verified anyway. Kept so the day it is real it is here.
    instagram: '@rescuerainbows',
    wishlist: 'https://www.amazon.com/hz/wishlist/ls/REPLACE-ME',
    // CHECKOUT IS LIVE, 6 Sep 2026. The two Chicago products are Active on
    // pauloctavious.com, so this is a real URL — the date list they hang off —
    // and every "not live yet" notice, which keys off this starting with
    // mailto:, has cleared itself. Put the mailto back and they all return.
    booking: 'https://pauloctavious.com/rainbows#dates',
    // The project ran as PET TECHNICOLOR before this. Kept here as prior art —
    // it is not on the site, but it is what people may search for.
    formerly: 'PET TECHNICOLOR',
  },

  // THE ALUMNI. Every dog already photographed, from the six session folders
  // in Paul's Drive. Real names off the real files — not invented, and the
  // front page counts them, so the number on the site is a true one.
  alumni: [
    'AROL', 'BARRY', 'BERNIE', 'BLUE', 'BODACIOUS', 'BOOKER',
    'BORRIS', 'BUFFY', 'BUMI', 'CHARLOTTE', 'DELILAH', 'EIN',
    'ELEANOR', 'ENZO', 'EVIE', 'FRITZ', 'GORDO', 'GRETA',
    'HARLEE', 'HARLOWE', 'HAROLD', 'IZZY', 'JAX', 'LAX',
    'LENOX', 'LUCA', 'MARVIN', 'MILO', 'MOOSE', 'OLIVE',
    'OTIS', 'PHOEBE', 'POVI', 'PROJECT PAT', 'RILEY', 'SAMMIE',
    'SAWYER', 'SCOUT', 'STANLEY', 'STINKERBELLE', 'TANGO', 'THOR',
    'WILLA',
  ],

  // THE PHOTOGRAPHS. 43 of them, and they are real: built by `build_photos.py`
  // straight out of the two Drive archives Paul dropped on 28 Aug 2026, which
  // are 3.4 GB of 67 MB TIFFs. The web set is 11 MB total.
  //
  // EVERY ONE IS SQUARE AND ON PURE BLACK. That is why the strip on the front
  // page is a black full-bleed band rather than framed cards — the photographs
  // run into one another and into the band, and the only thing separating them
  // is the dogs. Do not put them on the ivory paper; a black square on ivory is
  // a hole in the page.
  //
  // ** SCOUT STANLEY NEEDS CONFIRMING. ** The file is `Session A/Scout
  // Stanley.tif` and it is ONE dog, not two. There is a separate `scoutv1.tif`
  // that is already SCOUT, and STANLEY is in the roll call with no photograph
  // of his own — so this is probably Stanley. Probably is not good enough for a
  // caption on somebody's pet. Ask Paul, then fix the name here and rename the
  // file to match.
  photos: [
    { file: 'photos/web/arol.jpg', name: 'AROL' },
    { file: 'photos/web/barry.jpg', name: 'BARRY' },
    { file: 'photos/web/bernie.jpg', name: 'BERNIE' },
    { file: 'photos/web/blue.jpg', name: 'BLUE' },
    { file: 'photos/web/bodacious.jpg', name: 'BODACIOUS' },
    { file: 'photos/web/booker.jpg', name: 'BOOKER' },
    { file: 'photos/web/borris.jpg', name: 'BORRIS' },
    { file: 'photos/web/buffy.jpg', name: 'BUFFY' },
    { file: 'photos/web/bumi.jpg', name: 'BUMI' },
    { file: 'photos/web/charlotte.jpg', name: 'CHARLOTTE' },
    { file: 'photos/web/delilah.jpg', name: 'DELILAH' },
    { file: 'photos/web/ein.jpg', name: 'EIN' },
    { file: 'photos/web/eleanor.jpg', name: 'ELEANOR' },
    { file: 'photos/web/enzo.jpg', name: 'ENZO' },
    { file: 'photos/web/evie.jpg', name: 'EVIE' },
    { file: 'photos/web/fritz.jpg', name: 'FRITZ' },
    { file: 'photos/web/gordo.jpg', name: 'GORDO' },
    { file: 'photos/web/greta.jpg', name: 'GRETA' },
    { file: 'photos/web/harlee.jpg', name: 'HARLEE' },
    { file: 'photos/web/harlowe.jpg', name: 'HARLOWE' },
    { file: 'photos/web/harold.jpg', name: 'HAROLD' },
    { file: 'photos/web/izzy.jpg', name: 'IZZY' },
    { file: 'photos/web/jax.jpg', name: 'JAX' },
    { file: 'photos/web/lax.jpg', name: 'LAX' },
    { file: 'photos/web/lenox.jpg', name: 'LENOX' },
    { file: 'photos/web/luca.jpg', name: 'LUCA' },
    { file: 'photos/web/marvin.jpg', name: 'MARVIN' },
    { file: 'photos/web/milo.jpg', name: 'MILO' },
    { file: 'photos/web/moose.jpg', name: 'MOOSE' },
    { file: 'photos/web/olive.jpg', name: 'OLIVE' },
    { file: 'photos/web/otis.jpg', name: 'OTIS' },
    { file: 'photos/web/phoebe.jpg', name: 'PHOEBE' },
    { file: 'photos/web/povi.jpg', name: 'POVI' },
    { file: 'photos/web/project-pat.jpg', name: 'PROJECT PAT' },
    { file: 'photos/web/riley.jpg', name: 'RILEY' },
    { file: 'photos/web/sammie.jpg', name: 'SAMMIE' },
    { file: 'photos/web/sawyer.jpg', name: 'SAWYER' },
    { file: 'photos/web/scout-stanley.jpg', name: 'SCOUT STANLEY' },
    { file: 'photos/web/scout.jpg', name: 'SCOUT' },
    { file: 'photos/web/stinkerbelle.jpg', name: 'STINKERBELLE' },
    { file: 'photos/web/tango.jpg', name: 'TANGO' },
    { file: 'photos/web/thor.jpg', name: 'THOR' },
    { file: 'photos/web/willa.jpg', name: 'WILLA' },
  ],

  // THE REEL — WHICH PHOTOGRAPHS RUN UNDER THE PORTAL, AND IN WHAT ORDER.
  //
  // Empty means all of `photos`, in the order they are listed above. Put names
  // here — exactly as they are spelled in `photos` — and the band shows only
  // those, in this order. A name that matches nothing is dropped silently, so a
  // typo costs you a frame rather than a broken image on the front page.
  //
  // The band is a loop with no beginning, so ORDER IS ADJACENCY, not sequence:
  // what matters is which dog sits next to which, and that the last one reads
  // well against the first. Pace the coats — two pale dogs together disappear
  // into each other on the black.
  //
  // `_curate.html` shows all of them at thumb size and writes this list for you.
  reel: [
    'HAROLD',
    'AROL',
    'CHARLOTTE',
    'BOOKER',
    'HARLEE',
    'THOR',
    'SAMMIE',
    'SCOUT STANLEY',
    'OTIS',
    'MILO',
    'EVIE',
    'FRITZ',
    'BARRY',
  ],

  // WHAT IT IS, in Paul's own words. The clearest line anybody has written
  // about this project and it should be the first thing on the front page.
  what: 'A rainbow portrait studio.',
  session: '15 minutes',

  // ** BUY ONE, GIVE ONE — AND THE SHELTER ANIMALS COME TO THE STUDIO. **
  //
  // This reverses the 28 Aug 2026 note that used to sit here, which said the
  // crew takes the lights DOWN to the shelters and that the room changes.
  // Paul revised it on 3 Sep 2026: it is buy one give one, and the given
  // sitting happens in the studio — a shelter animal comes in, gets the same
  // room, the same lights and the same retouching, and we help it find a home.
  // Rewritten in `giving`, `why.body`, `tour.lead`, `tour.stop`, `doors` and
  // `volunteers` — if you find another "down to the shelter", it is a leftover
  // from the old rule and it is wrong now.
  //
  // ** AND IT IS NOT A FUNDRAISER. ** Paul, same day: "we're not a nonprofit,
  // so I don't want to call this a fundraiser." Buy one give one is the whole
  // description. No donation, no cause, no proceeds-to.

  // WHAT A SITTING BUYS, said once and briefly. This is the whole of the
  // giving argument on THE SHOOT now — the fundraiser essay that used to sit
  // under the packages is gone, along with the shelter-day breakdown and the
  // what-it-costs-them panel. Paul, 28 Aug 2026: each shoot donates time, or
  // supplies off the wishlist, and usually both.
  giving: 'Every rainbow gives one away. With every rainbow bought, we give rainbows away to shelter animals, in the hope they glow and find a forever home sooner. Sometimes that is time: an animal nobody has come for yet comes into the studio and gets the same room and the same lights. Sometimes it is what is on their list. Usually it is both.',

  // ** ARCHIVED — NEITHER OF THESE IS ON THE SITE. **
  //
  // `why` is held for later; Paul wanted THE SHOOT to stop talking. `room` is
  // not web copy at all any more — it is the prep note a person should get
  // AFTER they have booked, when what they need is to know what they are
  // walking into. Both are kept whole and rendered nowhere. Wiring either back
  // in is a section of markup and two lines of JS.
  //
  // ── THE WHY, AND THE ROOM ────────────────────────────────────────────────
  //
  // Paul dictated all of this on 28 Aug 2026. It is tidied, not rewritten —
  // every idea below is his and most of the good phrases are verbatim:
  // "immortalize my dog and my friend", "he makes dog rainbows, you're safe
  // with him", "shedding light on something you love", "a good photo doesn't
  // sell a dog, it helps a dog find a forever home".
  //
  // THE TAGLINE ALREADY SAID IT. `meta.tagline` is GOOD LIGHT GETS THEM SEEN,
  // and Paul's account is that line's two halves: good light gets YOUR dog
  // seen, and good light gets a SHELTER dog seen. Nothing here replaces the
  // tagline. This is the paragraph underneath it that makes the second meaning
  // land, which is the part that was missing.
  //
  // THE GIVE-BACK IS A SECOND SITTING, plus supplies. As of 3 Sep 2026 it is
  // stated as buy one give one: the bought session pays for a shelter animal's
  // session, in the studio, and the wishlist run rides on top of it. The
  // supplies are "leashes, crates and food" — `beneficiary.buys` in its own
  // order; keep the two in step if that list ever changes.
  //
  // THE SENIOR DOGS ARE THE HEART OF IT and they had appeared nowhere on this
  // site. Handle that line carefully: it is stated plainly, once, without a
  // number on it and without reaching for the reader's throat. The restraint is
  // the respect.
  why: {
    k: 'WHY PEOPLE COME',
    lead: 'Nobody books this for a photograph. They book it for the animal in the photograph.',
    body: [
      'A dog gets a dozen-odd years if everybody is lucky, and most of that dog lives on a phone behind eleven thousand other pictures. People come here to have the one they have got kept somewhere else, on a wall, at the size of a face.',
      'More of them than you would guess are old dogs. Nobody says so directly. They say they want to immortalize their best friend, and that is exactly the job, and it is a privilege to be handed it.',
      'Most people arrive having been told about this by a friend. That is the guy, he makes dog rainbows, your dog is safe with him. That introduction does half the work. The other half is not pointing anything at your dog until it has stopped caring that it is somewhere new.',
      'And in shedding light on your dog, we get to shed some light on the ones who need it. Every rainbow gives one away: your session buys a second one, and a shelter animal comes into this studio and gets the same room, the same lights and the same photograph, with leashes, crates and food off the wishlist on top of it. A really good photograph of a shelter dog can decide whether it finds a forever home or does not. That is the whole of it. Good light gets them seen. It means yours, and it means theirs.',
    ],
  },

  // WHAT ACTUALLY HAPPENS IN THE ROOM.
  //
  // ** NEVER DESCRIBE THE SET-UP. ** Paul, 28 Aug 2026: "let's never mention
  // the set-up, how many lights there are, yada yada." Step four used to be the
  // method — step behind me, squeak something, hold a treat beside one of the
  // lights so the dog looks back and forth — and it is gone. What replaced it
  // is the delivery, which is the thing a person actually needs to know next.
  //
  // The line to hold: this page exists to tell somebody what they are walking
  // into, NOT how the picture is made. Lamp counts, positions and the
  // look-back-and-forth trick stay out of it. That also took "four lamps" out
  // of `tour.lead` and `tour.stop`. The brand may still be about coloured
  // light; the rig is not for publishing.
  //
  // Everything left is real and came from him: the lights on when you arrive,
  // water down, the talk before anything else, the harness off, the seven-inch
  // platform, the owner within touching distance. Do not add to it without
  // asking.
  room: [
    { n: '01', h: 'THE LIGHTS ARE ON WHEN YOU ARRIVE',
      p: 'You can see around the whole studio and there is plenty of water to drink. The first thing that happens is nothing: we talk, and we introduce ourselves.' },
    { n: '02', h: 'THE HARNESS COMES OFF',
      p: 'Just fur. A collar or a harness reads as a stripe of nothing across the middle of the picture, so bring a lead you can take off quickly. No accessories either, unless we have talked about it beforehand.' },
    { n: '03', h: 'YOU STAY IN THE ROOM',
      p: 'Small dogs get a platform, seven inches off the ground. You stand either side of them, close enough to touch. That is not a formality. A settled dog is the whole difference between a good frame and a long afternoon.' },
    { n: '04', h: 'A WEEK LATER, A LINK',
      p: 'You choose. About a week after that a secure link arrives with the photographs on it and you download them. If you bought a print package, you pick which frames get printed.' },
  ],

  // ── THE TOUR ────────────────────────────────────────────────────────────
  //
  // THIS IS THE SPINE OF THE SITE. Every other page is a room off this list.
  // It replaced `opening`, which only ever knew about Chicago.
  //
  // ONE ROW PER DAY, NOT PER CITY. Chicago is two rows, because cats and dogs
  // never share a room on the same day and a ticket is for a day — so a list of
  // cities can never be a list of tickets. A city with three days is three rows
  // and nothing needs changing to allow it.
  //
  // FOUR STATUSES, and the rule is the one the rest of this file obeys: a row
  // states only what is true.
  //
  //   onsale       a date, a room, a price, and a button that takes money.
  //                NOTHING IS THIS YET and nothing may be until a price is
  //                decided — see `tiers`, where every price is null on purpose.
  //                The state is built and styled so that flipping one word here
  //                turns the row into a real buy button on every page at once.
  //   announced    the date and the room are real; tickets are not on sale.
  //                This is Chicago. It is what a tour site says between the
  //                announcement and the on-sale, and it is the honest status
  //                for a date whose price does not exist.
  //   unannounced  a city on the route with NO DATE. Not "coming soon", not a
  //                month, not a season — the row reads TBA and offers to tell
  //                you when it stops reading TBA. A placeholder month on one of
  //                these is how a fundraiser starts lying.
  //   requested    asked for by somebody, not on the route. No date, no venue,
  //                and no suggestion that either is coming.
  //   coming       A DATE ON THE ROUTE, NO ROOM AND NO TICKETS YET (7 Sep 2026,
  //                Paul: "get rid of the ticket sales for Nashville, Atlanta
  //                and New Haven — minimise them to bars and a NOTIFY ME").
  //                Dated but not for sale: it is not a live row, not a stub
  //                ticket, and it never says TICKETS SOON. It renders as a bar
  //                with its days and a NOTIFY ME under COMING TO A CITY NEAR
  //                YOU, and on the full tour list as a row that says DATE SET.
  //                When a room and a listing exist, it becomes `announced`.
  //
  // COLOUR IS EARNED BY BEING ON THE ROUTE. The five route cities carry their
  // own sample of the orb's gradient (see `cities`); requested cities render in
  // ink. That is the entire visual difference between "we are going" and
  // "somebody wants us to", and it needs no extra word to say it.
  //
  // NO TIMES. Doors, windows and slot lengths are not set. `time: null` renders
  // TIME TBA, which is true. Do not put a plausible 11–5 in here.
  tour: {
    name: 'THE 2026 TOUR',
    lead: 'A studio, a van and a set of lights. It stops in a city, photographs the dogs whose people paid, and then puts the same lights on the ones nobody has come for yet.',
    // The free half of every stop. It has no date anywhere yet, so it is a
    // note on the tour rather than a row in it — a row implies a day you could
    // turn up to, and there is not one.
    // WHAT A STOP IS. The reason this is a tour and not six unrelated shoots:
    // every city gets the same three things in the same order, and only the
    // first of them is ticketed. Written here rather than in tour.html because
    // it is the definition of the product, and the definition should not live
    // inside a page's markup.
    stop: [
      { k: 'ONE', h: 'THE TICKETED DAYS',
        p: 'Two Saturdays, cats on one and dogs on the other, never the same room on the same weekend. Fifteen minutes an animal, one animal at a time. This is the half that is bought.' },
      { k: 'TWO', h: 'THE SHELTER DAY',
        p: 'Free, unticketed, and the reason the ticketed days exist. The shelter brings its animals in and they get the room the paying ones got — the same lights, the same retouching — and every picture is the shelter\'s to keep, forever.' },
      { k: 'THREE', h: 'WHAT THE CITY KEEPS',
        p: 'The portraits, in web and print sizes. Everything off the wishlist that has shipped by then. And a shelter with a set of pictures good enough to get an animal looked at twice.' },
    ],
    // THE SEASON. What the band under the reel says. It is deliberately not
    // built from `dates` below: that list is what is booked, in the order it
    // was booked, and the band is the route as it is announced — a season and
    // the cities in it, the way a tour is printed on the back of a shirt.
    // Change the route here and the front page follows.
    // WHERE A SPOT IS ACTUALLY BOUGHT. Keyed 'CITY WHO', the same shape the
    // Shopify page passes in as window.RR_LINKS — which still wins when the
    // site is running as the theme, because there the handles come from the
    // store rather than from here. This is what the LOCAL site uses so a stub
    // points at the real listing instead of at shoot.html.
    //
    // BOTH PRODUCTS ARE DRAFT AS OF 2 SEP 2026. A draft product is not on the
    // storefront, so these resolve to a 404 for anybody who is not signed in to
    // the admin. They go live the moment the products do; nothing here changes.
    tickets: {
      'CHICAGO CATS': 'https://pauloctavious.com/products/pet-portrait-studio-cats-chicago-sun-4-oct',
      'CHICAGO DOGS': 'https://pauloctavious.com/products/pet-photo-booth-dogs-chicago',
      // DETROIT WENT ON SALE 7 Sep 2026 (Paul: "add tickets for Detroit,
      // nothing else — no other cities but Detroit and Chicago are live").
      'DETROIT DOGS': 'https://pauloctavious.com/products/pet-photo-booth-dogs-detroit',
      'DETROIT CATS': 'https://pauloctavious.com/products/pet-photo-booth-cats-detroit',
    },

    season: {
      label: 'F/W 26 27 TOUR',
      cities: ['CHICAGO', 'DETROIT', 'NASHVILLE', 'NEW HAVEN', 'ATLANTA'],
    },
        shelterDay: 'Every stop also runs a shelter day. It is free, it is not ticketed, and the animals photographed on it are the reason the ticketed day exists.',
    dates: [
      { city: 'CHICAGO', state: 'IL', venue: 'THE RAVENSWOOD STUDIO',
        date: '2026-09-27', time: null, who: 'DOGS', status: 'onsale',
        note: 'The home stop, in the studio the whole thing runs out of.' },
      // THE CATS DAY MOVED OFF THE DOGS WEEKEND ENTIRELY, 3 Sep. It used to be
      // the Saturday before, on the argument that a room full of dogs on
      // Saturday is not a room a cat will sit down in on Sunday. A week between
      // them is that argument taken seriously rather than solved by an
      // overnight. The 26 Sep listing is archived, not deleted.
      { city: 'CHICAGO', state: 'IL', venue: 'THE RAVENSWOOD STUDIO',
        date: '2026-10-04', time: null, who: 'CATS', status: 'onsale',
        note: 'A week after the dogs, on purpose. A room that had twenty dogs in it yesterday is not a room a cat will sit down in.' },
      // DETROIT HAS A WEEKEND, 6 Sep 2026 — Paul, for the carousel's last
      // frame: "Detroit in early Nov, pick an early 2 day weekend." The first
      // full weekend of November, dogs first the way Chicago runs, cats the
      // day after — a two-day tour stop, not Chicago's week apart. NO ROOM
      // YET: `announced` with a null venue renders VENUE TO BE CONFIRMED and
      // TICKETS SOON, which is the truth of it. Put the venue here when there
      // is one.
      // ON SALE 7 Sep 2026 — the two Detroit listings are ACTIVE on the
      // Online Store (venue still to be confirmed, so `venue` stays null).
      { city: 'DETROIT', state: 'MI', venue: null, date: '2026-11-07', time: null,
        who: 'DOGS', status: 'onsale', note: '' },
      { city: 'DETROIT', state: 'MI', venue: null, date: '2026-11-08', time: null,
        who: 'CATS', status: 'onsale', note: '' },
      // THREE MORE WEEKENDS, 7 Sep 2026 — Paul, for the carousel's last frame:
      // "New Haven early December, that first weekend; Atlanta near
      // Valentine's Day, whatever weekend that's at; Nashville the weekend
      // right after Atlanta." Dogs Saturday, cats Sunday, the way Detroit
      // runs. No rooms yet: `announced` with a null venue renders VENUE TO BE
      // CONFIRMED and TICKETS SOON. Put the venue in when there is one.
      { city: 'NEW HAVEN', state: 'CT', venue: null, date: '2026-12-05', time: null,
        who: 'DOGS', status: 'coming', note: '' },
      { city: 'NEW HAVEN', state: 'CT', venue: null, date: '2026-12-06', time: null,
        who: 'CATS', status: 'coming', note: '' },
      // Valentine's Day 2027 is the Sunday. These six are `coming`, not
      // `announced` — dated, not for sale; see the status note above.
      { city: 'ATLANTA', state: 'GA', venue: null, date: '2027-02-13', time: null,
        who: 'DOGS', status: 'coming', note: '' },
      { city: 'ATLANTA', state: 'GA', venue: null, date: '2027-02-14', time: null,
        who: 'CATS', status: 'coming', note: '' },
      { city: 'NASHVILLE', state: 'TN', venue: null, date: '2027-02-20', time: null,
        who: 'DOGS', status: 'coming', note: '' },
      { city: 'NASHVILLE', state: 'TN', venue: null, date: '2027-02-21', time: null,
        who: 'CATS', status: 'coming', note: '' },
    ],
  },

  // WHAT A TICKET IS. Written as a ticket, because the site sells one.
  //
  // Every line here is fact from the real listing. There is no price on it and
  // there must not be one until `tiers` has one — the ticket surfaces read
  // `tiers` for that and say NO PRICES YET when they find null.
  ticket: {
    // THE TICKET IS ONE OF THE FOUR LIGHTS, FLAT AND FULL BLEED. Not white with
    // a stripe of the colour on it — the whole card is the light. That is the
    // only way a ticket reads as a graphic object across a room, and it costs
    // nothing, because it invents no colour: blue and green are two of the four
    // lamps the booth actually points at the animal.
    //
    // CATS ARE BLUE AND DOGS ARE GREEN, in every city, forever. Species and not
    // sequence — "the first one is blue" breaks the moment a second city gets
    // dates, and it also throws away the one thing worth encoding, which is
    // that a cat day and a dog day are genuinely different days.
    //
    // THE TYPE COLOUR IS CHOSEN BY CONTRAST, NOT BY PREFERENCE. The four lights
    // are nowhere near equally dark. Paper on blue is 5.6:1 and passes at any
    // size; paper on green is 3.4:1 and fails for anything small, while ink on
    // green is 4.9:1 and passes. So blue takes paper and green takes ink, and
    // the pair still reads as two lights rather than two decisions. Add red or
    // yellow here and run the same check before choosing — red is marginal
    // both ways and yellow is obviously ink.
    //
    // THE ANIMAL KEEPS ALL FOUR LIGHTS, INCLUDING THE CARD'S OWN — so the cat
    // carries blue on the blue ticket and the dog carries green on the green
    // one, and as the loop drifts, rings of the animal dissolve into the card
    // and come back. That is PAUL'S CALL and it is the point, not a defect.
    //
    // A three-light version was built to stop it (`.beast.tri`, the card's own
    // lamp left out) and REJECTED. Do not reinstate it, and do not "fix" the
    // dissolve with a keyline either — that was tried too. The animal is meant
    // to be lit by the same four lamps as everything else, and a booth whose
    // subject sometimes disappears into its own light is a better description
    // of this project than a subject that always sits on top of it.
    //
    // THE TYPE IS INK ON BOTH, by instruction — the white version is gone.
    // Worth knowing what that costs: ink on green is 4.9:1 and fine, but ink on
    // red is 3.8:1, which clears the bar for large text (18.7px bold and up) and
    // misses it for small. Everything small on the card is therefore set at full
    // opacity rather than the 0.75 it used to carry. If a fifth light is ever
    // put on a ticket, check it before choosing.
    lights: {
      CATS: { light: 'var(--red)',   type: 'var(--ink)' },
      DOGS: { light: 'var(--green)', type: 'var(--ink)' },
    },

    // THE HEADLINE IS THE SPECIES, AND NOTHING ELSE. It was CAT PHOTO BOOTH /
    // DOG PHOTO BOOTH for a version; it is now just CATS and DOGS, set in the
    // four lights, at the biggest size the card allows.
    //
    // There is no `names` map any more — the headline is `who` off the date
    // row, so it cannot disagree with the animal on the stub or the row in the
    // tour list, and a day that is neither reads CATS + DOGS, which is true.
    // The brand name is not on the ticket at all: it is in the header, in the
    // footer, and on the promoter line at the top of the card, and a ticket
    // that spends its largest type saying its own brand name is an advert.
    // ADMIT ONE CAT, not ADMIT ONE PET. The ticket already knows which animal
    // it is for — it says so in the largest type on the card — so the stub may
    // as well say it too. Falls back to PET for a day that is both.
    // "ONE ANIMAL · ONE SLOT" is gone: ADMIT ONE CAT says it in three words.
    // THE PHOTOGRAPH ON EACH TICKET, by name rather than by path — the file
    // comes out of `photos` below, so there is one place a filename lives.
    //
    // BARRY IS A CAT. That is why he is on the cats ticket, and it is worth
    // saying out loud: the roll call calls all 43 of these "dogs" and at least
    // one of them is not. See the note on `alumni`.
    //
    // Both picks are bright ones on purpose. Every photograph in the set is on
    // pure black, and half of them are of dark animals — Moose is a black dog
    // and lands on a green card as a black square. A ticket's photograph has to
    // survive being the only image on a flat colour field, so it needs an
    // animal the four lights actually caught.
    hero: { CATS: 'BARRY', DOGS: 'JAX' },
    admits: { CATS: 'ADMIT ONE CAT', DOGS: 'ADMIT ONE DOG' },
    admitsFallback: 'ADMIT ONE PET',
    // Set as one line on the ticket, joined with · — the full list belongs on
    // THE SHOOT, where there is room for it to be a list. A receipt layout with
    // leader dots and a TOTAL row was built here and reverted: the ask was
    // bigger, plainer type, not more structure.
    // WHAT'S INCLUDED — Paul's own three, verbatim, 28 Aug 2026. This is the
    // list, not a summary of one: do not add to it.
    //
    // FOUR LIGHTS came off it. It is the best thing about the shoot and it is
    // still on the shoot page, in the footer and in the brand book — but as a
    // spec-line item next to a slot length it reads as equipment, and nobody
    // buying a portrait of their cat is comparing lamp counts.
    //
    // ARCHIVAL PRINT OPTION AVAILABLE is doing real work: THE PRINT and THE SET
    // have no prices yet, so "available" is the most a ticket can honestly say
    // about them, and it stays true when they get one. "Archival" is the one
    // word in the line that is a spec rather than a promise — see `fulfilment`.
    includesLabel: 'INCLUDED',
    includes: [
      'ONE 15-MINUTE SLOT',
      '2–3 EDITED PORTRAITS',
      'ARCHIVAL PRINT OPTION AVAILABLE',
    ],
    // WHAT THE THING ACTUALLY IS. The species is the largest word on the card
    // and it does not say what you are buying; this line does.
    what: 'PORTRAIT SESSION',
    fromLabel: 'FROM',
    // Shown while `meta.booking` is still a mailto. Gated on that, so the day
    // there is a real checkout the line goes on its own.
    notLive: 'CHECKOUT IS NOT LIVE YET · BOOKING GOES THROUGH THE STUDIO',
    terms: [
      'Payment is what holds the slot. Nothing is reserved before it.',
      'A Calendly link arrives after purchase and you pick your own time.',
      'One animal at a time.',
      'JUST FUR. No props, no outfits, no accessories.',
    ],
  },

  // THE SHELTER. Named because Paul named it. It is a real organisation, so
  // this is a public claim about them — get their sign-off before launch.
  beneficiary: {
    name: 'EVANSTON ANIMAL SHELTER',
    area: 'Cook County',
    // The honest phrasing from the original listing. There was a "50%" on this
    // site for a while; it was invented, and it was in the largest type on the
    // front page. Do not put a number here until one is decided.
    share: 'Every rainbow bought gives one away, and a portion of every session',
    buys: ['Leashes', 'Crates', 'Food'],
  },

  // ---------------------------------------------------------------- rescues
  // THE RESCUES, BY CITY. Every link opened by hand on 3 Sep 2026, not taken
  // from a directory: a wish-list URL that 404s sends somebody's money nowhere,
  // and this list exists to stop exactly that.
  //
  // KEYED BY CITY so the donate page can print one list instead of two. It had
  // the shelters under the city heading AND again under the links below, which
  // is the same eleven names twice on one screen.
  //
  // `lists` is only what the organisation itself publishes. An empty `lists` is
  // a fact, not a gap: Evanston, ALIVE and Felines & Canines take money and
  // goods but run no online registry, so the row says so.
  //
  // SMILE.AMAZON URLS ARE REWRITTEN TO amazon.com. Furkids, Nashville Cat
  // Rescue and Friends of the New Haven Animal Shelter all still link
  // smile.amazon.com, which Amazon retired in 2023; the list IDs are the same
  // on the live domain, so the ID is kept and the host corrected.
  rescuesChecked: '3 September 2026',
  rescues: {
    CHICAGO: [
      { name: 'The Anti-Cruelty Society', area: 'River North',
        site: 'https://anticruelty.org', donate: 'https://anticruelty.org/donate',
        lists: [['Amazon','https://www.amazon.com/gp/registry/wishlist/3N908SH9LBEX9'],
                ['Chewy','https://www.chewy.com/g/the-anti-cruelty-society_b71615499#wish-list'],
                ['Walmart','https://www.walmart.com/registry/RR/73ac9631-d655-43b9-a1ac-e1e7374f5ed6']] },
      { name: 'PAWS Chicago', area: 'Lincoln Park + Little Village',
        site: 'https://www.pawschicago.org',
        donate: 'https://www.pawschicago.org/how-to-help/donate/other-ways-to-give/donate-supplies-on-our-wish-list',
        lists: [['Amazon','https://www.amazon.com/hz/wishlist/ls/A91GR1NSCYZO'],
                ['Chewy','https://www.chewy.com/g/paws-chicago_b108348733#wish-list'],
                ['Walmart','https://www.walmart.com/lists/wishlist/fdabd9eb-0b76-44e3-986e-8fa7f69cae89']] },
      { name: 'Tree House Humane Society', area: 'Bucktown',
        site: 'https://treehouseanimals.org', donate: 'https://treehouseanimals.org/ways-to-give/in-kind/',
        lists: [['Amazon','https://www.amazon.com/hz/wishlist/ls/GKRQIALR9W2S'],
                ['Chewy','https://www.chewy.com/g/tree-house-humane-society_b89830594#wish-list']] },
      { name: 'Red Door Animal Shelter', area: 'Rogers Park',
        site: 'https://www.reddoorshelter.org', donate: 'https://www.reddoorshelter.org/donations.php',
        lists: [['Amazon','https://www.amazon.com/registry/wishlist/3T1E432NFLH5P'],
                ['Chewy','https://www.chewy.com/g/red-door-animal-shelter_b71966608#wish-list']] },
      { name: 'Chicago Canine Rescue', area: 'Jefferson Park',
        site: 'https://chicagocaninerescue.org', donate: 'https://chicagocaninerescue.org/donate/wish-list/',
        lists: [['Amazon','https://www.amazon.com/hz/wishlist/ls/331DNUMPUV72V'],
                ['Chewy','https://www.chewy.com/g/chicago-canine-rescue-foundation_b74166165#wish-list']] },
      { name: 'Chicago Animal Care & Control', area: 'West Side · the city shelter',
        site: 'https://www.chicago.gov/city/en/depts/cacc.html',
        donate: 'https://www.chicago.gov/city/en/depts/cacc/supp_info/wish_list.html',
        lists: [['Amazon','https://www.amazon.com/gp/registry/wishlist/32A5NOFYJAVHE']] },
      { name: 'One Tail at a Time', area: 'Wicker Park',
        site: 'https://www.onetail.org', donate: 'https://www.onetail.org/donate/',
        lists: [['Rescue Registry','https://rescueregistry.funraise.org/']] },
      { name: 'Famous Fido Rescue', area: 'Irving Park',
        site: 'https://www.famousfido.org', donate: 'https://www.famousfido.org',
        lists: [['Chewy','https://www.chewy.com/g/famous-fido-rescue-adoption-alliance_b90508771#wish-list']] },
      { name: 'Evanston Animal Shelter', area: 'Evanston · named on the tickets',
        site: 'http://evanstonanimalshelter.net', donate: 'http://evanstonanimalshelter.net/donate-supplies/',
        lists: [] },
      { name: 'ALIVE Rescue', area: 'Bucktown',
        site: 'https://www.aliverescue.org', donate: 'https://www.aliverescue.org/donate', lists: [] },
      { name: 'Felines & Canines', area: 'Edgewater',
        site: 'https://www.felinescanines.org', donate: 'https://www.felinescanines.org/donate', lists: [] },
    ],
    DETROIT: [
      { name: 'Michigan Animal Rescue League', area: 'Pontiac',
        site: 'https://marl.org', donate: 'https://marl.org/ways-to-help/wish-list-needs/',
        lists: [['Amazon','https://www.amazon.com/hz/wishlist/ls/U7C6QFWZAHSF'],
                ['Chewy','https://www.chewy.com/g/michigan-animal-rescue-league_b72121905#wish-list']] },
      { name: 'Rebel Dogs Detroit', area: 'Detroit',
        site: 'https://rebeldogsdetroit.com', donate: 'https://rebeldogsdetroit.com/ways-to-help',
        lists: [['Amazon','https://www.amazon.com/hz/wishlist/ls/35D332IVDU3MI'],
                ['Chewy','https://www.chewy.com/g/rebel-dogs-detroit_b149620323#wish-list']] },
      { name: 'Friends of Detroit Animal Care & Control', area: 'Detroit · the city shelter',
        site: 'https://www.friendsofdacc.org', donate: 'https://www.friendsofdacc.org/give-support',
        lists: [['Amazon','https://www.amazon.com/hz/wishlist/ls/9QV8OZSXWN5M']] },
      { name: 'Detroit Dog Rescue', area: 'Detroit',
        site: 'https://detroitdogrescue.com', donate: 'https://detroitdogrescue.com/donate/', lists: [] },
    ],
    ATLANTA: [
      { name: 'LifeLine Animal Project', area: 'Fulton + DeKalb county shelters',
        site: 'https://lifelineanimal.org', donate: 'https://lifelineanimal.org/wishlist/',
        lists: [['Amazon','https://www.amazon.com/hz/wishlist/ls/2UHJFFTUFCITG'],
                ['Chewy','https://www.chewy.com/g/lifeline-animal-project_b64143970#wish-list']] },
      { name: 'Atlanta Humane Society', area: 'Howell Mill + Alpharetta',
        site: 'https://atlantahumane.org', donate: 'https://atlantahumane.org/get-involved/wish-list/',
        lists: [['Amazon','https://www.amazon.com/gp/registry/wishlist/I1AXR56PM4O6']] },
      { name: 'Furkids', area: "Georgia's largest no-kill",
        site: 'https://furkids.org', donate: 'https://furkids.org/donation/wish-list',
        lists: [['Amazon','https://www.amazon.com/hz/wishlist/ls/2O1VK7S6KZYC9']] },
      { name: 'PAWS Atlanta', area: 'Decatur',
        site: 'https://www.pawsatlanta.org', donate: 'https://www.pawsatlanta.org/donate/wish-list',
        lists: [['Amazon','https://www.amazon.com/hz/wishlist/ls/2VFCGH608TCUJ']] },
    ],
    NASHVILLE: [
      { name: 'Nashville Humane Association', area: 'Sylvan Heights',
        site: 'https://nashvillehumane.org', donate: 'https://nashvillehumane.org/give/wishlist/',
        lists: [['Amazon','https://www.amazon.com/hz/wishlist/ls/3I6EQPZ8OB1DT'],
                ['Chewy','https://www.chewy.com/g/nashville-humane-association_b99925562#wish-list']] },
      { name: 'Nashville Cat Rescue', area: 'Nashville',
        site: 'https://nashvillecatrescue.org', donate: 'https://nashvillecatrescue.org/donate/',
        lists: [['Amazon','https://www.amazon.com/gp/registry/wishlist/33BODU0F26XY6'],
                ['Chewy','https://www.chewy.com/g/nashville-cat-rescue_b83171374#wish-list']] },
    ],
    'NEW HAVEN': [
      { name: 'Friends of the New Haven Animal Shelter', area: 'Fournier Street · the city shelter',
        site: 'https://www.findafriendforlife.org', donate: 'https://www.findafriendforlife.org/donate.html',
        lists: [['Amazon','https://www.amazon.com/gp/registry/wishlist/3SP1YVPL4L75X'],
                ['Chewy','https://www.chewy.com/g/friends-of-the-new-haven-animal-shelter_b88844852#wish-list']] },
      { name: 'Connecticut Humane Society', area: 'Newington + Waterford',
        site: 'https://cthumane.org', donate: 'https://cthumane.org/ways-to-give/wish-list-2/',
        lists: [['Amazon','https://www.amazon.com/hz/wishlist/ls/29THQF8FKV2RJ'],
                ['Chewy','https://www.chewy.com/g/connecticut-humane-society_b77371087#wish-list']] },
      { name: 'The Animal Haven', area: 'North Haven',
        site: 'https://theanimalhavenct.org', donate: 'https://theanimalhavenct.org/ways-to-give/',
        lists: [['Amazon','https://www.amazon.com/registry/wishlist/1IKDGAP8Z26X7']] },
    ],
  },

  // FOUR ITEMS. It was five plus a button, and the button said ADOPT A SPOT two
  // words away from a nav item that said ADOPT — the same verb pointing at two
  // different things, which is the one thing a nav must never do.
  //
  // ABOUT IS BACK. It came out once because photographer.html still says
  // "Portrait goes here", and a nav item is a promise that there is something at
  // the other end. That promise is now outstanding: the page is reachable and
  // unfinished, and the nav is pointing at it.
  //
  // PHOTO BOOTH AND TOUR CAME OUT, which leaves tour.html — the date list, and
  // the only place the two announced Chicago days are bookable — with no link in
  // the header. The front page's own date section still reaches it. See the
  // route band under the reel for the other way in.
  //
  // CONTACT IS A MAILTO, not a page, because an email address is a real answer
  // and a Contact page with a form nobody reads is not. It becomes a page when
  // there is more to say than one address.
  // THE NAV, as Paul set it 3 Sep 2026. Every item is a destination and the
  // label says which: TOUR is the dates, HOW IT WORKS is the steps, ABOUT is
  // the artist section, and the two pages and the address are themselves.
  // DATES became TOUR because the list is a route, not a calendar, and THE
  // STUDIO is gone — it pointed at the steps and HOW IT WORKS says that.
  // DONATE has no equivalent on the shop; it is a local page and stays here.
  // HOW IT WORKS CAME OUT ON 6 Sep 2026, with the section it pointed at. Paul:
  // "it doesn't have to be on the main page … it's pretty straightforward."
  // The steps still render on shoot.html, and the product page a ticket lands
  // on says the same four things in its own description. Same change in
  // shopify/rr-nav.liquid.
  nav: [
    { label: 'TOUR',         href: 'index.html#dates' },
    { label: 'ABOUT',        href: 'index.html#artist' },
    { label: 'ADOPT',        href: 'adopt.html' },
    { label: 'DONATE',       href: 'donate.html' },
    { label: 'CONTACT',      href: 'mailto:Support@pauloctavious.com' },
  ],

  // The front page is a switchboard. Six people arrive at this site and they
  // want six different things; the job of the home page is to sort them fast.
  doors: [
    { k: 'I HAVE A DOG',        h: 'Book a sitting',        p: 'Your pet under the lights, and the rainbow it buys is given away to a shelter animal.',   href: 'shoot.html' },
    { k: 'I WANT IT HERE',      h: 'Bring us to your city', p: 'Five cities to start. The sixth is decided by who asks loudest.',       href: 'tour.html#request' },
    { k: 'I WANT TO SPONSOR',   h: 'Put a name on it',      p: 'A tour needs a floor, a van and a light kit in every city.',            href: 'tour.html#sponsors' },
    { k: 'I WANT TO GIVE',      h: 'Send crates, not cash', p: 'Leashes, crates and food, straight to the shelter. No middleman.',       href: 'donate.html' },
    { k: 'I HAVE A CAMERA',     h: 'Shoot a shelter day',   p: 'Shoot alongside us on a shelter day. We train you on the kit.', href: 'donate.html#photographers' },
    { k: 'I HAVE A SATURDAY',   h: 'Handle the animals',    p: 'Someone has to walk them, hold them and get them back to their kennel.', href: 'donate.html#volunteers' },
  ],

  // THE TOUR. Chicago is real and has dates; the other four are shaped, not
  // booked, and nothing on the site states a date against them.
  //
  // EACH CITY HAS ITS OWN COLOUR, and none of them is a new colour. The brand
  // has four lights and rule 03 says it never gains a fifth — so the city
  // colours are five evenly spaced SAMPLES of the orb's own gradient, taken in
  // OKLab around the yellow-green-blue-red loop. Chicago sits at phase 0, which
  // is the pure brand yellow: the home city gets the colour at the core of the
  // mark. A sixth city just moves the sampling; nothing has to be invented.
  //
  // `near` is that same ramp sampled either side of the city's own phase, so a
  // city's swatch can MOVE without ever leaving its own colour — the stripe
  // breathes through its neighbours in the loop and stays identifiably itself.
  // `spin` is its rate. Every city differs in colour, frequency and speed, and
  // all of it still comes off one gradient.
  //
  // Regenerate with phase = i / cities.length, position = phase * 4, then lerp
  // between COLS[k] and COLS[k+1] in OKLab; near samples at phase +/- 0.085.
  // See HANDOFF.md.
  // `lat`/`lon` are city-centre coordinates, used only to drop a paw print on
  // the map on ADOPT. They are public geography, not the sort of invented datum
  // `shelters` refuses to carry — nobody is sent anywhere by them.
  cities: [
    { city: 'CHICAGO',     state: 'IL', status: 'home',    colour: '#ffc93a', phase: 0.0,
      near: ['#ff9f64', '#ffc93a', '#cfd465'], spin: '5.5s',
      // THE SHELTER THIS CITY GIVES TO, and where its own wishlist lives.
      // Only Chicago has a shelter, because only Chicago has been arranged —
      // `shelter: null` renders TO BE CONFIRMED, which is true, and inventing a
      // name here is the same mistake as inventing an address on `shelters`.
      // Evanston's wishlist URL is unknown: Paul thinks they run a Chewy list,
      // and until somebody has the actual link it stays null and the row simply
      // does not offer one. A wrong wishlist sends food to the wrong building.
      lat: 41.88, lon: -87.63, shelter: 'EVANSTON ANIMAL SHELTER', wishlist: null,
      note: 'Where the studio is. First stop, and the only one with dates.' },
    { city: 'DETROIT',     state: 'MI', status: 'planned', colour: '#31e39a', phase: 0.25,
      near: ['#99dd81', '#31e39a', '#26b7bf'], spin: '7.4s', lat: 42.33, lon: -83.05, shelter: null, wishlist: null, note: '' },
    { city: 'ATLANTA',     state: 'GA', status: 'planned', colour: '#3b4eea', phase: 0.5,
      near: ['#2b8ad7', '#3b4eea', '#8658cc'], spin: '9.3s', lat: 33.75, lon: -84.39, shelter: null, wishlist: null, note: '' },
{ city: 'NASHVILLE',   state: 'TN', status: 'planned', colour: '#ff2e88', phase: 0.75,
      near: ['#c152ad', '#ff2e88', '#ff7379'], spin: '11.2s', lat: 36.16, lon: -86.78, shelter: null, wishlist: null, note: '' },
    // NEW HAVEN MOVED UP FROM `requested` ON 3 SEP. It had been announced on the
    // season band under the reel while every other list on the site still said
    // four cities, so the front page promised a stop that the route did not
    // contain. Colour and phase continue the four-light rotation: yellow.
    { city: 'NEW HAVEN',   state: 'CT', status: 'planned', colour: '#ffc93a', phase: 0.12,
      near: ['#ffe07a', '#ffc93a', '#f2a341'], spin: '8.6s', lat: 41.31, lon: -72.93, shelter: null, wishlist: null, note: '' },
      ],

  // Asked for and not on the tour. The request form feeds this; it is the
  // honest way to run "bring it to my city".
  requested: ['BROOKLYN', 'AUSTIN', 'PORTLAND', 'SAN FRANCISCO', 'PHILADELPHIA'],

  // THE PACKAGES.
  //
  // ** THE SESSION IS $99, AND PAUL SET IT. ** It is the first
  // real number this project has had, and it arrived on 28 Aug 2026: "it starts
  // at $99". THE PRINT and THE SET are still null and must stay null until he
  // says otherwise. "FROM $99" on the ticket is the minimum of whatever is
  // priced here, so it stays true as the other two land.
  //
  // Everything that used to say NO PRICES YET reads this block and clears
  // itself: the banner on THE SHOOT, the line on each ticket, and the labels on
  // the tour rows. Nothing had to be found and deleted, which was the point of
  // building it that way.
  //
  // A price is NOT the same as being able to take one. `meta.booking` is still
  // a mailto, so there is no checkout, and the ticket says so on its own line —
  // gated on the mailto, so that line clears itself too.
  tiers: [
    { code: 'A', name: 'THE SESSION', price: 99, lead: 'Fifteen minutes and the files. No print.',
      items: ['One pet, fifteen minutes, under the lights',
              '2–3 edited digital rainbow portraits',
              'Secure download link within one week',
              'Supports the shelter'] },
    // TWO OPTIONS, NOT THREE. Paul, 6 Sep 2026: "take away the 2 prints and
    // only have 2 options … make it a 12x12 print signed by Paul." THE SET
    // (the two-print rung) is gone here and on both Shopify listings, where
    // the second option is now "Rainbow Pet Portrait × 12×12 Signed Print".
    { code: 'B', name: 'THE PRINT', price: null, lead: 'One 12×12 archival print, signed by Paul, and the files with it.', flag: true,
      items: ['Everything in THE SESSION',
              'One 12×12 print on archival paper, signed by Paul',
              'Digital portraits included',
              'Local pickup at the Ravenswood studio'] },
  ],

  // THE FOUR STEPS, AND THE ONLY LIST OF THEM. Dictated by Paul on 3 Sep and
  // rewritten whole. index.html and shoot.html both render this array, so the
  // numbers cannot drift between the two pages; there was a second, shorter
  // `steps` list for the front page that nothing had read in months, and it is
  // gone rather than left to disagree with this one.
  //
  // 10 TO 5, NOT 10 TO 4. Seven hours at fifteen minutes is twenty-eight slots,
  // which is the first number that makes the 25 on each ticket honest.
  howItWorks: [
    { n: '01', h: 'YOU BOOK A RAINBOW', p: 'Pick a package. Payment holds the slot; nothing is reserved before it.' },
    { n: '02', h: 'YOU PICK YOUR TIME', p: 'An email arrives with a link. Sessions run 10am to 5pm and there is a set number of them, so the earlier you pick the more there is to pick from.' },
    { n: '03', h: 'YOU COME IN EARLY', p: 'Fifteen minutes before your slot, to get your pet settled. Water everywhere, treats, walkers on hand so nobody holds a leash through their own sitting, and CBD treats for the ones who find a studio a lot. The room is calm on purpose.' },
    { n: '04', h: 'YOU CHOOSE', p: 'A week later a link arrives with the edited frames. Three digitals are yours either way. If you bought a print you choose which frame gets printed, and collect it at the studio.' },
  ],

  fulfilment: [
    { k: 'DIGITAL PORTRAITS', v: 'A secure download link within one week of your session.' },
    { k: 'PHYSICAL PRINTS', v: 'Allow two weeks for production after you have made your final selection.' },
    { k: 'DELIVERY', v: 'Local pickup only, at the Ravenswood studio. Contact the studio directly about shipping.' },
    { k: 'PAPER', v: 'Every print option is produced on high-quality archival paper, for gallery-grade results.' },
  ],

  // What to bring, and who the shoot actually suits. Straight from the listing
  // and worth keeping blunt — it manages expectations before anyone pays.
  suits: {
    lead: 'The shoot works best with chill dogs, or dogs that will stand still for a treat.',
    bring: ['Their favourite toy', 'Their favourite treat', 'A lead you can take off quickly'],
    rule: 'JUST FUR',
    ruleNote: 'No props, no outfits, no accessories, unless we have talked about it beforehand. The lighting is the costume. Anything else in frame is competing with it, and the dog always loses that fight.',
  },

  addons: [],

  party: [
    { k: 'COOKIES', v: 'Dad bakes them. For the dogs. He will tell you the recipe.' },
    { k: 'WALKERS', v: 'Two on hand, so nobody holds a leash through their own sitting.' },
    { k: 'CBD MEALS', v: 'For the ones who find a studio a lot. Owner says yes first.' },
    { k: 'NO APPOINTMENT', v: 'Show up inside the window. Sit down. You are next when you are next.' },
    { k: 'WATER, EVERYWHERE', v: 'Bowls at ankle height in every room.' },
  ],

  shelter: [
    { day: 'DAY ONE', who: 'DOGS', note: 'Twelve to twenty portraits. Leashed, one at a time, quiet room.' },
    { day: 'DAY TWO', who: 'CATS', note: 'Different day on purpose. Different smell in the room, calmer cats.' },
  ],

  shelterGets: [
    'Every portrait, free, forever, in web and print sizes',
    'A short clip per animal for the listing',
    'Crates, leashes, beds and blankets off the wishlist',
    'The same lighting the paying dogs got',
  ],

  wishlistItems: [
    'Wire crates, 36" and 42"', 'Slip leads, 6ft', 'Martingale collars, all sizes',
    'Elevated beds', 'Washable blankets', 'Stainless bowls',
    'Enrichment toys: Kong, snuffle mats', 'Puppy pads', 'Unscented laundry detergent',
  ],

  volunteers: [
    { role: 'PHOTOGRAPHER', need: 'Two per shelter day',
      p: 'You shoot alongside us on the shelter days, in the studio, on the set the paying animals get. Bring your own body and a 50mm if you have one; the lights, stands and backdrop are ours and we set them up with you the morning of.',
      ask: 'Comfortable with manual exposure and strobes. Portfolio not required, patience is.' },
    { role: 'HANDLER', need: 'Four to six per shelter day',
      p: 'Walk them in, hold a leash, keep one calm while the one before it finishes, get them back to their kennel. This is the job that decides whether the day works.',
      ask: 'No experience needed. The shelter briefs you on their animals before anyone touches one.' },
    { role: 'RUNNER', need: 'Two per shelter day',
      p: 'Water, towels, treats, the sign-in sheet, the thing somebody forgot. Unglamorous and the first thing we miss when nobody does it.',
      ask: 'A pair of shoes you do not mind ruining.' },
    { role: 'RETOUCHER', need: 'Remote, any week',
      p: 'Shelter galleries get the same treatment the paying ones do. Colour, crop, clean, out the door within a week of the shoot.',
      ask: 'Lightroom or Capture One. We send a preset and a reference set.' },
  ],

  sponsors: {
    lead: 'A tour needs a floor, a van and a light kit in five cities. Here is what a name gets on it.',
    tiers: [
      { name: 'CITY',     note: 'One city, one weekend. Logo on the wall, the wishlist and the prints.' },
      { name: 'SEASON',   note: 'Two cities. Everything in CITY, plus your product in every dog\'s bag.' },
      { name: 'THE TOUR', note: 'All five. Naming on the shelter days, which is the part that matters.' },
    ],
  },

  // DRAFT — the shop is shaped, not stocked. No fulfilment behind any of this.
  shop: [
    { name: 'THE ORB PRINT',   price: 45,  size: '18×18 archival', p: 'The gradient itself, printed square. Every pixel is one of the four brand colours.' },
    { name: 'YOUR DOG, FRAMED', price: 225, size: '12×16 framed',  p: 'Only orderable after a sitting. This is the same print as tier B, on its own.' },
    { name: 'THE TOUR TEE',    price: 34,  size: 'S–3XL',          p: 'Five cities on the back, each in its own colour. Reprinted when the sixth is announced, not before.' },
    { name: 'BANDANA',         price: 18,  size: 'One size, dog',  p: 'Four lights on white cotton. Washes badly on purpose. It is meant to look worn.' },
    { name: 'THE STICKER',     price: 5,   size: '3in',            p: 'Cheapest way to fund a portrait. Five dollars is roughly one shelter dog\'s file.' },
    { name: 'GIFT A SITTING',  price: 150, size: 'Any city',       p: 'Someone else\'s dog gets the room. Redeemable on any stop of the tour.' },
  ],

  // THE SHELTER DIRECTORY.
  //
  // Empty on purpose. This page sends people to real shelters, so inventing
  // entries that read as real is the one thing it must never do — a wrong
  // address on an adopt page sends somebody to the wrong building. Seed it from
  // a real source before this goes anywhere: `python3 build_shelters.py` pulls
  // it off the RescueGroups.org API (free, uncapped, non-profit) for every tour
  // and requested city, in exactly the row shape below. It needs an API key —
  // see HANDOFF.md. The rows it prints are real but UNVERIFIED; the page below
  // promises each one was checked with the shelter, so cut what you have not.
  //
  //   { name, city, state, area, lon, lat, url }
  //
  // `area` is the phone area code — it is what people actually know about their
  // own patch, and the search matches on it.
  shelters: [],

  // Shape-only rows so the map and the list can be seen working. Loaded ONLY
  // with ?demo=1, and the page shouts about it when they are.
  shelterSamples: [
    { name: 'SAMPLE · NORTH SIDE',  city: 'Chicago',     state: 'IL', area: '773', lon: -87.66, lat: 41.95 },
    { name: 'SAMPLE · SOUTH LOOP',  city: 'Chicago',     state: 'IL', area: '312', lon: -87.62, lat: 41.86 },
    { name: 'SAMPLE · KINGS COUNTY',city: 'Brooklyn',    state: 'NY', area: '718', lon: -73.94, lat: 40.68 },
    { name: 'SAMPLE · EASTSIDE',    city: 'Los Angeles', state: 'CA', area: '323', lon: -118.24, lat: 34.05 },
    { name: 'SAMPLE · SOUTH RIVER', city: 'Austin',      state: 'TX', area: '512', lon: -97.74, lat: 30.27 },
    { name: 'SAMPLE · PUGET',       city: 'Seattle',     state: 'WA', area: '206', lon: -122.33, lat: 47.61 },
    { name: 'SAMPLE · FRONT RANGE', city: 'Denver',      state: 'CO', area: '303', lon: -104.99, lat: 39.74 },
    { name: 'SAMPLE · RIVERBEND',   city: 'New Orleans', state: 'LA', area: '504', lon: -90.07, lat: 29.95 },
  ],

  // WHAT THE PHOTOGRAPHER SAYS, in the machine and in the reel.
  //
  // MOVED HERE OUT OF machine.js. It was three arrays inside a closure, which
  // was fine while the machine was the only thing that talked — then the reel
  // needed the same man saying the same things and the choice was a second copy
  // or this. Copy lives in content.js; that is what this file is for.
  greeter: {
    // FIFTY REAL NAMES, lifted out of the adoption data itself — every one of
    // them belongs to an actual animal in the pull: Karl Barx, Bonnie Raitt,
    // Betsy Ross, Boba Tea, Dumpling Squash. Nothing here is invented, which is
    // the whole joke: shelters name dogs like this. The ordinary ones are the
    // funniest. Somebody's dog is called Deborah. Somebody's is Poopy.
    names: [
      'Mark', 'Linda', 'Susan', 'Kevin', 'Deborah', 'Brian',
      'Karen', 'Gary', 'Sandra', 'Wayne', 'Dennis', 'Marcia',
      'Gerald', 'Patricia', 'Cheryl', 'Doug', 'Barbara', 'Ronald',
      'Janet', 'Poopy', 'Meatball', 'Chunk', 'Biscuit',
      'Karl Barx', 'Bonnie Raitt', 'Ava Gardner', 'Betsy Ross', 'Ceelo Green',
      'Tommy Pickles', 'Swiss Miss', 'Baby Spice', 'Boba Tea', 'Mr Bean',
      'Montgomery Ward', 'Funshine Bear', 'Bam Bam', 'Dumpling Squash', 'Poppy Purrsome',
      'Swamp Monster', 'Jessica Rabbit', 'Thomas Paine', 'Kenny Rogers', 'Won Ton',
      'Almond Joy', 'Cookie Dough', 'Mr. Bones', 'Ororo Munroe', 'Jasper Hale',
      'Bagel Bite', 'Melly Vanelly', 'Mama Maggie', 'Miss Kitty', 'Sun Ray',
      'Black Hole', 'Mount Everest', 'Goosie Gus', 'Milky Man', 'Cafe Au Lait',
      'Lady Moo', 'Diva Dark', 'Miss Paws', 'Bedrock Orange', 'Coco Miranda',
      'Octavia Wright', 'Deedra Rose', 'Connie Falco', 'La Nina', 'Buddy Green',
      'Sugar Sugar', 'Big Red', 'Jethro', 'Pippi', 'Elvis',
    ],

    // HOW HE TALKS. Warm, camp, and genuinely encouraging — a photographer who
    // is delighted by every animal that walks in and says so. The register is
    // the ballroom compliment rather than the pet-shop coo: GAG, serving, the
    // FACE, category is. Never at the animal's expense, and never the tired
    // ones — nothing here is a good boy who is a very good boy.
    //
    // AND HE DIRECTS, because he is running a shoot. "Look at the blue light"
    // is a real instruction with a real light behind it — there are four and he
    // names them. That is the line that makes him a photographer and not a mascot.
    lines: [
      'GAG! {n}!', '{n}, over here!', 'Obsessed with you, {n}.',
      '{n} \u2014 the FACE.', 'Serving, {n}. Serving.',
      'Look at the blue light, {n}!', 'Give me that chin, {n}.',
      '{n}, you are GIVING.', 'Yes {n}. Yes.', 'That\'s it, {n}. Hold it.',
      'Work, {n}. Work!', 'Stunning, {n}. Stunning.',
      'Thank you, {n}. Truly.', '{n}! Category is: rainbow.',
      'Oh {n}, that\'s devastating.', 'Nobody does it like you, {n}.',
    ],

    // AND HE DOES NOT ONLY SAY NAMES. A man running a booth all day welcomes
    // people, calls the lights, and reassures whoever has just been put on a
    // table under four of them. A third of the time he says one of these.
    asides: [
      'WELCOME TO YOUR PHOTO SHOOT!', 'Look at the blue light!',
      'Now the green one \u2014 there!', 'Chin up, eyes soft. Perfect.',
      'Four lights. Fifteen minutes.', 'Every rainbow gives one away.',
      'Everyone is beautiful under here.', 'No bad angles in this room.',
      'GAG!', 'Photographs get them adopted.',
      'One more \u2014 you\'re doing great.', 'Treats after. I promise.',
      'You were BORN for this.', 'Same lights for the shelter dogs.',
      'Take your time. We have all day.', 'Beautiful. Next!',
    ],

    // WHAT THE ANIMALS SAY. The reel gives every bark a bubble, and a bubble
    // needs a word in it. Barks only — the one being photographed is holding
    // still and the cat is a separate matter.
    barks: ['WOOF!', 'WOOF WOOF', 'BORK!', 'RUFF!', 'ARF!', 'YIP!', 'BARK!', 'HENLO'],
    meows: ['MRRP', 'MEOW', 'MRRRRP'],
  },

  // DRAFT — every line of this bio is a placeholder. Paul writes his own.
  // ── THE STORY. IT IS THE `#artist` SECTION AND THERE IS NO ABOUT PAGE. ───
  //
  // There was one for about an hour on 3 Sep 2026 — photographer.html locally,
  // /pages/rescue-rainbow on the shop — and Paul killed it the same afternoon:
  // ABOUT in the nav is an anchor down to `#artist` on the front page, and the
  // whole bio renders there. Do not rebuild the page; if this ever needs its
  // own URL again, the nav is the only thing that decides it.
  //
  // Paul, first person, dictated 3 Sep 2026 — the second, longer telling. An
  // earlier draft that same afternoon had the same events in three paragraphs;
  // this replaced it because he told the whole thing, including the part that
  // makes it make sense, which is the drama club.
  //
  //   THE FIRST LINE IS HIS AND IT STAYS. "I did not plan to become one of the
  //   world's best Black pet photographers, but here we are." He asked for the
  //   page to open on it. Do not soften it, do not hedge it, do not move it
  //   further down the page to be modest on his behalf.
  //
  //   THE DRAMA CLUB IS THE WHOLE POINT. Red for the evil queen, blue for cold,
  //   green for the happy forest — three lamps and a spotlight he was mostly
  //   not allowed to touch. It is where colour started meaning something, and
  //   it is what the rainbow rig is still doing. Cut anything else before this.
  //
  //   THE SHOW IS NAMED NOW: Chicago Fire, for NBC, about ten years ago. An
  //   earlier note here said not to name it — that was written when all he had
  //   said was "an NBC show". He named it himself, so the site does.
  //
  //   IT IS NOT A FUNDRAISER. "We're not a nonprofit, so I don't want to call
  //   this a fundraiser." That rule holds, but the sentence itself is off the
  //   page now: he says it warmly in his own words — "we give one away" — and a
  //   disclaimer next to that reads as flinching. No donation, no cause, no
  //   proceeds-to anywhere near this copy.
  //
  //   "SCOOPED UP" IS HIS. So is "here we are". Keep them.
  //
  // FIRST PERSON, singular for the photography and plural for the giving —
  // "I photographed a few of them", "we give one away". That is how he says it
  // and the switch is not an inconsistency to tidy up.
  photographer: {
    name: 'PAUL OCTAVIOUS',
    role: 'PHOTOGRAPHER · CHICAGO',
    lead: 'I did not plan to become one of the world\'s best Black pet photographers. But here we are.',
    bio: [
      'Hi. My name is Paul Octavious. I am a photographer, a designer, a multidisciplinary artist, and I work in Chicago. What I actually love is light — coloured strobes most of all, and best of all blended together into a rainbow.',
      'That started in high school. I was in drama club, on the crew backstage, learning to man the lights, although what they mostly let me touch was the spotlight. We had three colours and nothing else. Red was for when the evil queen came on stage. Blue was for when it was cold. Green was the happy forest. Colour and light meant something to me before I had any idea what I was looking at, and I carried it out of graphic design and into photography without ever really putting it down.',
      'About ten years ago I was on set photographing the actors on Chicago Fire, for NBC, and I was going to put my rainbow light on them. While I was waiting there were rescue dogs on set, so I photographed a few of those under the same light. They came out so well that I gave the pictures to the shelter. The shelter put them up on their website and those dogs were scooped up. They found their forever homes.',
      'So now I do it on purpose. Every so often — about once a year — I open the studio up. People come in for a pet portrait of their own, and we give one away to a shelter animal. Supplies too, and whatever else they are short of, but mostly photographs, because a photograph is the thing that gets an animal home quicker.',
      'And we are taking it around the country. Five cities to start and more if they will have us, carrying as many rainbows as we can get in the van. The lights come, the giveaway comes, and every stop leaves a shelter with pictures it did not have the week before.',
    ],
    // ** ARCHIVED — NOT ON THE PAGE. ** Paul cut the facts table on 3 Sep 2026,
    // the same hour it went up: the about page is the story and the pictures,
    // and a spec table under a piece of writing turns it into a listing. Kept
    // whole and rendered nowhere, the way `why` and `room` are. Wiring it back
    // in is a div and two lines of JS. `{alumni}` substitutes alumni.length.
    facts: [
      { k: 'BASED', v: 'Chicago' },
      { k: 'THE STUDIO', v: 'Ravenswood' },
      { k: 'THE MODEL', v: 'Buy one, give one' },
      { k: 'PORTRAITS SO FAR', v: '{alumni} dogs' },
    ],
  },
};

/* ---- chrome.js ---- */
// Header and footer, injected on every page from content.js. One nav, one set
// of contact details, one place to change them.
//
//   <body data-page="tour">   picks out the current nav item
//   <body data-nofooter>      skip the footer — a full-bleed page is a flex
//                             column, and a footer in it eats the height the
//                             canvas was supposed to get
(function(){
'use strict';
const C = window.CONTENT, M = C.meta;

// THE WORDMARK. The orb replaces one letter O, per brand-bible/logo-seven —
// there it is the O in RAINBOWS, here the O in PHOTO. Built from meta.orbLetter
// so the name and the swapped letter stay in one place and cannot drift apart.
// Returns the mark as an array of per-word HTML, because the caller often needs
// to wrap each word — and splitting the finished string on spaces tears the
// orb's own tag in half, which is exactly what happened the first time.
// TEXT HELPERS, here rather than in tourlist.js because chrome.js is the one
// script every page loads — including the footer's own city count, which is the
// most-repeated sentence on the site. RRTour delegates to these.
//
// Small counts are spelled out because the display type is set in words: "10
// maybes." in a 92px headline reads as a receipt.
window.RRText = {
  word: function(n){
    const W = ['no','one','two','three','four','five','six','seven','eight','nine','ten',
               'eleven','twelve','thirteen','fourteen','fifteen','sixteen','seventeen',
               'eighteen','nineteen','twenty'];
    return W[n] || String(n);
  },
  Word: function(n){ const w = window.RRText.word(n); return w[0].toUpperCase() + w.slice(1); },
  // Days of the month, spelled out, for prose. "Cats on the nineteenth" is a
  // sentence; "Cats on the 26th" is a table cell that wandered into one.
  ordinal: function(n){
    const O = ['','first','second','third','fourth','fifth','sixth','seventh','eighth','ninth','tenth',
      'eleventh','twelfth','thirteenth','fourteenth','fifteenth','sixteenth','seventeenth','eighteenth',
      'nineteenth','twentieth','twenty-first','twenty-second','twenty-third','twenty-fourth',
      'twenty-fifth','twenty-sixth','twenty-seventh','twenty-eighth','twenty-ninth','thirtieth',
      'thirty-first'];
    return O[n] || String(n);
  },
  // once / twice / three times. English stops having a word for it at two,
  // which is why this is a lookup and not a suffix.
  times: function(n){
    return n === 1 ? 'once' : n === 2 ? 'twice' : window.RRText.word(n) + ' times';
  },
  // City names are stored in caps. A headline sets them in sentence case, and
  // LOS ANGELES has to come back "Los Angeles" not "Los angeles" — so it is per
  // word, not per string.
  title: function(str){
    return str.toLowerCase().replace(/(^|[\s-])(\w)/g, function(m, a, b){ return a + b.toUpperCase(); });
  },
};

window.wordmarkWords = function(){
  const spec = M.orbLetter;
  return M.name.split(' ').map(function(w){
    if (!spec || w !== spec.word) return w;
    return w.slice(0, spec.index) + '<i class="orb-o"></i>' + w.slice(spec.index + 1);
  });
};
window.wordmark = function(){ return window.wordmarkWords().join(' '); };
// THE CHROME IS RELATIVE BY DEFAULT AND OVERRIDABLE BY A HOST. The local site
// links to sibling .html files; the Shopify page cannot, because none of them
// exist there. A host sets window.RR_NAV / RR_HOME / RR_CTA before this script
// runs and gets its own links. Unset, nothing changes.
const NAV = window.RR_NAV || C.nav;
const HOME = window.RR_HOME || 'index.html';
const CTA = window.RR_CTA || 'tour.html#tickets';   // kept for hosts; no header button uses it
const page = document.body.dataset.page || '';
// WHICH ITEM IS THE CURRENT ONE. Locally the nav points at sibling .html files
// and data-page is the filename, so the first test is the whole answer. On a
// shop the same nav points at /pages/<handle> and rr.liquid sets data-page to
// that handle — so the second test is the same comparison in Shopify's shape.
// Without it no store page ever marked itself, which is why every ported page
// so far has had a nav with nothing underlined in it.
const cur = function(href){
  // AN ITEM WITH A FRAGMENT NEVER MARKS ITSELF. On the shop, DATES and THE
  // STUDIO are both /pages/rainbows with different hashes, so comparing the
  // path alone underlined two items at once on the front page. A jump inside a
  // page is not a page; two marks are worse than none.
  if (href.indexOf('#') !== -1) return '';
  const h = href.replace(/\/$/, '');
  const here = h === page + '.html' || (page && h.endsWith('/pages/' + page));
  return here ? ' aria-current="page"' : '';
};

const header =
  '<header class="bar"><div class="wrap">' +
    '<a class="lock" href="' + HOME + '">' +
      '<span class="orb m"></span>' +
      '<span><b>' + window.wordmark() + '</b><em>' + M.tagline + '</em></span>' +
    '</a>' +
    '<nav>' + NAV.map(n => '<a href="' + n.href + '"' + cur(n.href) + '>' + n.label + '</a>').join('') + '</nav>' +
    // NO BUTTON IN THE BAR. It was BOOK A RAINBOW (before that ADOPT A SPOT, and
    // for an hour `+ 🌈`). Paul took it off the header on 6 Sep 2026 and put it
    // beside the slogan instead, as BOOK A ’BOW — see #thesis in index.html and
    // page.tickets.liquid. RR_CTA is still read above for any host that wants a
    // header button back; nothing here uses it now.
  '</div></header>';

const footer =
  '<footer><div class="ribbon bottom rbbar"></div><div class="wrap" style="padding-top:44px">' +
    '<div class="fwrap">' +
      '<div class="col">' +
        '<span class="orb s"></span>' +
        '<div style="font-size:17px;font-weight:700;letter-spacing:-.03em;color:var(--ink);margin-top:12px">' +
          window.wordmark() + '</div>' +
        '<div style="margin-top:6px">' + M.tagline + '</div>' +
        '<div style="margin-top:2px;font-size:11px;letter-spacing:.18em">' + M.descriptor + '</div>' +
        // Counted off the route, not typed. The footer is on every page, so a
        // hard-coded "four more cities" here is the single most-repeated
        // sentence on the site and the easiest one to forget.
        '<div style="margin-top:10px">' + M.home + ' · and ' + window.RRText.word(C.cities.length - 1) +
          ' more cities</div>' +
      '</div>' +
      '<div class="col"><h4>PAGES</h4>' +
        NAV.map(n => '<a href="' + n.href + '">' + n.label + '</a>').join('') +
      '</div>' +
      // GET IN TOUCH IS THE EMAIL AND NOTHING ELSE. Paul, 6 Sep 2026: the
      // Instagram handle came off (it was never verified — see HANDOFF) and so
      // did the whole THE LIGHTS column (RED · BLUE · GREEN · YELLOW / Nothing
      // added afterwards.) — the rig is not for publishing, and the footer was
      // the last place on the site that named it. meta.instagram is still in
      // content.js; nothing reads it.
      '<div class="col"><h4>GET IN TOUCH</h4>' +
        '<a href="mailto:' + M.email + '">' + M.email + '</a>' +
      '</div>' +
    '</div>' +
  '</div></footer>';

document.body.insertAdjacentHTML('afterbegin', header);
// The top ribbon sits directly under the chrome on every page.
document.querySelector('header.bar')
  .insertAdjacentHTML('afterend', '<div class="ribbon top"></div>');
if (!document.body.hasAttribute('data-nofooter')) document.body.insertAdjacentHTML('beforeend', footer);
})();

/* ---- tourlist.js ---- */
// THE TOUR LIST — one place that turns content.js → tour.dates into rows and
// stubs, because the front page and the tour page both show it and the old
// version of this had the row-building copy-pasted into two files.
//
//   RRTour.rows(el, opts)   the date list.  opts: { limit, requested, actions }
//   RRTour.stubs(el)        the announced days, drawn as tickets
//   RRTour.counts()         { live, unannounced, requested } for headline copy
//
// Every row's action is a mailto. There is no server behind this site, and a
// button that pretends to take money when nothing can is worse than one that
// admits it opens your mail app.
(function(){
'use strict';
const C = window.CONTENT, M = C.meta;

const MONTHS = ['JAN','FEB','MAR','APR','MAY','JUN','JUL','AUG','SEP','OCT','NOV','DEC'];
const DAYS   = ['SUN','MON','TUE','WED','THU','FRI','SAT'];
const BEAST  = { CATS:'cat', DOGS:'dog' };
const MONTHS_LONG = ['January','February','March','April','May','June','July',
                     'August','September','October','November','December'];

// PARSE THE DATE AS LOCAL, NOT UTC. `new Date('2026-09-19')` is midnight UTC,
// which is the 18th anywhere west of Greenwich — so a Chicago reader sees a
// Friday for a Saturday event and a countdown one day short. Splitting the
// string and using the numeric constructor is the fix, and it is the reason
// dates in content.js are plain ISO strings rather than Date objects.
function parse(iso){
  if (!iso) return null;
  const p = iso.split('-');
  return new Date(+p[0], +p[1] - 1, +p[2]);
}
function midnight(){ const n = new Date(); return new Date(n.getFullYear(), n.getMonth(), n.getDate()); }
// Whole days from today. Negative is past, 0 is today.
function daysAway(iso){
  const d = parse(iso); if (!d) return null;
  return Math.round((d - midnight()) / 86400000);
}

// The status a row actually renders with, which is not always the status
// written in content.js: a date that has been and gone is PAST no matter what
// it says, so the list ages correctly without anybody editing it.
function stateOf(d){
  const n = daysAway(d.date);
  if (n !== null && n < 0) return 'past';
  return d.status;
}

// WHICH BUTTON, AND WHY. The label is the promise, so it has to match what the
// row can actually do. Nothing is buyable until `tiers` has a price — see
// content.js — so `onsale` is built and unused rather than claimed.
// THE BUY ACTION IS A MARK, NOT A SENTENCE. `+ 🌈` — add a rainbow. Every
// other action here still uses words, because TELL ME WHEN and ASK FOR IT are
// promises about the future and a glyph cannot make one. Only the row you can
// act on right now gets the mark.
const BUY = '+ \uD83C\uDF08';
const ACTIONS = {
  onsale:      { label: BUY, ghost: false },
  announced:   { label: 'TELL ME WHEN', ghost: true  },
  // A DATED CITY THAT IS NOT FOR SALE YET goes to the sign-up, not to a
  // mailto: the button carries `data-notify`, and the handler at the foot of
  // this file scrolls to #notify and puts the cursor in the email field
  // wherever that form is on the page; on a page without one it falls back
  // to the mailto in the href.
  coming:      { label: 'NOTIFY ME',    ghost: true, notify: true },
  unannounced: { label: 'NOTIFY ME',    ghost: true  },
  requested:   { label: 'ASK FOR IT',   ghost: true  },
  past:        null,
};

// Once a price exists, an announced row stops offering to tell you later and
// starts pointing at the packages — otherwise the list says TELL ME WHEN beside
// a stub that says ADOPT A SPOT, which is the site disagreeing with itself.
function announcedAction(){
  return C.tiers.some(t => t.price != null)
    ? { label: BUY, ghost: false, href: 'shoot.html' }
    : ACTIONS.announced;
}

// WHAT THIS BROWSER HAS ALREADY ASKED FOR. The only state on this site that
// belongs to the reader. It is local and it is honest — it says "you asked",
// never "247 people asked", because nothing here can count that.
const KEY = 'ppb.asked';
function asked(){
  try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch(e){ return []; }
}
function remember(id){
  try {
    const a = asked();
    if (a.indexOf(id) < 0){ a.push(id); localStorage.setItem(KEY, JSON.stringify(a)); }
  } catch(e){ /* private mode: the mailto still opened, which is the part that matters */ }
}
const idOf = d => d.city + (d.date ? '|' + d.date : '');

// The colour a row wears. Route cities carry their own sample of the orb's
// gradient; a requested city has none, and that absence is the whole visual
// difference between "we are going" and "somebody wants us to".
function colourOf(city){ return C.cities.find(c => c.city === city) || null; }

function mailto(d, st){
  const where = d.city + (d.date ? ' — ' + fmtLong(d.date) : '');
  const subj = st === 'onsale'      ? 'Tickets — ' + where
             : st === 'requested'   ? 'Bring Rescue Rainbow to ' + d.city
             :                        'Tell me when — ' + where;
  const body = (st === 'announced' || st === 'coming')
    ? 'Let me know the moment tickets go on sale for ' + where + '.\n\nName:\n'
    : st === 'requested'
    ? 'I want a stop in ' + d.city + '.\n\nName:\nEmail:\nI could help with:\n'
    : 'Let me know when ' + d.city + ' gets a date.\n\nName:\n';
  return 'mailto:' + M.email + '?subject=' + encodeURIComponent(subj) +
         '&body=' + encodeURIComponent(body);
}

function fmtLong(iso){
  const d = parse(iso);
  return DAYS[d.getDay()] + ' ' + d.getDate() + ' ' + MONTHS[d.getMonth()] + ' ' + d.getFullYear();
}

// The requested cities are rows too, in the same list. Keeping them in a
// separate block of chips let people read the route as five cities; in the list
// they read as what they are — eleven places, five of which we have committed
// to. That is a more honest picture and a longer, better-looking tour list.
function requestedRows(){
  return (C.requested || []).map(city => ({
    city: city, state: '', venue: null, date: null, time: null,
    who: '', status: 'requested', note: '',
  }));
}

function rowHTML(d){
  const st = stateOf(d), col = colourOf(d.city);
  const a = st === 'announced' ? announcedAction() : ACTIONS[st];
  const n = daysAway(d.date);
  const dt = parse(d.date);
  const isAsked = asked().indexOf(idOf(d)) >= 0;

  const swatch = col
    ? '<i style="--a:' + col.near[0] + ';--b:' + col.near[1] + ';--c:' + col.near[2] +
      ';--spin:' + col.spin + '"></i>'
    : '';

  const when = dt
    ? '<div class="when"><em>' + DAYS[dt.getDay()] + ' ' + dt.getDate() + '</em>' +
      MONTHS[dt.getMonth()] + ' ' + dt.getFullYear() + '</div>'
    : '<div class="when tba">TBA</div>';

  const venue = d.venue ? d.venue
    : st === 'requested' ? 'REQUESTED BY READERS'
    : 'VENUE TO BE CONFIRMED';

  const label = st === 'past' ? 'PLAYED'
    : st === 'onsale' ? 'ON SALE'
    // NO PRICE IN THE LIST. Paul's call — a row says when and where, and the
    // money belongs on the page you land on when you press BOOK.
    : st === 'announced' ? 'TICKETS SOON'
    : st === 'coming' ? 'DATE SET'
    : st === 'unannounced' ? 'NO DATE YET'
    : 'REQUESTED';

  const href = a && a.href ? a.href : (st === 'onsale' ? 'shoot.html' : mailto(d, st));
  const act = !a ? ''
    : '<a class="btn' + (a.ghost ? ' ghost' : '') + '" data-ask="' + idOf(d) + '"' +
      (a.notify ? ' data-notify="1"' : '') + ' href="' + href + '">' +
      (isAsked && !a.href ? 'ASKED' : a.label) + '</a>';

  // The species in the same lit gradient the ticket headline wears — the one
  // device that makes the list and the cards read as one system. A day that is
  // both gets the default rotation; a requested city has no species at all.
  const kind = BEAST[d.who] || '';
  // ONLY A DAY WITH A DATE NAMES ITS SPECIES. Paul's call: CATS + DOGS repeated
  // under Detroit, Atlanta and Nashville was three guesses dressed as facts —
  // nobody has decided which animals those cities get. A booked day still says.
  const who = (d.who && d.date)
    ? '<span class="who lit ' + kind + '">' + d.who + '</span>' : '';

  return '<div class="trow ' + st + (isAsked ? ' asked' : '') + '">' +
    '<div class="swatch">' + swatch + '</div>' +
    when +
    '<div class="place"><b>' + d.city +
      (d.state ? '<i>' + d.state + '</i>' : '') + '</b>' +
      (who ? '<span class="whowrap">' + who + '</span>' : '') +
      '<span class="venue">' + venue + '</span></div>' +
    '<div class="act"><div class="stat"><i>' + label + '</i></div>' + act + '</div>' +
  '</div>';
}

// WHERE ADOPT A SPOT GOES. Locally that is shoot.html, which explains the
// packages. A host that actually sells the day — the Shopify page — sets
// window.RR_LINKS keyed 'CITY WHO' (or just 'WHO') and the stub points at the
// real product instead. No RR_LINKS, no change: the site behaves as it always did.
function ticketHref(d){
  // THREE PLACES TO LOOK, MOST SPECIFIC FIRST. A Shopify host sets RR_LINKS from
  // its own product handles and wins; otherwise the URLs written in
  // content.js -> tour.tickets take it to the real listing; shoot.html is the
  // last resort, and now only for a date with no product behind it at all.
  const map = window.RR_LINKS || (C.tour && C.tour.tickets) || {};
  return map[d.city + ' ' + d.who] || map[d.who] || 'shoot.html';
}

function stubHTML(d){
  const dt = parse(d.date), T = C.ticket, B = C.beneficiary;
  // FROM $99 — the lowest price actually set, so the line stays true as the
  // other tiers land. `priced` is false only while every tier is null.
  const prices = C.tiers.map(t => t.price).filter(p => p != null);
  const priced = prices.length > 0;
  const from = priced ? '$' + Math.min.apply(null, prices) : '';
  // A PRICE IS NOT A CHECKOUT. The booking link is still a mailto, so the card
  // says so — and says it on a line that clears itself the day it is not.
  const live = (M.booking || '').indexOf('mailto:') !== 0;
  const L = T.lights[d.who] || { light: 'var(--paper)', type: 'var(--ink)' };
  const kind = BEAST[d.who] || '';

  // The photograph for this species, looked up in `photos` by name so the path
  // lives in exactly one place. Falls back to the gradient animal if the file
  // is not in the list — an empty frame is worse than no frame.
  const heroName = (T.hero || {})[d.who];
  const hero = heroName && (C.photos || []).filter(p => p.name === heroName)[0];

  // THE CITY SITS ABOVE THE TICKET, NOT ON IT — flush left, in display type,
  // like the city heading over a listing rather than a line of the ticket's own
  // copy. The card still names it, in the spec line beside the venue, so a
  // ticket screenshotted on its own is not orphaned from its city.
  return '<article class="stub ' + kind + '" style="--tbg:' + L.light + ';--tc:' + L.type + '">' +
    // THE STUB, AT THE TOP: the animal and what it admits. Kept exactly as it
    // was — it is the one part of this card that was already right.
    // THE SPECIES SITS BESIDE THE ANIMAL NOW, not below the promoter line —
    // Paul's call, and the two things that name the day are together at last.
    // `.endcopy` exists so fitHeadlines has a box to measure: it fits the word
    // to its PARENT, and the parent is now the column beside the animal rather
    // than the whole card.
    '<div class="end">' +
      (kind ? '<span class="beast ' + kind + '"></span>' : '') +
      '<div class="endcopy">' +
        '<span class="admit">' + (T.admits[d.who] || T.admitsFallback) + '</span>' +
        '<h3 class="lit ' + kind + '">' + d.who + '</h3>' +
      '</div>' +
    '</div>' +
    '<div class="tear"></div>' +
    '<div class="body">' +

      // The promoter block, flush to the same left edge as everything below it.
      // IT NAMED THE SHELTER; IT NOW NAMES THE DEAL. "BENEFITING EVANSTON ANIMAL
      // SHELTER" was true and told a buyer nothing about what they were doing.
      // The line is the same one the tickets, the front page and the donate
      // page all carry now, so the stub says what everything else says.
      '<p class="by"><b>' + M.parent + '</b>EVERY RAINBOW PURCHASED GIVES A RAINBOW TO A LOCAL SHELTER PET</p>' +

      // THE DATE IS TWO LINES, and that is the only reason it can be this big.
      // As one string "SAT 19 SEP 2026" runs out of card at about 36px; broken
      // after the day number it doubles, and the day number leads the line.
      // WHAT YOU ARE ACTUALLY BUYING, directly under the word it explains. A
      // stranger reading CATS at four hundred point does not know whether this
      // is a show, a shelter or a shop; two words fix that, and they only work
      // in this position — under the date they read as an afterthought.
      '<p class="what">' + T.what + '</p>' +
      '<p class="when">' + DAYS[dt.getDay()] + ' ' + dt.getDate() + '<br>' +
        MONTHS[dt.getMonth()] + ' ' + dt.getFullYear() + '</p>' +
      // Two mono lines, not one: where-and-when is a different question from
      // what-you-get, and running them together as one long dot-separated
      // string made the reader parse a venue and a slot length as the same
      // kind of fact.
      // A DATED ROW CAN HAVE NO ROOM YET (Detroit, from 6 Sep 2026) — the
      // card above says VENUE TO BE CONFIRMED for that; the stub says the
      // same rather than printing "null".
      '<p class="inc">' + (d.venue || 'VENUE TO BE CONFIRMED') + ', ' + d.city + ' ' + d.state + ' · ' +
        (d.time || 'TIME TBA') + '</p>' +
      '<p class="inc"><b>' + T.includesLabel + '</b>' + T.includes.join(' · ') + '</p>' +
      // NO PRICE ON THE TICKET. It was a ruled FROM $99 row here and Paul moved
      // it: a ticket says what the thing is and when, and the money belongs on
      // the page you land on when you press ADOPT A SPOT. THE SHOOT carries it,
      // as do the tour-list rows. `from` is still computed above and one line
      // brings the row back.
      '<p class="no">' +
        (priced ? (live ? '' : T.notLive) : 'SPOTS NOT ON SALE YET — NO PRICE IS SET') +
      '</p>' +
      // BACK AT THE BOTTOM, AND IT SAYS ADOPT A SPOT AGAIN. Both were tried the
      // other way on 31 Aug and both came back: a ticket reads down — animal,
      // species, date, what you get — and the thing you press is the tear-off
      // strip at the end of that. It keeps the four lights it gained there.
      '<p class="go"><a class="btn big" href="' + ticketHref(d) + '"' +
        ' aria-label="Adopt a spot"><span aria-hidden="true">' + BUY + '</span></a></p>' +

    '</div>' +
  '</article>';
}

// FIT THE SPECIES TO THE CARD, INK EDGE TO INK EDGE.
//
// Paul: "dogs has to go edge to edge", and "rescue rainbows … aren't lined up
// with dogs". Both are the same problem, and it is not a bug — it is what type
// does. Every glyph carries a side bearing, a sliver of blank inside its own
// advance width. At 34px the R of RESCUE RAINBOWS carries about 2px of it; at
// 150px the D of DOGS carries ten times that. Set both flush to the same CSS
// left edge and the big word sits visibly indented under the small one, because
// the thing your eye lines up is the INK, and only one of them was measured on
// its ink.
//
// So this measures the ink and not the box. Canvas `measureText` reports
// actualBoundingBoxLeft/Right — the real painted extents — which gives both the
// exact ink width to scale to AND the left bearing to pull back out with a
// negative margin. The result is a word whose painted edges touch the column on
// both sides and whose left edge agrees with every line above and below it.
//
// The relationship stays linear (letter-spacing is in `em`), so measuring once
// at 100px and multiplying is exact rather than iterative.
const FITC = document.createElement('canvas').getContext('2d');
const FIT_HAS_LS = FITC && ('letterSpacing' in FITC);
const FIT_REF = 100;

function inkOf(text, font, lsPx){
  FITC.font = font;
  if (FIT_HAS_LS) FITC.letterSpacing = lsPx + 'px';
  const m = FITC.measureText(text);
  // actualBoundingBoxLeft is positive when ink extends LEFT of the origin; for
  // left-set Latin caps it is negative, and its negation is the left bearing.
  let width = m.actualBoundingBoxLeft + m.actualBoundingBoxRight;
  // Older engines have no canvas letter-spacing. Spacing sits BETWEEN glyphs as
  // far as ink is concerned, so n-1 gaps, never n.
  if (!FIT_HAS_LS && text.length > 1) width += (text.length - 1) * lsPx;
  return { width: width, bearing: -m.actualBoundingBoxLeft };
}

function fitHeadlines(root){
  const hs = (root || document).querySelectorAll('.stub h3');
  for (let i = 0; i < hs.length; i++){
    const h = hs[i], body = h.parentElement;
    const bs = getComputedStyle(body);
    const avail = body.clientWidth - parseFloat(bs.paddingLeft) - parseFloat(bs.paddingRight);
    if (!(avail > 0)) continue;

    const cs = getComputedStyle(h);
    const ls = cs.letterSpacing === 'normal' ? 0
      : parseFloat(cs.letterSpacing) / parseFloat(cs.fontSize);
    const font = cs.fontStyle + ' ' + cs.fontWeight + ' ' + FIT_REF + 'px ' + cs.fontFamily;

    const ink = inkOf(h.textContent, font, ls * FIT_REF);
    if (!(ink.width > 0)) continue;

    const scale = avail / ink.width;
    h.style.fontSize = (FIT_REF * scale) + 'px';
    h.style.marginLeft = (-ink.bearing * scale) + 'px';
    // The CSS max-width is the no-JS fallback. Left on, it would clamp the
    // BACKGROUND box of a word now deliberately wider than its column — and a
    // clamped background box is exactly what clips the final S.
    h.style.maxWidth = 'none';
  }
}

// Refit when the cards change width. Guarded on the width actually changing:
// setting a font-size changes the card's HEIGHT, and an unguarded observer
// would see its own effect and run forever.
function watchHeadlines(root){
  if (typeof ResizeObserver !== 'function') return;
  // OBSERVE EACH CARD, NOT THE CONTAINER. In the bento the tickets go from two
  // columns to one at a breakpoint the container never notices — its own width
  // is unchanged, so a container-level observer would never fire and the
  // headline would stay fitted to half a card it no longer occupies.
  const last = new WeakMap();
  const ro = new ResizeObserver(function(entries){
    let changed = false;
    entries.forEach(function(e){
      const w = Math.round(e.contentRect.width);
      if (last.get(e.target) !== w){ last.set(e.target, w); changed = true; }
    });
    // Guarded on the WIDTH actually changing: setting a font-size changes each
    // card's HEIGHT, and an unguarded observer would see its own effect and
    // run for ever.
    if (changed) fitHeadlines(root);
  });
  root.querySelectorAll('.stub').forEach(function(s){ ro.observe(s); });
}

// One delegated listener for the whole page. The mailto still fires — this only
// records that it did, and repaints the button so the reader can see the site
// heard them.
function wire(root){
  root.addEventListener('click', function(e){
    const a = e.target.closest('[data-ask]');
    if (!a || a.getAttribute('href').indexOf('mailto:') !== 0) return;
    remember(a.getAttribute('data-ask'));
    a.textContent = 'ASKED';
    const row = a.closest('.trow'); if (row) row.classList.add('asked');
  });
}

// THE BARS under COMING TO A CITY NEAR YOU (7 Sep 2026). One slim row per
// city that is on the route but not for sale — its days, in the species'
// lights, and NOTIFY ME on the right into the sign-up. Shared here so the
// local page and the shop's draw the same thing; the section that calls it
// used to draw drifting colour chips and a "no dates yet" note that stopped
// being true the day every city got a date.
function comingBars(cities){
  // IN DATE ORDER, like the list above it — not in the order the cities were
  // typed into the file.
  const firstDate = c => (C.tour.dates.filter(d => d.city === c && d.date)
    .map(d => d.date).sort()[0]) || '9999';
  return cities.slice().sort((a, b) => firstDate(a) < firstDate(b) ? -1 : firstDate(a) > firstDate(b) ? 1 : 0)
  .map(function(city){
    const days = C.tour.dates.filter(d => d.city === city && d.date)
      .sort((a, b) => a.date < b.date ? -1 : a.date > b.date ? 1 : 0);
    const state = (C.cities || []).filter(c => c.city === city)[0];
    const st = state ? state.state : '';
    const when = days.length
      ? days.map(function(d){
          const dt = parse(d.date);
          return '<span class="who lit ' + (BEAST[d.who] || '') + '">' + d.who + '</span> ' +
            DAYS[dt.getDay()] + ' ' + dt.getDate() + ' ' + MONTHS[dt.getMonth()];
        }).join('<i class="dot">·</i>')
      : 'NO DATE YET';
    const first = days[0] || {city: city, state: st, venue: null, date: null, who: '', status: 'unannounced'};
    return '<div class="pbar">' +
      '<b>' + city + (st ? '<i>' + st + '</i>' : '') + '</b>' +
      '<span class="pbar-days">' + when + '</span>' +
      '<a class="btn ghost" data-notify="1" href="' + mailto(first, days.length ? 'coming' : 'unannounced') + '">NOTIFY ME</a>' +
    '</div>';
  }).join('');
}

// NOTIFY ME GOES TO THE FORM. Any button carrying data-notify scrolls to
// #notify and puts the cursor in the email field; on a page with no form the
// href (a mailto) does what it always did.
document.addEventListener('click', function(ev){
  const a = ev.target.closest && ev.target.closest('a[data-notify]');
  if (!a) return;
  const form = document.getElementById('notify');
  if (!form) return;
  ev.preventDefault();
  form.scrollIntoView({behavior: 'smooth', block: 'start'});
  const email = document.getElementById('nEmail');
  if (email) setTimeout(function(){ email.focus({preventScroll: true}); }, 450);
});

// A LITTLE BOX THAT SAYS RECEIVED (7 Sep 2026, Paul: "if they're subscribing
// to get notified, can we just put up a message that says received, you'll
// hear from us soon — just a little box"). Fixed at the foot of the screen so
// it is seen wherever the page reloaded to (the shop's form comes back at the
// top of the page); it goes on its own after a while, or on a click. The copy
// is `meta.received` in content.js; a known city gets the longer line.
function received(city){
  const R = (C.meta && C.meta.received) || {};
  const head = R.head || 'Received.';
  const line = (city && R.lineCity) ? R.lineCity.replace('{city}', city)
    : (R.line || 'You\u2019ll hear from us soon.');
  const old = document.querySelector('.received'); if (old) old.remove();
  const box = document.createElement('div');
  box.className = 'received';
  box.setAttribute('role', 'status'); box.setAttribute('aria-live', 'polite');
  const b = document.createElement('b'); b.textContent = head;
  const sp = document.createElement('span'); sp.textContent = line;
  box.appendChild(b); box.appendChild(sp);
  document.body.appendChild(box);
  // A reflow and a beat, so the transition has a "from" to leave. Not
  // requestAnimationFrame: a throttled or hidden tab can hold that back
  // indefinitely, and a box that never arrives is worse than one that snaps.
  void box.offsetWidth;
  setTimeout(function(){ box.classList.add('in'); }, 30);
  const timer = setTimeout(hide, 9000);
  function hide(){
    clearTimeout(timer); box.classList.remove('in');
    setTimeout(function(){ if (box.parentNode) box.parentNode.removeChild(box); }, 450);
  }
  box.addEventListener('click', hide);
  return box;
}

window.RRTour = {
  received: received,
  comingBars: comingBars,
  live: function(){ return C.tour.dates.filter(d => {
    const s = stateOf(d); return s === 'onsale' || s === 'announced'; }); },

  counts: function(){
    const ds = C.tour.dates;
    return {
      live:        ds.filter(d => { const s = stateOf(d); return s === 'onsale' || s === 'announced'; }).length,
      unannounced: ds.filter(d => stateOf(d) === 'unannounced').length,
      coming:      ds.filter(d => stateOf(d) === 'coming').length,
      requested:   (C.requested || []).length,
      cities:      C.cities.length,
    };
  },

  rows: function(el, opts){
    opts = opts || {};
    let ds = opts.live ? window.RRTour.live() : C.tour.dates.slice();
    if (opts.requested) ds = ds.concat(requestedRows());
    if (opts.limit) ds = ds.slice(0, opts.limit);
    el.innerHTML = ds.map(rowHTML).join('');
    wire(el);
  },

  stubs: function(el){
    const ds = window.RRTour.live();
    // GROUPED BY CITY, ONE HEADING FOR THE SET. Every ticket used to carry its
    // own CHICAGO above it, which meant two Chicago dates said CHICAGO twice in
    // a column. Side by side under one heading they read as what they are: two
    // days in the same city.
    //
    // JUST THE CITY, no state. It read CHICAGO IL, then CHICAGO, ILLINOIS, and
    // Paul cut it — at this size the city is the whole heading and the state is
    // a smaller second fact competing with it. The list rows still carry it,
    // where a column wants one.
    const groups = [];
    ds.forEach(function(d){
      let g = groups.filter(x => x.city === d.city)[0];
      if (!g) groups.push(g = { city: d.city, dates: [] });
      g.dates.push(d);
    });
    // THE DATES RIDE WITH THE CITY. The heading said CHICAGO and the reader had
    // to go into a ticket to find out when — so the days come up to sit beside
    // the name, one month and both days: CHICAGO SEP 26 + 27. Built from
    // the same dates the tickets below are, so it cannot disagree with them.
    const MON = ['JAN','FEB','MAR','APR','MAY','JUN','JUL','AUG','SEP','OCT','NOV','DEC'];
    function when(dates){
      const parts = dates.map(d => String(d.date || '').split('-')).filter(p => p.length === 3);
      if (!parts.length) return '';
      const byMonth = [];
      parts.forEach(function(p){
        const m = MON[(+p[1]) - 1];
        let g = byMonth.filter(x => x.m === m)[0];
        if (!g) byMonth.push(g = { m: m, d: [] });
        g.d.push(+p[2]);
      });
      return byMonth.map(g => g.m + ' ' + g.d.join(' + ')).join('  ');
    }
    el.innerHTML = groups.map(function(g){
      const w = when(g.dates);
      return '<section class="tk"><h2 class="tkcity">' + g.city +
        (w ? '<span class="tkwhen">' + w + '</span>' : '') + '</h2>' +
        '<div class="bento">' + g.dates.map(stubHTML).join('') + '</div></section>';
    }).join('');
    wire(el);
    fitHeadlines(el);
    watchHeadlines(el);
    // Helvetica is a system face so there is nothing to download, but a client
    // that substitutes while it decides would measure the wrong metrics.
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function(){ fitHeadlines(el); });
  },

  // Spelled-out counts and title case live in chrome.js as RRText, because the
  // footer needs them and chrome.js is the only script every page loads. These
  // delegate so callers on the tour pages read as one API.
  //
  // EVERY HEADLINE THAT CARRIES A COUNT BUILDS IT FROM THE DATE LIST rather
  // than stating it — the old page said "Five cities to start" in markup, which
  // is a sentence that quietly goes wrong the day a sixth is added and nobody
  // remembers where it was written.
  word: function(n){ return window.RRText.word(n); },
  Word: function(n){ return window.RRText.Word(n); },
  title: function(s){ return window.RRText.title(s); },
  // THESE COUNT WHAT IS ON SCREEN, not what is in the data. The requested
  // cities stopped being rendered on 31 Aug, and a sentence that said "nine of
  // these eleven rows" under five rows was the page miscounting itself out loud.
  rowCount: function(){ return C.tour.dates.length; },
  undatedCount: function(){ return C.tour.dates.filter(d => !d.date).length; },
  monthOf: function(iso){ return MONTHS_LONG[parse(iso).getMonth()]; },
  dayOf:   function(iso){ return parse(iso).getDate(); },

  fmtLong: fmtLong,
  daysAway: daysAway,
};
})();

/* ---- sprites.js ---- */
// GENERATED by build_dogs.py — do not hand-edit. Re-run the builder.
// RESCUE RAINBOWS sprite pack. 30x26, one char per pixel.
window.RR = (function(){
  const W = 30, H = 26;
  const SPRITES = {
    "mutt": [
      "..............................",
      "...................222222.....",
      ".................2211111122...",
      "................211111111112..",
      "...............3311111111112..",
      "...............33111111kw12...",
      "..............333111111k112...",
      "..............33311111111111kk",
      "..............33311111111111kk",
      "...22.....2222333111111111122.",
      "..22....2111113331111111112...",
      "..22...2111111333111111111....",
      "..22..21111111333111111112....",
      "...222111111111ccccccccc2.....",
      ".....21111111111111111112.....",
      ".....21111111111111144442.....",
      "....211111111111111144442.....",
      "....211111111111111144442.....",
      "....311111111111111244442.....",
      "....311111111111113244442.....",
      "....311111111111133.44444.....",
      ".....31111111444444.44444.....",
      ".............444444.44344.....",
      ".............333333.33233.....",
      "..............................",
      ".............................."
    ],
    "shepherd": [
      "..................22..........",
      ".................2112.........",
      ".................21112........",
      "................2111122.......",
      "................21111112......",
      "................21111111112...",
      "...............2111111kw12....",
      "...............2111111k112....",
      "...............2111111111111kk",
      "...22.....2222.2111111111111kk",
      "..22....21111121111111111122..",
      "..22...2111111111111111112....",
      "..22..211111111ccccccccc2.....",
      "...222111111111ccccccccc2.....",
      ".....21111111111111111112.....",
      ".....21111111111111144442.....",
      "....211111111111111144442.....",
      "....211111111111111144442.....",
      "....311111111111111244442.....",
      "....311111111111113244442.....",
      "....311111111111133.44444.....",
      ".....31111111444444.44444.....",
      ".............444444.44344.....",
      ".............333333.33233.....",
      "..............................",
      ".............................."
    ],
    "dachshund": [
      "..............................",
      "..............................",
      ".....................2222.....",
      "...................22111122...",
      "..................2111111112..",
      ".................331111kw1112.",
      "................3331111k11111k",
      "................3331111111111k",
      "................33311111111122",
      "................333111111112..",
      "...2............33cccccccc2...",
      "..22....222222..33ccccccc2....",
      "..22..2111111111333111112.....",
      "...222111111111111111112......",
      "....2111111111111111142.......",
      "....2111111111111114442.......",
      "....3111111111111124442.......",
      "....31111111111133.4442.......",
      ".....3111114444....4444.......",
      "......4444.4444....4444.......",
      "......3333.3333....3333.......",
      "..............................",
      "..............................",
      "..............................",
      "..............................",
      ".............................."
    ],
    "greyhound": [
      "..............................",
      ".....................2222.....",
      "...................22111122...",
      "..................233111112...",
      "..................231kw1112...",
      "..................21111111112.",
      "...................211111111kk",
      "...................211111111kk",
      "...................2111111122.",
      "...................2111112....",
      "...................2ccccc2....",
      "...................2ccccc2....",
      "..................21111112....",
      ".........222......21111112....",
      ".......2111112...211111112....",
      "......2111111112.111111112....",
      ".....211111111112111111112....",
      "...22111111111113111111112....",
      "..2.211111111111331111112.....",
      ".2..3111111111133.111112......",
      ".2..31111111133...444.2.......",
      ".22..3111114444...444.........",
      "..22.......4444...444.........",
      "...........3333...333.........",
      "..............................",
      ".............................."
    ],
    "pug": [
      "..............................",
      "................22222222......",
      "..............3311111111332...",
      ".............333111111113332..",
      ".............33311131113333...",
      ".............33311kw13kw333...",
      ".............33111k1333333....",
      ".............31111113333112...",
      "..............111111kkkk112...",
      "..............111113tt3312....",
      ".....22.......11111133332.....",
      "....2112......1111111112......",
      "....212..2222.ccccccccc2......",
      "....22.2111111ccccccccc2......",
      ".....2111111111111111112......",
      "....21111111111111144442......",
      "....21111111111111144442......",
      "....31111111111111244442......",
      "....31111111111113244442......",
      "....31111111111133.44444......",
      ".....3111111444444.44444......",
      "............444444.44344......",
      "............333333.33233......",
      "..............................",
      "..............................",
      ".............................."
    ],
    "poodle": [
      "..................22..........",
      "................22111122......",
      "...............21111111112....",
      "..............3311111111122...",
      ".............33311111122......",
      ".............3333111kw12......",
      ".............3333111k112......",
      ".............3333111111112....",
      ".............333111111111112..",
      "..22.........33.1111111111kk..",
      ".2112.......2..11111111111kk..",
      ".2112.....22..111111111.222...",
      "..22....21111.1111111112......",
      "...2...2111111.cccccccc2......",
      "....211111111.1111111112......",
      "....21111111111111114442......",
      "....21111111111111114442......",
      "....31111111111111124442......",
      "....31111111111111324442......",
      "....311111111111133.4444......",
      ".....3111111144444..4444......",
      ".............44444..4344......",
      ".............33333..3233......",
      "..............................",
      "..............................",
      ".............................."
    ],
    "terrier": [
      "..............................",
      "................3.....3.......",
      "...............33....33.......",
      "...............33222233.......",
      "...............331111332......",
      "...............3111113122.....",
      "...............31kw111kw12....",
      "...............31k1111k112....",
      "...............3111111111111kk",
      "...22..........3111111111111kk",
      "..2112....2222.3111111111122..",
      "..2112..211111.11111111112....",
      "...212.21111111ccccccccc2.....",
      "....22211111111ccccccccc2.....",
      ".....21111111111111111112.....",
      ".....21111111111111144442.....",
      "....211111111111111144442.....",
      "....211111111111111144442.....",
      "....311111111111111244442.....",
      "....311111111111113244442.....",
      "....311111111111133.44444.....",
      ".....31111111444444.44444.....",
      ".............444444.44344.....",
      ".............333333.33233.....",
      "..............................",
      ".............................."
    ],
    "cat": [
      "..............................",
      "...............2......2.......",
      "..............232....232......",
      "..............2332..2332......",
      "..............21111111112.....",
      "..............211kw11kw12.....",
      "..............211k111k112.....",
      "...............2111111k112....",
      "...............211111111112...",
      "................211111112.....",
      "................21111112......",
      "...........2222.11111112......",
      ".........211111111111112......",
      "........2111111111111112......",
      ".......21111111111111112......",
      "......211111111111111112......",
      "......211111111111111442......",
      "......311111111111112442......",
      "......311111111111334442......",
      ".....231111111133...4444......",
      "....2.311111.4444..4444.......",
      "....22.......4444..4444.......",
      "....222222222222222222........",
      ".....33333333333333333........",
      "..............................",
      ".............................."
    ],
    "catloaf": [
      "..............................",
      "..............................",
      "..............2......2........",
      ".............232....232.......",
      ".............2332..2332.......",
      ".............21111111112......",
      ".............211kw11kw12......",
      ".............211k111k112......",
      ".............21111k111112.....",
      "..............21111111112.....",
      "..........222221111111112.....",
      ".......221111111111111112.....",
      ".....21111111111111111112.....",
      "....211111111111111111112.....",
      "...2111111111111111111112.....",
      "...2111111111111111111112.....",
      "...2111111111111111111112.....",
      "...3111111111111444411113.....",
      "....33333333333344443333......",
      "..............................",
      "..............................",
      "..............................",
      "..............................",
      "..............................",
      "..............................",
      ".............................."
    ]
  };
  const COATS = {
    "sable": {
      "1": "#c99a5e",
      "2": "#a06f36",
      "3": "#6b431c",
      "4": "#f6ead6"
    },
    "black": {
      "1": "#4a4a52",
      "2": "#33333a",
      "3": "#1e1e24",
      "4": "#e8e6df"
    },
    "cream": {
      "1": "#f3e4c6",
      "2": "#dcc498",
      "3": "#a98f63",
      "4": "#ffffff"
    },
    "red": {
      "1": "#d98a4e",
      "2": "#b0602a",
      "3": "#763a12",
      "4": "#f8efe0"
    },
    "grey": {
      "1": "#b9bcc2",
      "2": "#93979f",
      "3": "#63666e",
      "4": "#f2f2f0"
    },
    "choc": {
      "1": "#8f6142",
      "2": "#6b432a",
      "3": "#432818",
      "4": "#e9dcc9"
    },
    "white": {
      "1": "#fbf8f0",
      "2": "#e2dccc",
      "3": "#b1a996",
      "4": "#ffffff"
    },
    "tabby": {
      "1": "#c6a173",
      "2": "#96703f",
      "3": "#5f451f",
      "4": "#f6ecdc"
    },
    "tuxedo": {
      "1": "#3a3a42",
      "2": "#26262c",
      "3": "#131317",
      "4": "#ffffff"
    }
  };
  const INK = {"k": "#141419", "w": "#ffffff", "t": "#e8697f"};
  const LIGHTS = {"red": "#ff2e88", "green": "#31e39a", "blue": "#3b4eea", "yellow": "#ffc93a"};
  const RAINBOW = [{"1": "#ff9b8e", "2": "#f0402f", "3": "#a82214"}, {"1": "#ffc48a", "2": "#f5872b", "3": "#bd530d"}, {"1": "#ffe98a", "2": "#f2c518", "3": "#b58a06"}, {"1": "#a8e39b", "2": "#3fae49", "3": "#1c7027"}, {"1": "#9cc8f5", "2": "#2f5ce0", "3": "#17408f"}, {"1": "#c9a8f0", "2": "#7f45d1", "3": "#4f2590"}];
  const LAMP = [".33333333..", ".3cccccc3..", ".3cccccc3..", ".3cccccc3..", ".3cccccc3..", ".33333333..", "....33.....", "....33.....", "...3..3....", "...3..3....", "..3....3...", "..3....3...", ".3......3..", ".3......3..", "3........3.", "33......33."]; const LAMP_W = 11;
  const BOX = ["11111111111111111111", "11111111111111111111", "33222222222222222233", "33222222222222222233", "33222222222222222233", "33222222333322222233", "33222222333322222233", "33222222222222222233", "33222222222222222233", "33222222222222222233", "33333333333333333333"]; const BOX_W = 20, BOX_H = 11;
  const PROP = {"1": "#e6e6ea", "2": "#c7c7cf", "3": "#8d8d97"};

  // ---- THE PHOTOGRAPHER ---------------------------------------------------
  // He stands on the far side of the orb with a camera on a tripod aimed back
  // into it, and he presses the shutter the moment a dog crosses. Facing LEFT,
  // because that is where the orb is and dogs walk left to right.
  //
  // GENERATED, NOT HAND-TYPED. Fifty-four rows of thirty-four characters is not
  // something to keep correct by hand — the source that draws him is in the
  // commit that added this. Same one-char-per-pixel format as LAMP and BOX.
  const GREETER_W = 34;
  const GREETER = [
    "...................aaaaaaa........",
    "...................aaaaaaa........",
    "..................aaaaaaaaa.......",
    "..................aaaaaaaaa.......",
    "..................aaaaaaaaa.......",
    "..................aaaaaaaaa.......",
    "..........aaaaaaaaaaaaaaaa........",
    "..........aaaaaaaaaaaaaaaa........",
    "...................kkkkkkk........",
    "...................kkkkkkk........",
    "...................kwkkkkk........",
    "...................kkkkkkk........",
    "...................kkkkkkk........",
    "...................kkkkkkk........",
    "...................kkkkkkk........",
    ".....................kkkk.........",
    ".....................kkkk.........",
    "..................rrrrrrrrr.......",
    "..................rrrrrrrrr.......",
    "..................rrrrrrrrr.......",
    "..................rrrrrrrrr.......",
    "..............rrrrrrrrrrrrr.......",
    "...........kkkkrrrrrrrrrrrr.......",
    ".......bbbbkkkk...rrrrrrrrr.......",
    ".......bbbb.......rrrrrrrrr.......",
    "......bbbbbbbb....rrrrrrrrr.......",
    "......bbbbbbwb....rrrrrrrrr.......",
    "....bbbbbbbbbb....rrrrrrrrr.......",
    "....bbbbbbbbbb....rrrrrrrrr.......",
    "....bbbbbbbbb.....rrrrrrrrr.......",
    "..llbbbbbbbbb......kkkkkkk........",
    "..llbbbbbbbbb......kkkkkkk........",
    ".lll....mmm........kkkkkkk........",
    ".lll....mmm........kkkkkkk........",
    "........mmm........kkkkkkk........",
    "........mmm........kkkkkkk........",
    "........mmm........kkkkkkk........",
    "........mmm.......ppppppppp.......",
    "........mmm.......ppppppppp.......",
    "........mmm.......ppppppppp.......",
    "........mmm.......ppppppppp.......",
    "........mmm.......ppppppppp.......",
    "........mmm.......ppppppppp.......",
    "........mmm........ppp..ppp.......",
    "........mmm........ppp..ppp.......",
    "........mmm........ppp..ppp.......",
    "........mmm........ppp..ppp.......",
    "........mmm........ppp..ppp.......",
    "........mmm........ppp..ppp.......",
    "........mmm........ppp..ppp.......",
    "........mmm........ppp..ppp.......",
    "........mmm........ppp..ppp.......",
    "........mmm........ppp..ppp.......",
    "........mmm........ppp..ppp.......",
    "........mmm........ppp..ppp.......",
    "........mmm........ppp..ppp.......",
    "........mmm........ppp..ppp.......",
    "........mmm........ppp..ppp.......",
    "........mmm........ppp..ppp.......",
    "........mmm........ppp..ppp.......",
    "........mmm........ppp..ppp.......",
    "........mmm........ppp..ppp.......",
    "........mmm........ppp..ppp.......",
    "........mmm........ppp..ppp.......",
    "........mmm........ppp..ppp.......",
    "........mmm........ppp..ppp.......",
    "........mmm........ppp..ppp.......",
    "........mmm........ppp..ppp.......",
    ".......mmmmm.......ppp..ppp.......",
    ".......mmmmm.......ppp..ppp.......",
    ".......mmmmm.......ppp..ppp.......",
    ".......mmmmm.......ppp..ppp.......",
    "......mm.m.mm......ppp..ppp.......",
    "......mm.m.mm......ppp..ppp.......",
    "......mm.m.mm......ppp..ppp.......",
    "......mm.m.mm......ppp..ppp.......",
    ".....mm..m..mm.....ppp..ppp.......",
    ".....mm..m..mm.....ppp..ppp.......",
    ".....mm..m..mm.....ppp..ppp.......",
    "....m.m..m..m.m....ppp..ppp.......",
    "....mm...m...mm....ppp..ppp.......",
    "....mm...m...mm....ppp..ppp.......",
    "....mm...m...mm....ppp..ppp.......",
    "...mm....m....mm...ppp..ppp.......",
    "...mm....m....mm...ppp..ppp.......",
    "...mm....m....mm...ppp..ppp.......",
    "...mm....m....mm...ppp..ppp.......",
    "..mm.....m.....mm..ppp..ppp.......",
    "..mm.....m.....mm..ppp..ppp.......",
    "..mm.....m.....mm..ppp..ppp.......",
    "..mm.....m.....mm.sssss.ssss......",
    ".mm......m......mmsssss.ssss......",
    ".mm......m......mmsssss.ssss......",
  ];
  // The raised arm and the squeaky toy, on the same grid and the same anchor.
  const GREETER_TOY = [
    "..................................",
    "..................................",
    "..................................",
    "...........................y.....y",
    "...........................yyyyyyy",
    "............................ywyyy.",
    "...........................yyyyyyy",
    "...........................y.....y",
    ".............................kkk..",
    ".............................kkk..",
    ".............................kkk..",
    ".............................kkk..",
    ".............................kkk..",
    ".............................kkk..",
    ".............................kkk..",
    "............................kkkk..",
    "............................kkk...",
    "............................kkk...",
    "............................kkk...",
    "..........................rrkkk...",
    "..........................rrr.....",
    "..........................rrr.....",
    "..................................",
    "..................................",
    "..................................",
    "..................................",
    "..................................",
    "..................................",
    "..................................",
    "..................................",
    "..................................",
    "..................................",
    "..................................",
    "..................................",
    "..................................",
    "..................................",
    "..................................",
    "..................................",
    "..................................",
    "..................................",
    "..................................",
    "..................................",
    "..................................",
    "..................................",
    "..................................",
    "..................................",
    "..................................",
    "..................................",
    "..................................",
    "..................................",
    "..................................",
    "..................................",
    "..................................",
    "..................................",
    "..................................",
    "..................................",
    "..................................",
    "..................................",
    "..................................",
    "..................................",
    "..................................",
    "..................................",
    "..................................",
    "..................................",
    "..................................",
    "..................................",
    "..................................",
    "..................................",
    "..................................",
    "..................................",
    "..................................",
    "..................................",
    "..................................",
    "..................................",
    "..................................",
    "..................................",
    "..................................",
    "..................................",
    "..................................",
    "..................................",
    "..................................",
    "..................................",
    "..................................",
    "..................................",
    "..................................",
    "..................................",
    "..................................",
    "..................................",
    "..................................",
    "..................................",
    "..................................",
    "..................................",
    "..................................",
    "..................................",
  ];
  // 'r' is the belly shirt and it carries no colour here on purpose —
  // machine.js pours a moving gradient through it every frame.
  const GREETER_PAL = {a:'#1d1d24', k:'#7a4a2b', w:'#fdf6ec', r:'#e11d48',
    p:'#2f5ce0', s:'#0d0d10', b:'#1b1b21', l:'#6f7480', m:'#8d8d97',
    y:'#ffc93a'};

  const BANDS = {"mutt": [14.25, 18.05, 21.1, 23.95, 27.15], "shepherd": [13.85, 17.75, 20.5, 23.4, 27.0], "dachshund": [13.649999999999999, 18.1, 20.75, 23.6, 26.65], "greyhound": [14.899999999999999, 19.7, 22.55, 25.15, 27.35], "pug": [14.55, 17.65, 20.45, 23.1, 26.35], "poodle": [14.3, 17.55, 20.3, 22.95, 25.85], "terrier": [13.649999999999999, 17.55, 20.85, 23.5, 27.1], "cat": [15.4, 18.1, 21.0, 23.2, 25.95], "catloaf": [13.6, 16.6, 19.75, 22.4, 25.25]};
  const FEET = {"mutt": {"y": 23, "x0": 13, "x1": 24}, "shepherd": {"y": 23, "x0": 13, "x1": 24}, "dachshund": {"y": 20, "x0": 6, "x1": 22}, "greyhound": {"y": 23, "x0": 11, "x1": 20}, "pug": {"y": 22, "x0": 12, "x1": 23}, "poodle": {"y": 22, "x0": 13, "x1": 23}, "terrier": {"y": 23, "x0": 13, "x1": 24}, "cat": {"y": 23, "x0": 5, "x1": 21}, "catloaf": {"y": 18, "x0": 4, "x1": 23}};
  const BBOX = {
    "mutt": {
      "x0": 2,
      "y0": 1,
      "x1": 29,
      "y1": 23
    },
    "shepherd": {
      "x0": 2,
      "y0": 0,
      "x1": 29,
      "y1": 23
    },
    "dachshund": {
      "x0": 2,
      "y0": 2,
      "x1": 29,
      "y1": 20
    },
    "greyhound": {
      "x0": 1,
      "y0": 1,
      "x1": 29,
      "y1": 23
    },
    "pug": {
      "x0": 4,
      "y0": 1,
      "x1": 27,
      "y1": 22
    },
    "poodle": {
      "x0": 1,
      "y0": 0,
      "x1": 27,
      "y1": 22
    },
    "terrier": {
      "x0": 2,
      "y0": 1,
      "x1": 29,
      "y1": 23
    },
    "cat": {
      "x0": 4,
      "y0": 1,
      "x1": 26,
      "y1": 23
    },
    "catloaf": {
      "x0": 3,
      "y0": 2,
      "x1": 24,
      "y1": 18
    }
  };
  const CAST = [
    {
      "id": "mutt",
      "sprite": "mutt",
      "coat": "sable",
      "collar": "red",
      "name": "BISCUIT",
      "kind": "dog",
      "note": "shepherd-ish, mostly"
    },
    {
      "id": "shepherd",
      "sprite": "shepherd",
      "coat": "black",
      "collar": "yellow",
      "name": "OFFICER",
      "kind": "dog",
      "note": "ears up, always"
    },
    {
      "id": "dachshund",
      "sprite": "dachshund",
      "coat": "choc",
      "collar": "green",
      "name": "NOODLE",
      "kind": "dog",
      "note": "needs a wide frame"
    },
    {
      "id": "greyhound",
      "sprite": "greyhound",
      "coat": "grey",
      "collar": "blue",
      "name": "SPINDLE",
      "kind": "dog",
      "note": "sat down once, in 2019"
    },
    {
      "id": "pug",
      "sprite": "pug",
      "coat": "cream",
      "collar": "red",
      "name": "DUMPLING",
      "kind": "dog",
      "note": "breathes loudly, on purpose"
    },
    {
      "id": "poodle",
      "sprite": "poodle",
      "coat": "white",
      "collar": "blue",
      "name": "MERINGUE",
      "kind": "dog",
      "note": "knows she looks good"
    },
    {
      "id": "terrier",
      "sprite": "terrier",
      "coat": "red",
      "collar": "green",
      "name": "RASCAL",
      "kind": "dog",
      "note": "twelve pounds of opinion"
    },
    {
      "id": "cat",
      "sprite": "cat",
      "coat": "tabby",
      "collar": "yellow",
      "name": "GRAHAM",
      "kind": "cat",
      "note": "tuesday is cat day"
    },
    {
      "id": "catloaf",
      "sprite": "catloaf",
      "coat": "tuxedo",
      "collar": "red",
      "name": "BOARD",
      "kind": "cat",
      "note": "will not be posed"
    }
  ];
  return {W, H, LAMP, LAMP_W, BOX, BOX_W, BOX_H, PROP, GREETER, GREETER_TOY, GREETER_W, GREETER_PAL, SPRITES, BANDS, FEET, BBOX, COATS, INK, LIGHTS, RAINBOW, CAST};
})();

/* ---- gradients.js ---- */
// uiGradients — vendored. Source: github.com/ghosh/uiGradients (MIT).
// 382 gradients, fetched and written by hand-off, not by a build step: this
// collection loads everything with <script src> so a piece still opens off
// disk with no server and no npm.
//
// ALL is the library as published. PICKS is the subset that actually holds up
// here — saturated, mid-lightness, with real hue travel between the stops.
// A muddy or near-black gradient turns the machine into a hole in the page,
// and roughly four fifths of the library is too dark or too grey for a white
// ground with a pixel dog standing in front of it.
window.UIGRADIENTS = (function(){
  const ALL = [
    {n:'Omolon', c:['#091e3a','#2f80ed','#2d9ee0']},
    {n:'Farhan', c:['#9400d3','#4b0082']},
    {n:'Purple', c:['#c84e89','#f15f79']},
    {n:'Ibtesam', c:['#00f5a0','#00d9f5']},
    {n:'Radioactive Heat', c:['#f7941e','#72c6ef','#00a651']},
    {n:'The Sky And The Sea', c:['#f7941e','#004e8f']},
    {n:'From Ice To Fire', c:['#72c6ef','#004e8f']},
    {n:'Blue & Orange', c:['#fd8112','#0085ca']},
    {n:'Purple Dream', c:['#bf5ae0','#a811da']},
    {n:'Blu', c:['#00416a','#e4e5e6']},
    {n:'Summer Breeze', c:['#fbed96','#abecd6']},
    {n:'Ver', c:['#ffe000','#799f0c']},
    {n:'Ver Black', c:['#f7f8f8','#acbb78']},
    {n:'Combi', c:['#00416a','#799f0c','#ffe000']},
    {n:'Anwar', c:['#334d50','#cbcaa5']},
    {n:'Bluelagoo', c:['#0052d4','#4364f7','#6fb1fc']},
    {n:'Lunada', c:['#5433ff','#20bdff','#a5fecb']},
    {n:'Reaqua', c:['#799f0c','#acbb78']},
    {n:'Mango', c:['#ffe259','#ffa751']},
    {n:'Bupe', c:['#00416a','#e4e5e6']},
    {n:'Rea', c:['#ffe000','#799f0c']},
    {n:'Windy', c:['#acb6e5','#86fde8']},
    {n:'Royal Blue', c:['#536976','#292e49']},
    {n:'Royal Blue + Petrol', c:['#bbd2c5','#536976','#292e49']},
    {n:'Copper', c:['#b79891','#94716b']},
    {n:'Anamnisar', c:['#9796f0','#fbc7d4']},
    {n:'Petrol', c:['#bbd2c5','#536976']},
    {n:'Sky', c:['#076585','#ffffff']},
    {n:'Sel', c:['#00467f','#a5cc82']},
    {n:'Afternoon', c:['#000c40','#607d8b']},
    {n:'Skyline', c:['#1488cc','#2b32b2']},
    {n:'DIMIGO', c:['#ec008c','#fc6767']},
    {n:'Purple Love', c:['#cc2b5e','#753a88']},
    {n:'Sexy Blue', c:['#2193b0','#6dd5ed']},
    {n:'Blooker20', c:['#e65c00','#f9d423']},
    {n:'Sea Blue', c:['#2b5876','#4e4376']},
    {n:'Nimvelo', c:['#314755','#26a0da']},
    {n:'Hazel', c:['#77a1d3','#79cbca','#e684ae']},
    {n:'Noon to Dusk', c:['#ff6e7f','#bfe9ff']},
    {n:'YouTube', c:['#e52d27','#b31217']},
    {n:'Cool Brown', c:['#603813','#b29f94']},
    {n:'Harmonic Energy', c:['#16a085','#f4d03f']},
    {n:'Playing with Reds', c:['#d31027','#ea384d']},
    {n:'Sunny Days', c:['#ede574','#e1f5c4']},
    {n:'Green Beach', c:['#02aab0','#00cdac']},
    {n:'Intuitive Purple', c:['#da22ff','#9733ee']},
    {n:'Emerald Water', c:['#348f50','#56b4d3']},
    {n:'Lemon Twist', c:['#3ca55c','#b5ac49']},
    {n:'Monte Carlo', c:['#cc95c0','#dbd4b4','#7aa1d2']},
    {n:'Horizon', c:['#003973','#e5e5be']},
    {n:'Rose Water', c:['#e55d87','#5fc3e4']},
    {n:'Frozen', c:['#403b4a','#e7e9bb']},
    {n:'Mango Pulp', c:['#f09819','#edde5d']},
    {n:'Bloody Mary', c:['#ff512f','#dd2476']},
    {n:'Aubergine', c:['#aa076b','#61045f']},
    {n:'Aqua Marine', c:['#1a2980','#26d0ce']},
    {n:'Sunrise', c:['#ff512f','#f09819']},
    {n:'Purple Paradise', c:['#1d2b64','#f8cdda']},
    {n:'Stripe', c:['#1fa2ff','#12d8fa','#a6ffcb']},
    {n:'Sea Weed', c:['#4cb8c4','#3cd3ad']},
    {n:'Pinky', c:['#dd5e89','#f7bb97']},
    {n:'Cherry', c:['#eb3349','#f45c43']},
    {n:'Mojito', c:['#1d976c','#93f9b9']},
    {n:'Juicy Orange', c:['#ff8008','#ffc837']},
    {n:'Mirage', c:['#16222a','#3a6073']},
    {n:'Steel Gray', c:['#1f1c2c','#928dab']},
    {n:'Kashmir', c:['#614385','#516395']},
    {n:'Electric Violet', c:['#4776e6','#8e54e9']},
    {n:'Venice Blue', c:['#085078','#85d8ce']},
    {n:'Bora Bora', c:['#2bc0e4','#eaecc6']},
    {n:'Moss', c:['#134e5e','#71b280']},
    {n:'Shroom Haze', c:['#5c258d','#4389a2']},
    {n:'Mystic', c:['#757f9a','#d7dde8']},
    {n:'Midnight City', c:['#232526','#414345']},
    {n:'Sea Blizz', c:['#1cd8d2','#93edc7']},
    {n:'Opa', c:['#3d7eaa','#ffe47a']},
    {n:'Titanium', c:['#283048','#859398']},
    {n:'Mantle', c:['#24c6dc','#514a9d']},
    {n:'Dracula', c:['#dc2424','#4a569d']},
    {n:'Peach', c:['#ed4264','#ffedbc']},
    {n:'Moonrise', c:['#dae2f8','#d6a4a4']},
    {n:'Clouds', c:['#ece9e6','#ffffff']},
    {n:'Stellar', c:['#7474bf','#348ac7']},
    {n:'Bourbon', c:['#ec6f66','#f3a183']},
    {n:'Calm Darya', c:['#5f2c82','#49a09d']},
    {n:'Influenza', c:['#c04848','#480048']},
    {n:'Shrimpy', c:['#e43a15','#e65245']},
    {n:'Army', c:['#414d0b','#727a17']},
    {n:'Miaka', c:['#fc354c','#0abfbc']},
    {n:'Pinot Noir', c:['#4b6cb7','#182848']},
    {n:'Day Tripper', c:['#f857a6','#ff5858']},
    {n:'Namn', c:['#a73737','#7a2828']},
    {n:'Blurry Beach', c:['#d53369','#cbad6d']},
    {n:'Vasily', c:['#e9d362','#333333']},
    {n:'A Lost Memory', c:['#de6262','#ffb88c']},
    {n:'Petrichor', c:['#666600','#999966']},
    {n:'Jonquil', c:['#ffeeee','#ddefbb']},
    {n:'Sirius Tamed', c:['#efefbb','#d4d3dd']},
    {n:'Kyoto', c:['#c21500','#ffc500']},
    {n:'Misty Meadow', c:['#215f00','#e4e4d9']},
    {n:'Aqualicious', c:['#50c9c3','#96deda']},
    {n:'Moor', c:['#616161','#9bc5c3']},
    {n:'Almost', c:['#ddd6f3','#faaca8']},
    {n:'Forever Lost', c:['#5d4157','#a8caba']},
    {n:'Winter', c:['#e6dada','#274046']},
    {n:'Nelson', c:['#f2709c','#ff9472']},
    {n:'Autumn', c:['#dad299','#b0dab9']},
    {n:'Candy', c:['#d3959b','#bfe6ba']},
    {n:'Reef', c:['#00d2ff','#3a7bd5']},
    {n:'The Strain', c:['#870000','#190a05']},
    {n:'Dirty Fog', c:['#b993d6','#8ca6db']},
    {n:'Earthly', c:['#649173','#dbd5a4']},
    {n:'Virgin', c:['#c9ffbf','#ffafbd']},
    {n:'Ash', c:['#606c88','#3f4c6b']},
    {n:'Cherryblossoms', c:['#fbd3e9','#bb377d']},
    {n:'Parklife', c:['#add100','#7b920a']},
    {n:'Dance To Forget', c:['#ff4e50','#f9d423']},
    {n:'Starfall', c:['#f0c27b','#4b1248']},
    {n:'Red Mist', c:['#000000','#e74c3c']},
    {n:'Teal Love', c:['#aaffa9','#11ffbd']},
    {n:'Neon Life', c:['#b3ffab','#12fff7']},
    {n:'Man of Steel', c:['#780206','#061161']},
    {n:'Amethyst', c:['#9d50bb','#6e48aa']},
    {n:'Cheer Up Emo Kid', c:['#556270','#ff6b6b']},
    {n:'Shore', c:['#70e1f5','#ffd194']},
    {n:'Facebook Messenger', c:['#00c6ff','#0072ff']},
    {n:'SoundCloud', c:['#fe8c00','#f83600']},
    {n:'Behongo', c:['#52c234','#061700']},
    {n:'ServQuick', c:['#485563','#29323c']},
    {n:'Friday', c:['#83a4d4','#b6fbff']},
    {n:'Martini', c:['#fdfc47','#24fe41']},
    {n:'Metallic Toad', c:['#abbaab','#ffffff']},
    {n:'Between The Clouds', c:['#73c8a9','#373b44']},
    {n:'Crazy Orange I', c:['#d38312','#a83279']},
    {n:'Hersheys', c:['#1e130c','#9a8478']},
    {n:'Talking To Mice Elf', c:['#948e99','#2e1437']},
    {n:'Purple Bliss', c:['#360033','#0b8793']},
    {n:'Predawn', c:['#ffa17f','#00223e']},
    {n:'Endless River', c:['#43cea2','#185a9d']},
    {n:'Pastel Orange at the Sun', c:['#ffb347','#ffcc33']},
    {n:'Twitch', c:['#6441a5','#2a0845']},
    {n:'Atlas', c:['#feac5e','#c779d0','#4bc0c8']},
    {n:'Instagram', c:['#833ab4','#fd1d1d','#fcb045']},
    {n:'Flickr', c:['#ff0084','#33001b']},
    {n:'Vine', c:['#00bf8f','#001510']},
    {n:'Turquoise flow', c:['#136a8a','#267871']},
    {n:'Portrait', c:['#8e9eab','#eef2f3']},
    {n:'Virgin America', c:['#7b4397','#dc2430']},
    {n:'Koko Caramel', c:['#d1913c','#ffd194']},
    {n:'Fresh Turboscent', c:['#f1f2b5','#135058']},
    {n:'Green to dark', c:['#6a9113','#141517']},
    {n:'Ukraine', c:['#004ff9','#fff94c']},
    {n:'Curiosity blue', c:['#525252','#3d72b4']},
    {n:'Dark Knight', c:['#ba8b02','#181818']},
    {n:'Piglet', c:['#ee9ca7','#ffdde1']},
    {n:'Lizard', c:['#304352','#d7d2cc']},
    {n:'Sage Persuasion', c:['#ccccb2','#757519']},
    {n:'Between Night and Day', c:['#2c3e50','#3498db']},
    {n:'Timber', c:['#fc00ff','#00dbde']},
    {n:'Passion', c:['#e53935','#e35d5b']},
    {n:'Clear Sky', c:['#005c97','#363795']},
    {n:'Master Card', c:['#f46b45','#eea849']},
    {n:'Back To Earth', c:['#00c9ff','#92fe9d']},
    {n:'Deep Purple', c:['#673ab7','#512da8']},
    {n:'Little Leaf', c:['#76b852','#8dc26f']},
    {n:'Netflix', c:['#8e0e00','#1f1c18']},
    {n:'Light Orange', c:['#ffb75e','#ed8f03']},
    {n:'Green and Blue', c:['#c2e59c','#64b3f4']},
    {n:'Poncho', c:['#403a3e','#be5869']},
    {n:'Back to the Future', c:['#c02425','#f0cb35']},
    {n:'Blush', c:['#b24592','#f15f79']},
    {n:'Inbox', c:['#457fca','#5691c8']},
    {n:'Purplin', c:['#6a3093','#a044ff']},
    {n:'Pale Wood', c:['#eacda3','#d6ae7b']},
    {n:'Haikus', c:['#fd746c','#ff9068']},
    {n:'Pizelex', c:['#114357','#f29492']},
    {n:'Joomla', c:['#1e3c72','#2a5298']},
    {n:'Christmas', c:['#2f7336','#aa3a38']},
    {n:'Minnesota Vikings', c:['#5614b0','#dbd65c']},
    {n:'Miami Dolphins', c:['#4da0b0','#d39d38']},
    {n:'Forest', c:['#5a3f37','#2c7744']},
    {n:'Nighthawk', c:['#2980b9','#2c3e50']},
    {n:'Superman', c:['#0099f7','#f11712']},
    {n:'Suzy', c:['#834d9b','#d04ed6']},
    {n:'Dark Skies', c:['#4b79a1','#283e51']},
    {n:'Deep Space', c:['#000000','#434343']},
    {n:'Decent', c:['#4ca1af','#c4e0e5']},
    {n:'Colors Of Sky', c:['#e0eafc','#cfdef3']},
    {n:'Purple White', c:['#ba5370','#f4e2d8']},
    {n:'Ali', c:['#ff4b1f','#1fddff']},
    {n:'Alihossein', c:['#f7ff00','#db36a4']},
    {n:'Shahabi', c:['#a80077','#66ff00']},
    {n:'Red Ocean', c:['#1d4350','#a43931']},
    {n:'Tranquil', c:['#eecda3','#ef629f']},
    {n:'Transfile', c:['#16bffd','#cb3066']},
    {n:'Sylvia', c:['#ff4b1f','#ff9068']},
    {n:'Sweet Morning', c:['#ff5f6d','#ffc371']},
    {n:'Politics', c:['#2196f3','#f44336']},
    {n:'Bright Vault', c:['#00d2ff','#928dab']},
    {n:'Solid Vault', c:['#3a7bd5','#3a6073']},
    {n:'Sunset', c:['#0b486b','#f56217']},
    {n:'Grapefruit Sunset', c:['#e96443','#904e95']},
    {n:'Deep Sea Space', c:['#2c3e50','#4ca1af']},
    {n:'Dusk', c:['#2c3e50','#fd746c']},
    {n:'Minimal Red', c:['#f00000','#dc281e']},
    {n:'Royal', c:['#141e30','#243b55']},
    {n:'Mauve', c:['#42275a','#734b6d']},
    {n:'Frost', c:['#000428','#004e92']},
    {n:'Lush', c:['#56ab2f','#a8e063']},
    {n:'Firewatch', c:['#cb2d3e','#ef473a']},
    {n:'Sherbert', c:['#f79d00','#64f38c']},
    {n:'Blood Red', c:['#f85032','#e73827']},
    {n:'Sun on the Horizon', c:['#fceabb','#f8b500']},
    {n:'IIIT Delhi', c:['#808080','#3fada8']},
    {n:'Jupiter', c:['#ffd89b','#19547b']},
    {n:'50 Shades of Grey', c:['#bdc3c7','#2c3e50']},
    {n:'Dania', c:['#be93c5','#7bc6cc']},
    {n:'Limeade', c:['#a1ffce','#faffd1']},
    {n:'Disco', c:['#4ecdc4','#556270']},
    {n:'Love Couple', c:['#3a6186','#89253e']},
    {n:'Azure Pop', c:['#ef32d9','#89fffd']},
    {n:'Nepal', c:['#de6161','#2657eb']},
    {n:'Cosmic Fusion', c:['#ff00cc','#333399']},
    {n:'Snapchat', c:['#fffc00','#ffffff']},
    {n:'Ed\'s Sunset Gradient', c:['#ff7e5f','#feb47b']},
    {n:'Brady Brady Fun Fun', c:['#00c3ff','#ffff1c']},
    {n:'Black Rosé', c:['#f4c4f3','#fc67fa']},
    {n:'80\'s Purple', c:['#41295a','#2f0743']},
    {n:'Radar', c:['#a770ef','#cf8bf3','#fdb99b']},
    {n:'Ibiza Sunset', c:['#ee0979','#ff6a00']},
    {n:'Dawn', c:['#f3904f','#3b4371']},
    {n:'Mild', c:['#67b26f','#4ca2cd']},
    {n:'Vice City', c:['#3494e6','#ec6ead']},
    {n:'Jaipur', c:['#dbe6f6','#c5796d']},
    {n:'Jodhpur', c:['#9cecfb','#65c7f7','#0052d4']},
    {n:'Cocoaa Ice', c:['#c0c0aa','#1cefff']},
    {n:'EasyMed', c:['#dce35b','#45b649']},
    {n:'Rose Colored Lenses', c:['#e8cbc0','#636fa4']},
    {n:'What lies Beyond', c:['#f0f2f0','#000c40']},
    {n:'Roseanna', c:['#ffafbd','#ffc3a0']},
    {n:'Honey Dew', c:['#43c6ac','#f8ffae']},
    {n:'Under the Lake', c:['#093028','#237a57']},
    {n:'The Blue Lagoon', c:['#43c6ac','#191654']},
    {n:'Can You Feel The Love Tonight', c:['#4568dc','#b06ab3']},
    {n:'Very Blue', c:['#0575e6','#021b79']},
    {n:'Love and Liberty', c:['#200122','#6f0000']},
    {n:'Orca', c:['#44a08d','#093637']},
    {n:'Venice', c:['#6190e8','#a7bfe8']},
    {n:'Pacific Dream', c:['#34e89e','#0f3443']},
    {n:'Learning and Leading', c:['#f7971e','#ffd200']},
    {n:'Celestial', c:['#c33764','#1d2671']},
    {n:'Purplepine', c:['#20002c','#cbb4d4']},
    {n:'Sha la la', c:['#d66d75','#e29587']},
    {n:'Mini', c:['#30e8bf','#ff8235']},
    {n:'Maldives', c:['#b2fefa','#0ed2f7']},
    {n:'Cinnamint', c:['#4ac29a','#bdfff3']},
    {n:'Html', c:['#e44d26','#f16529']},
    {n:'Coal', c:['#eb5757','#000000']},
    {n:'Sunkist', c:['#f2994a','#f2c94c']},
    {n:'Blue Skies', c:['#56ccf2','#2f80ed']},
    {n:'Chitty Chitty Bang Bang', c:['#007991','#78ffd6']},
    {n:'Visions of Grandeur', c:['#000046','#1cb5e0']},
    {n:'Crystal Clear', c:['#159957','#155799']},
    {n:'Mello', c:['#c0392b','#8e44ad']},
    {n:'Compare Now', c:['#ef3b36','#ffffff']},
    {n:'Meridian', c:['#283c86','#45a247']},
    {n:'Relay', c:['#3a1c71','#d76d77','#ffaf7b']},
    {n:'Alive', c:['#cb356b','#bd3f32']},
    {n:'Scooter', c:['#36d1dc','#5b86e5']},
    {n:'Terminal', c:['#000000','#0f9b0f']},
    {n:'Telegram', c:['#1c92d2','#f2fcfe']},
    {n:'Crimson Tide', c:['#642b73','#c6426e']},
    {n:'Socialive', c:['#06beb6','#48b1bf']},
    {n:'Subu', c:['#0cebeb','#20e3b2','#29ffc6']},
    {n:'Broken Hearts', c:['#d9a7c7','#fffcdc']},
    {n:'Kimoby Is The New Blue', c:['#396afc','#2948ff']},
    {n:'Dull', c:['#c9d6ff','#e2e2e2']},
    {n:'Purpink', c:['#7f00ff','#e100ff']},
    {n:'Orange Coral', c:['#ff9966','#ff5e62']},
    {n:'Summer', c:['#22c1c3','#fdbb2d']},
    {n:'King Yna', c:['#1a2a6c','#b21f1f','#fdbb2d']},
    {n:'Velvet Sun', c:['#e1eec3','#f05053']},
    {n:'Zinc', c:['#ada996','#f2f2f2','#dbdbdb','#eaeaea']},
    {n:'Hydrogen', c:['#667db6','#0082c8','#0082c8','#667db6']},
    {n:'Argon', c:['#03001e','#7303c0','#ec38bc','#fdeff9']},
    {n:'Lithium', c:['#6d6027','#d3cbb8']},
    {n:'Digital Water', c:['#74ebd5','#acb6e5']},
    {n:'Orange Fun', c:['#fc4a1a','#f7b733']},
    {n:'Rainbow Blue', c:['#00f260','#0575e6']},
    {n:'Pink Flavour', c:['#800080','#ffc0cb']},
    {n:'Sulphur', c:['#cac531','#f3f9a7']},
    {n:'Selenium', c:['#3c3b3f','#605c3c']},
    {n:'Delicate', c:['#d3cce3','#e9e4f0']},
    {n:'Ohhappiness', c:['#00b09b','#96c93d']},
    {n:'Lawrencium', c:['#0f0c29','#302b63','#24243e']},
    {n:'Relaxing red', c:['#fffbd5','#b20a2c']},
    {n:'Taran Tado', c:['#23074d','#cc5333']},
    {n:'Bighead', c:['#c94b4b','#4b134f']},
    {n:'Sublime Vivid', c:['#fc466b','#3f5efb']},
    {n:'Sublime Light', c:['#fc5c7d','#6a82fb']},
    {n:'Pun Yeta', c:['#108dc7','#ef8e38']},
    {n:'Quepal', c:['#11998e','#38ef7d']},
    {n:'Sand to Blue', c:['#3e5151','#decba4']},
    {n:'Wedding Day Blues', c:['#40e0d0','#ff8c00','#ff0080']},
    {n:'Shifter', c:['#bc4e9c','#f80759']},
    {n:'Red Sunset', c:['#355c7d','#6c5b7b','#c06c84']},
    {n:'Moon Purple', c:['#4e54c8','#8f94fb']},
    {n:'Pure Lust', c:['#333333','#dd1818']},
    {n:'Slight Ocean View', c:['#a8c0ff','#3f2b96']},
    {n:'eXpresso', c:['#ad5389','#3c1053']},
    {n:'Shifty', c:['#636363','#a2ab58']},
    {n:'Vanusa', c:['#da4453','#89216b']},
    {n:'Evening Night', c:['#005aa7','#fffde4']},
    {n:'Magic', c:['#59c173','#a17fe0','#5d26c1']},
    {n:'Margo', c:['#ffefba','#ffffff']},
    {n:'Blue Raspberry', c:['#00b4db','#0083b0']},
    {n:'Citrus Peel', c:['#fdc830','#f37335']},
    {n:'Sin City Red', c:['#ed213a','#93291e']},
    {n:'Rastafari', c:['#1e9600','#fff200','#ff0000']},
    {n:'Summer Dog', c:['#a8ff78','#78ffd6']},
    {n:'Wiretap', c:['#8a2387','#e94057','#f27121']},
    {n:'Burning Orange', c:['#ff416c','#ff4b2b']},
    {n:'Ultra Voilet', c:['#654ea3','#eaafc8']},
    {n:'By Design', c:['#009fff','#ec2f4b']},
    {n:'Kyoo Tah', c:['#544a7d','#ffd452']},
    {n:'Kye Meh', c:['#8360c3','#2ebf91']},
    {n:'Kyoo Pal', c:['#dd3e54','#6be585']},
    {n:'Metapolis', c:['#659999','#f4791f']},
    {n:'Flare', c:['#f12711','#f5af19']},
    {n:'Witching Hour', c:['#c31432','#240b36']},
    {n:'Azur Lane', c:['#7f7fd5','#86a8e7','#91eae4']},
    {n:'Neuromancer', c:['#f953c6','#b91d73']},
    {n:'Harvey', c:['#1f4037','#99f2c8']},
    {n:'Amin', c:['#8e2de2','#4a00e0']},
    {n:'Memariani', c:['#aa4b6b','#6b6b83','#3b8d99']},
    {n:'Yoda', c:['#ff0099','#493240']},
    {n:'Cool Sky', c:['#2980b9','#6dd5fa','#ffffff']},
    {n:'Dark Ocean', c:['#373b44','#4286f4']},
    {n:'Evening Sunshine', c:['#b92b27','#1565c0']},
    {n:'JShine', c:['#12c2e9','#c471ed','#f64f59']},
    {n:'Moonlit Asteroid', c:['#0f2027','#203a43','#2c5364']},
    {n:'MegaTron', c:['#c6ffdd','#fbd786','#f7797d']},
    {n:'Cool Blues', c:['#2193b0','#6dd5ed']},
    {n:'Piggy Pink', c:['#ee9ca7','#ffdde1']},
    {n:'Grade Grey', c:['#bdc3c7','#2c3e50']},
    {n:'Telko', c:['#f36222','#5cb644','#007fc3']},
    {n:'Zenta', c:['#2a2d3e','#fecb6e']},
    {n:'Electric Peacock', c:['#8a2be2','#0000cd','#228b22','#ccff00']},
    {n:'Under Blue Green', c:['#051937','#004d7a','#008793','#00bf72','#a8eb12']},
    {n:'Lensod', c:['#6025f5','#ff5555']},
    {n:'Newspaper', c:['#8a2be2','#ffa500','#f8f8ff']},
    {n:'Dark Blue Gradient', c:['#2774ae','#002e5d','#002e5d']},
    {n:'Dark Blu Two', c:['#004680','#4484ba']},
    {n:'Lemon Lime', c:['#7ec6bc','#ebe717']},
    {n:'Beleko', c:['#ff1e56','#f9c942','#1e90ff']},
    {n:'Mango Papaya', c:['#de8a41','#2ada53']},
    {n:'Unicorn Rainbow', c:['#f7f0ac','#acf7f0','#f0acf7']},
    {n:'Flame', c:['#ff0000','#fdcf58']},
    {n:'Blue Red', c:['#36b1c7','#960b33']},
    {n:'Twitter', c:['#1da1f2','#009ffc']},
    {n:'Blooze', c:['#6da6be','#4b859e','#6da6be']},
    {n:'Blue Slate', c:['#b5b9ff','#2b2c49']},
    {n:'Space Light Green', c:['#9fa0a8','#5c7852']},
    {n:'Flower', c:['#dcffbd','#cc86d1']},
    {n:'Elate The Euge', c:['#8bdeda','#43add0','#998ee0','#e17dc2','#ef9393']},
    {n:'Peach Sea', c:['#e6ae8c','#a8cecf']},
    {n:'Abbas', c:['#00fff0','#0083fe']},
    {n:'Winter Woods', c:['#333333','#a2ab58','#a43931']},
    {n:'Ameena', c:['#0c0c6d','#de512b','#98d0c1','#5bb226','#023c0d']},
    {n:'Emerald Sea', c:['#05386b','#5cdb95']},
    {n:'Bleem', c:['#4284db','#29eac4']},
    {n:'Coffee Gold', c:['#554023','#c99846']},
    {n:'Compass', c:['#516b8b','#056b3b']},
    {n:'Andreuzza\'s', c:['#d70652','#ff025e']},
    {n:'Moonwalker', c:['#152331','#000000']},
    {n:'Whinehouse', c:['#f7f7f7','#b9a0a0','#794747','#4e2020','#111111']},
    {n:'Hyper Blue', c:['#59cde9','#0a2a88']},
    {n:'Racker', c:['#eb0000','#95008a','#3300fc']},
    {n:'After the Rain', c:['#ff75c3','#ffa647','#ffe83f','#9fff5b','#70e2ff','#cd93ff']},
    {n:'Neon Green', c:['#81ff8a','#64965e']},
    {n:'Dusty Grass', c:['#d4fc79','#96e6a1']},
    {n:'Visual Blue', c:['#003d4d','#00c996']},
  ];
  const PICKS = [
    'Purple', 'Ibtesam', 'Radioactive Heat', 'The Sky And The Sea',
    'Blue & Orange', 'Ver', 'Bluelagoo', 'Lunada',
    'Mango', 'Rea', 'Sel', 'Skyline',
    'DIMIGO', 'Blooker20', 'Harmonic Energy', 'Intuitive Purple',
    'Horizon', 'Rose Water', 'Mango Pulp', 'Bloody Mary',
    'Sunrise', 'Purple Paradise', 'Stripe', 'Sea Weed',
    'Pinky', 'Mojito', 'Electric Violet', 'Venice Blue',
    'Bora Bora', 'Sea Blizz', 'Opa', 'Miaka',
    'Day Tripper', 'Blurry Beach', 'Kyoto', 'Misty Meadow',
    'Reef', 'Dance To Forget', 'Starfall', 'Teal Love',
    'Neon Life', 'Cheer Up Emo Kid', 'Facebook Messenger', 'SoundCloud',
    'Martini', 'Crazy Orange I', 'Predawn', 'Endless River',
    'Atlas', 'Instagram', 'Virgin America', 'Fresh Turboscent',
    'Ukraine', 'Timber', 'Master Card', 'Back To Earth',
    'Back to the Future', 'Blush', 'Pizelex', 'Minnesota Vikings',
    'Superman', 'Ali', 'Alihossein', 'Shahabi',
    'Transfile', 'Politics', 'Bright Vault', 'Grapefruit Sunset',
    'Dusk', 'Sherbert', 'Jupiter', 'Azure Pop',
    'Nepal', 'Cosmic Fusion', 'Brady Brady Fun Fun', 'Ibiza Sunset',
    'Dawn', 'Vice City', 'Jodhpur', 'Cocoaa Ice',
    'EasyMed', 'Honey Dew', 'Mini', 'Sunkist',
    'Blue Skies', 'Chitty Chitty Bang Bang', 'Relay', 'Alive',
    'Scooter', 'Purpink', 'Orange Coral', 'Summer',
    'King Yna', 'Hydrogen', 'Argon', 'Orange Fun',
    'Rainbow Blue', 'Pink Flavour', 'Ohhappiness', 'Relaxing red',
    'Sublime Vivid', 'Sublime Light', 'Pun Yeta', 'Quepal',
    'Wedding Day Blues', 'Shifter', 'Slight Ocean View', 'Vanusa',
    'Evening Night', 'Magic', 'Citrus Peel', 'Rastafari',
    'Wiretap', 'Burning Orange', 'By Design', 'Kyoo Tah',
    'Kyoo Pal', 'Metapolis', 'Flare', 'Evening Sunshine',
    'JShine', 'Telko', 'Zenta', 'Electric Peacock',
    'Lensod', 'Newspaper', 'Lemon Lime', 'Beleko',
    'Mango Papaya', 'Flame', 'Blue Red', 'Elate The Euge',
    'Abbas', 'Ameena', 'Emerald Sea', 'Bleem',
    'Hyper Blue', 'Racker', 'After the Rain',
  ];
  const byName = {}; ALL.forEach(g => byName[g.n] = g);
  return { ALL, PICKS, byName, pick: n => byName[n] };
})();

/* ---- palettes.js ---- */
// MORPHING GRADIENTS — two sources, one interface.
//
//   'ui'      the installed uiGradients library (gradients.js), morphing
//             between named designer gradients.
//   'cosine'  Inigo Quilez's formula, from awesome-gradient's CosineGradient
//             entry: colour(t) = a + b*cos(2pi*(c*t + d)). Twelve floats
//             describe a whole gradient, so it generates rather than recalls.
//
// A CORRECTION TO THE FIRST TAKE. The reason cosine palettes looked like the
// only option for morphing was that raw colour stops cannot be interpolated
// into each other — different stop counts, different positions, and every
// halfway state is a guess. That is true of the stops. It is not true once both
// gradients are resampled to a LUT of the same length: equal-length LUTs lerp
// entry-for-entry, and in OKLab every intermediate stays saturated. So the
// named gradients morph perfectly well, and they are what a person actually
// wants to look at.
//
// Both sources are resampled MIRRORED — a linear gradient run around a ring
// cycle would show a hard seam where its end meets its start, so it plays out
// and back instead.
window.PALETTES = (function(){
'use strict';

// ---- OKLab. Defined here because this file loads first; rainbow.js uses it.
const s2l = c => { c /= 255; return c <= 0.04045 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4); };
const l2s = c => { const v = c <= 0.0031308 ? c * 12.92 : 1.055 * Math.pow(Math.max(0, c), 1/2.4) - 0.055;
                   return Math.max(0, Math.min(255, v * 255)); };
function toLab(c){
  const R = s2l(c[0]), G = s2l(c[1]), B = s2l(c[2]);
  const l = Math.cbrt(0.4122214708*R + 0.5363325363*G + 0.0514459929*B);
  const m = Math.cbrt(0.2119034982*R + 0.6806995451*G + 0.1073969566*B);
  const s = Math.cbrt(0.0883024619*R + 0.2817188376*G + 0.6299787005*B);
  return [0.2104542553*l + 0.7936177850*m - 0.0040720468*s,
          1.9779984951*l - 2.4285922050*m + 0.4505937099*s,
          0.0259040371*l + 0.7827717662*m - 0.8086757660*s];
}
function fromLab(L){
  const l = Math.pow(L[0] + 0.3963377774*L[1] + 0.2158037573*L[2], 3);
  const m = Math.pow(L[0] - 0.1055613458*L[1] - 0.0638541728*L[2], 3);
  const s = Math.pow(L[0] - 0.0894841775*L[1] - 1.2914855480*L[2], 3);
  return [l2s( 4.0767416621*l - 3.3077115913*m + 0.2309699292*s),
          l2s(-1.2684380046*l + 2.6097574011*m - 0.3413193965*s),
          l2s(-0.0041960863*l - 0.7034186147*m + 1.7076147010*s)];
}
window.OKLAB = { toLab, fromLab };

const TAU = Math.PI * 2;
const LUTN = 96;                       // entries per gradient, in OKLab

// ---- cosine source ---------------------------------------------------------
// Keep b comfortably under a (roughly b <= a - 0.12) so nothing bottoms out at
// pure black. The textbook IQ presets use a = b = 0.5, which swings the full
// 0..1 and puts black rings in the machine — a hole rather than a colour.
const COS = [
  { name: 'FAIRGROUND', a:[0.58,0.58,0.58], b:[0.42,0.42,0.42], c:[1.0,1.0,1.0], d:[0.00,0.33,0.67] },
  { name: 'FORECOURT',  a:[0.60,0.58,0.52], b:[0.40,0.42,0.40], c:[1.0,1.0,0.5], d:[0.80,0.90,0.30] },
  { name: 'SEASIDE',    a:[0.56,0.60,0.62], b:[0.40,0.38,0.34], c:[1.0,1.0,1.0], d:[0.30,0.20,0.20] },
  { name: 'BUBBLEGUM',  a:[0.70,0.56,0.60], b:[0.28,0.36,0.36], c:[1.0,1.0,1.0], d:[0.00,0.10,0.20] },
  { name: 'FORECAST',   a:[0.58,0.58,0.62], b:[0.40,0.40,0.34], c:[2.0,1.0,1.0], d:[0.50,0.20,0.25] },
  { name: 'CITRUS',     a:[0.66,0.62,0.48], b:[0.32,0.34,0.34], c:[1.0,1.0,0.5], d:[0.00,0.15,0.35] },
  { name: 'AQUARIUM',   a:[0.54,0.62,0.66], b:[0.38,0.34,0.32], c:[1.0,1.0,1.0], d:[0.60,0.70,0.85] },
  { name: 'SUNSTROKE',  a:[0.72,0.54,0.46], b:[0.26,0.38,0.34], c:[1.0,1.0,1.0], d:[0.00,0.20,0.45] },
];

function cosLUT(p){
  const lut = new Float32Array(LUTN * 3);
  for (let i = 0; i < LUTN; i++){
    let u = i / LUTN;
    u = u < 0.5 ? u * 2 : 2 - u * 2;
    const rgb = [0,0,0];
    for (let j = 0; j < 3; j++){
      const v = p.a[j] + p.b[j] * Math.cos(TAU * (p.c[j] * u + p.d[j]));
      rgb[j] = (v < 0 ? 0 : v > 1 ? 1 : v) * 255;
    }
    const lab = toLab(rgb);
    lut[i*3] = lab[0]; lut[i*3+1] = lab[1]; lut[i*3+2] = lab[2];
  }
  return lut;
}

// ---- uiGradients source ----------------------------------------------------
function hexRGB(h){ return [parseInt(h.slice(1,3),16), parseInt(h.slice(3,5),16), parseInt(h.slice(5,7),16)]; }

function stopsLUT(colors){
  const stops = colors.map(c => toLab(hexRGB(c)));
  const lut = new Float32Array(LUTN * 3);
  for (let i = 0; i < LUTN; i++){
    let u = i / LUTN;
    u = u < 0.5 ? u * 2 : 2 - u * 2;                 // mirrored, so the ring has no seam
    const s = u * (stops.length - 1);
    const k = Math.min(stops.length - 2, Math.floor(s)), f = s - k;
    for (let j = 0; j < 3; j++) lut[i*3+j] = stops[k][j] + (stops[k+1][j] - stops[k][j]) * f;
  }
  return lut;
}

// ---- the morph -------------------------------------------------------------
let source = 'ui';
const cache = new Map();
let names = [];

function rebuild(){
  cache.clear();
  if (source === 'cosine') names = COS.map(p => p.name);
  else names = (window.UIGRADIENTS ? window.UIGRADIENTS.PICKS : []).slice();
  if (!names.length) { source = 'cosine'; names = COS.map(p => p.name); }
}

function lutFor(name){
  let l = cache.get(name);
  if (l) return l;
  if (source === 'cosine') l = cosLUT(COS.find(p => p.name === name));
  else l = stopsLUT(window.UIGRADIENTS.byName[name].c);
  cache.set(name, l);
  return l;
}

const curLab = new Float32Array(LUTN * 3);
const curRGB = new Uint8Array(LUTN * 3);
const out = [0, 0, 0];
let label = '';

function ease(t){ return t * t * t * (t * (t * 6 - 15) + 10); }

// Set the morph state at time `t` seconds. Each gradient holds, then crosses.
function morphTo(t, period){
  if (!names.length) rebuild();
  const s = t / period;
  const i = Math.floor(s);
  const f = ease(Math.min(1, Math.max(0, (s - i) * 1.6 - 0.3)));
  const A = lutFor(names[((i % names.length) + names.length) % names.length]);
  const B = lutFor(names[(((i + 1) % names.length) + names.length) % names.length]);
  for (let k = 0; k < LUTN * 3; k++) curLab[k] = A[k] + (B[k] - A[k]) * f;
  // one fromLab per entry per update, not per pixel per frame
  for (let i2 = 0; i2 < LUTN; i2++){
    const c = fromLab([curLab[i2*3], curLab[i2*3+1], curLab[i2*3+2]]);
    curRGB[i2*3] = c[0]; curRGB[i2*3+1] = c[1]; curRGB[i2*3+2] = c[2];
  }
  const n = f > 0.5 ? i + 1 : i;
  label = names[((n % names.length) + names.length) % names.length];
}

// Sample the current gradient. u is 0..1 around the cycle.
function at(u){
  let i = Math.floor(((u % 1) + 1) % 1 * LUTN);
  if (i >= LUTN) i = LUTN - 1;
  out[0] = curRGB[i*3]; out[1] = curRGB[i*3+1]; out[2] = curRGB[i*3+2];
  return out;
}

rebuild();
return {
  morphTo, at,
  label: () => label,
  get source(){ return source; },
  setSource(s){ if (s !== source){ source = s; rebuild(); } return source; },
  count: () => names.length,
};
})();

/* ---- rainbow.js ---- */
// The ring pattern — shared by the machine and by the dogs that come out of it.
//
// Four colours, always in this order, repeating outward from the centre:
// YELLOW, GREEN, BLUE, RED — a yellow core out to a red rim.
//
// This matches the mark. brand-bible/logo-seven draws the orb yellow-centred in
// both the logo sheet and the illuminated sign, and the machine has to be the
// same object as the logo or the whole idea comes apart. The machine wears it and stamps it onto whatever
// walks through, which is why both live in one file.
//
// Three ways of getting from one colour to the next. Press G in the piece.
// ONLY THOSE FOUR COLOURS? Then the mode is `dither`, and it is the only one.
// A blended gradient cannot obey that constraint: interpolating red into blue
// produces magenta, blue into green produces teal. The way to have a gradient
// AND a four-colour palette is to stop mixing pigment and mix PIXELS instead —
// every pixel is exactly one of the four, and the blend happens in the eye.
//
//   blend   a gradient. Interpolated in OKLab, not RGB — a straight RGB lerp
//           from yellow to blue runs through grey and the middle of the cube
//           goes muddy. Each colour also holds flat for the first and last
//           quarter of its ring, so it stays a recognisable colour with a
//           blend between, rather than a continuous smear of nothing.
//   dither  Bayer 4x4 across that same transition zone. Flat colour, dithered
//           edge, flat colour. Exactly four colours up close.
//   band    hard cut. Poster.
//
// RING WIDTH IS RELATIVE TO THE SUBJECT, not fixed. A fixed width means a
// labrador shows five rings and a chihuahua shows two, and the small dogs stop
// reading as the same pattern. Every subject gets the same number of cycles
// from its own centre to its own corner instead.
//
// PHASE is passed as 0..1 of a full four-colour cycle, never in pixels, so the
// cube and every dog drift outward at the same *rate* despite having different
// ring widths. The dogs' fur does what the machine does.
window.RINGS = (function(){
'use strict';
const hex = h => [parseInt(h.slice(1,3),16), parseInt(h.slice(3,5),16), parseInt(h.slice(5,7),16)];
const COLS = ['yellow','green','blue','red'].map(k => hex(RR.LIGHTS[k]));
// 'morph' is the odd one out: the other three ring the four brand lights, it
// rings a cosine palette that is itself changing. See palettes.js.
// The first three ring the four brand lights and differ only in finish. The
// last two ring a gradient that is itself changing: 'morph' recalls the
// installed uiGradients library, 'cosine' generates.
const MODES = ['blend', 'dither', 'band', 'morph', 'cosine'];
const MORPH_PERIOD = 9;     // seconds a palette holds before crossing to the next
const MORPH_STOPS = 4;      // flat fields per cycle, so HOLD still means something
let morphT = 0;             // seconds; the scene drives this
// ONE full pass through the four colours from centre to rim — red core, then
// blue, green, yellow at the edge, and it stops there. Above 1.0 the sequence
// starts over before it reaches the edge and you get red at the core AND the
// rim, which reads as a target rather than as one gradient.
const CYCLES = 1.0;

// THE PORTAL is tuned to the CSS orb in site.css, so the thing the dogs walk
// through and the thing in the header are the same object moving the same way.
//   entry on BLUE      -> rot 2 (the loop is yellow, green, blue, red)
//   band 29% of radius -> 100/116 of a full cycle fits inside the rim
//   11s, inward        -> drift runs the other way from the dogs'
// Changing the CSS orb without changing these is how the two silently drift
// apart, so they are commented in both places.
// `inward` is read now instead of being assumed. The portal PULSES OUT: the
// bands travel from the core to the rim, which reads as light leaving the orb
// rather than the orb swallowing it — and it is the same direction the dogs
// walk, so the whole scene moves one way.
// `rot` is where the loop is entered, and it decides the colour at the core:
// COLS is yellow, green, blue, red, so rot 1 puts GREEN in the middle and the
// rest follow it out. It was 2, which started on blue.
const ORB = { rot: 1, cycles: 100 / 116, driftMs: 11000, inward: false };
const MIN_RING = 1.8;       // below this the rings are thinner than a pixel
// Fraction of a ring each colour holds flat at each end. This is the crispness
// dial, and it matters more than resolution does: at 0.25 half of every ring is
// transition and the whole thing reads soft no matter how many device pixels it
// is drawn with. At 0.40 only a fifth of the ring is moving, so each colour is
// a flat, confident field with a clean edge into the next.
let HOLD = 0.40;
const DRIFT_MS = 4000;      // one full four-colour cycle
const STEPS = 24;           // baked phases per cycle
let mode = 'blend';

const BAYER = [0,8,2,10, 12,4,14,6, 3,11,1,9, 15,7,13,5].map(v => (v + 0.5) / 16);
const mod = (v, n) => ((v % n) + n) % n;

// ---- OKLab lives in palettes.js, which loads first -------------------------
const toLab = OKLAB.toLab, fromLab = OKLAB.fromLab;

// hold, then ease across, then hold. smootherstep rather than smoothstep — it
// spends less of the transition near the endpoints, which keeps the flat fields
// looking flat right up to the edge.
function ramp(f){
  let t = (f - HOLD) / (1 - HOLD * 2);
  t = t < 0 ? 0 : t > 1 ? 1 : t;
  return t * t * t * (t * (t * 6 - 15) + 10);
}

// one loop of the cycle, baked once — cbrt per pixel per frame is not free
const N = 512;
const LUT = new Uint8Array(N * 3);
const LAB = COLS.map(toLab);
function buildLUT(){
  for (let i = 0; i < N; i++){
    const t = i / N * 4, k = Math.floor(t), f = ramp(t - k);
    const a = LAB[mod(k, 4)], b = LAB[mod(k + 1, 4)];
    const c = fromLab([a[0] + (b[0]-a[0])*f, a[1] + (b[1]-a[1])*f, a[2] + (b[2]-a[2])*f]);
    LUT[i*3] = c[0]; LUT[i*3+1] = c[1]; LUT[i*3+2] = c[2];
  }
}
buildLUT();

// The ring width that gives `CYCLES` cycles between a subject's centre and its
// furthest corner.
function ringFor(halfW, halfH){
  return Math.max(MIN_RING, Math.hypot(halfW, halfH) / (CYCLES * 4));
}

const out = [0, 0, 0];
function colAt(dist, ring, phase01, x, y, rot){
  const t = dist / ring - phase01 * 4 + (rot || 0);
  const k = Math.floor(t), f = t - k;
  if (mode === 'morph' || mode === 'cosine'){
    // Posterise around the cycle so the crispness dial still applies — without
    // it a cosine palette is a continuous smear and the piece loses its edges.
    const u = ((t / 4) % 1 + 1) % 1;
    const s = u * MORPH_STOPS, sk = Math.floor(s), sf = ramp(s - sk);
    const A = PALETTES.at(sk / MORPH_STOPS);
    const a0 = A[0], a1 = A[1], a2 = A[2];
    const B = PALETTES.at((sk + 1) / MORPH_STOPS);
    out[0] = a0 + (B[0] - a0) * sf;
    out[1] = a1 + (B[1] - a1) * sf;
    out[2] = a2 + (B[2] - a2) * sf;
    return out;
  }
  if (mode === 'band'){ const c = COLS[mod(k, 4)]; out[0]=c[0]; out[1]=c[1]; out[2]=c[2]; return out; }
  if (mode === 'dither'){
    const c = ramp(f) > BAYER[((y & 3) << 2) | (x & 3)] ? COLS[mod(k+1, 4)] : COLS[mod(k, 4)];
    out[0]=c[0]; out[1]=c[1]; out[2]=c[2]; return out;
  }
  const i = mod(Math.round((k + f) / 4 * N), N) * 3;
  out[0] = LUT[i]; out[1] = LUT[i+1]; out[2] = LUT[i+2];
  return out;
}

// Recolour a baked sprite in place: same pattern, centred on the animal, sized
// to the animal, with its own shading folded back in so it still reads as a dog
// and keeps an eye.
function stamp(g, W, H, phase01){
  const img = g.getImageData(0, 0, W, H), d = img.data;
  let lo = W, hi = 0, top = H, bot = 0, total = 0;
  const lum = new Float32Array(W * H);
  const census = new Map();
  for (let y = 0; y < H; y++) for (let x = 0; x < W; x++){
    const i = y * W + x;
    if (d[i*4+3] < 8) continue;
    const R = d[i*4], G = d[i*4+1], B = d[i*4+2];
    lum[i] = 0.299*R + 0.587*G + 0.114*B;
    total++;
    if (x < lo) lo = x; if (x > hi) hi = x;
    if (y < top) top = y; if (y > bot) bot = y;
    const k = (R << 16) | (G << 8) | B;
    const e = census.get(k);
    if (e) e.n++; else census.set(k, {n: 1, l: lum[i]});
  }
  if (total < 8) return;
  const cx = (lo + hi) / 2, cy = (top + bot) / 2;
  const ring = ringFor((hi - lo) / 2, (bot - top) / 2);

  // WHICH DARK IS WHICH.
  //
  // Luminance alone cannot tell a black labrador from a dalmatian's spots: on a
  // normalised ramp both read as "the dark end", so the old pass crushed them
  // both towards black. That is right for the dalmatian and wrong for the lab —
  // it put the rainbow over the darkness and the darkest dogs came out muddy
  // when they are the ones that should glow hardest.
  //
  // The tell is the DOMINANT colour. Whatever covers most of the animal is its
  // coat, whatever that coat happens to be. A colour clearly darker than the
  // coat, covering enough area to be a pattern rather than an outline, is a
  // MARKING — the spots, the saddle, the sheepdog's patches — and marks are
  // what make a dog that dog, so they stay dark. Everything else is coat and
  // takes the full colour, black labrador included.
  let dom = null;
  census.forEach(function(e){ if (!dom || e.n > dom.n) dom = e; });
  const domLum = dom.l;
  // 85 is chosen, not guessed. A breed's own shade line sits 45-55 below its
  // base tone (golden retriever 196 -> 143), and a real marking is far further
  // down (saint bernard 238 -> 106, dalmatian white -> black). At 46 the golden
  // read its own legs as markings and walked out of the machine with black
  // socks. Anything between the two is shading and belongs to the coat.
  const MARK_DROP = 85;
  const MARK_MIN  = 0.04;        // and it has to cover 4% — an outline is not a mark
  const INK_MAX   = 0.012;       // eye, nose, collar: too small to be either
  const mark = new Set(), ink = new Set();
  census.forEach(function(e, k){
    const drop = domLum - e.l, share = e.n / total;
    if (share < INK_MAX && drop > MARK_DROP) ink.add(k);
    else if (drop >= MARK_DROP && share >= MARK_MIN) mark.add(k);
  });

  // Shading now runs only across the COAT, and only as far as the coat can
  // afford: a cream chihuahua can take a real shadow, a black newfoundland has
  // no room below it and gets almost none.
  const coatL = [];
  for (let y = 0; y < H; y++) for (let x = 0; x < W; x++){
    const i = y * W + x;
    if (d[i*4+3] < 8) continue;
    const k = (d[i*4] << 16) | (d[i*4+1] << 8) | d[i*4+2];
    if (!mark.has(k) && !ink.has(k)) coatL.push(lum[i]);
  }
  if (coatL.length < 4) return;
  coatL.sort(function(a,b){ return a - b; });
  const p2  = coatL[Math.floor(coatL.length * 0.02)];
  const p98 = coatL[Math.floor(coatL.length * 0.98)];
  const span = Math.max(1, p98 - p2);
  const SHADE = 0.10 + 0.42 * (domLum / 255);
  const LIFT  = 0.30;

  for (let y = 0; y < H; y++) for (let x = 0; x < W; x++){
    const i = y * W + x, o = i * 4;
    if (d[o+3] < 8) continue;
    const k = (d[o] << 16) | (d[o+1] << 8) | d[o+2];
    if (ink.has(k)) continue;                       // an eye is an eye

    const c = colAt(Math.hypot(x - cx, y - cy), ring, phase01 || 0, x, y);
    let r = c[0], g2 = c[1], b = c[2];

    if (mark.has(k)){
      // the mark reads as a mark, not as a shadow laid over the colour
      r += (18 - r) * 0.84; g2 += (18 - g2) * 0.84; b += (22 - b) * 0.84;
      d[o] = r|0; d[o+1] = g2|0; d[o+2] = b|0;
      continue;
    }

    let q = (lum[i] - p2) / span;
    q = q < 0 ? 0 : q > 1 ? 1 : q;
    if (q < 0.30){
      const f = (0.30 - q) / 0.30 * SHADE;
      r += (14 - r) * f; g2 += (14 - g2) * f; b += (18 - b) * f;
    } else if (q > 0.80){
      const f = (q - 0.80) / 0.20 * LIFT;
      r += (255 - r) * f; g2 += (255 - g2) * f; b += (255 - b) * f;
    }
    d[o] = r|0; d[o+1] = g2|0; d[o+2] = b|0;
  }
  g.putImageData(img, 0, 0);
}

// The machine's face. One canvas per (mode, size, phase step), built with
// putImageData and then blitted — painting it per frame meant a fillStyle
// string per pixel and 1156 of them a frame, which is where the frame rate
// went. A canvas gradient is not an option: it antialiases, and the upscale
// smears it.
// The 4K path. In blend mode the machine's face is not drawn on the logical
// pixel grid at all — it is a real canvas radial gradient, so it resolves at
// whatever the device can actually show while the dogs in front of it stay on
// the grid. Canvas gradients interpolate in sRGB between stops, which would
// undo the OKLab work, so the ramp is sampled densely enough (96 stops) that
// the sRGB error between neighbours is invisible.
function squareGradient(ctx, x0, y0, size, phase01, disc){
  const cx = x0 + size / 2, cy = y0 + size / 2;
  const base = disc ? size / 2 * 0.70711 : size / 2;
  const ring = ringFor(base, base) / (disc ? ORB.cycles : 1);
  if (disc && ORB.inward) phase01 = -phase01;      // see ORB.inward
  const maxR = disc ? size / 2 : size * 0.70711;   // radius, or corner of the square
  const g = ctx.createRadialGradient(cx, cy, 0, cx, cy, maxR);
  const STOPS = 192;
  for (let i = 0; i <= STOPS; i++){
    const c = colAt(maxR * i / STOPS, ring, phase01, 0, 0, disc ? ORB.rot : 0);
    g.addColorStop(i / STOPS, 'rgb(' + (c[0]|0) + ',' + (c[1]|0) + ',' + (c[2]|0) + ')');
  }
  ctx.fillStyle = g;
  if (disc){
    ctx.save();
    ctx.beginPath();
    ctx.arc(cx, cy, size / 2, 0, Math.PI * 2);
    ctx.fill();
    ctx.restore();
  } else {
    ctx.fillRect(x0, y0, size, size);
  }
}

// The machine's face as a disc. Same pattern, masked to a circle — and the
// edge is HARD, not feathered. A soft rim would be closer to the reference but
// it is partially transparent, and the whole point of the machine is that a dog
// disappears behind it. You would see the dog through the glow.
const sqCache = new Map();
function squareCanvas(size, step, disc){
  const id = mode + '#' + size + '#' + step + (disc ? '#o' : '');
  const hit = sqCache.get(id);
  if (hit) return hit;
  const c = document.createElement('canvas');
  c.width = size; c.height = size;
  const g = c.getContext('2d');
  const img = g.createImageData(size, size), d = img.data;
  const cx = size / 2, cy = size / 2;
  // For a disc the furthest point is the radius, not the corner
  // The portal gets ORB's cycle count, not the cast's.
  const base = disc ? size / 2 * 0.70711 : size / 2;
  const ring = ringFor(base, base) / (disc ? ORB.cycles : 1);
  const ph = (disc ? -1 : 1) * step / STEPS, R = size / 2;
  for (let y = 0; y < size; y++) for (let x = 0; x < size; x++){
    const dist = Math.hypot(x + 0.5 - cx, y + 0.5 - cy);
    const o = (y * size + x) * 4;
    if (disc && dist > R){ d[o+3] = 0; continue; }
    const col = colAt(dist, ring, ph, x, y, disc ? ORB.rot : 0);
    d[o] = col[0]; d[o+1] = col[1]; d[o+2] = col[2]; d[o+3] = 255;
  }
  g.putImageData(img, 0, 0);
  sqCache.set(id, c);
  return c;
}

return {
  COLS, MODES, stamp, squareCanvas, squareGradient, ringFor, DRIFT_MS, STEPS, ORB,
  get mode(){ return mode; },
  setMode(m){
    if (MODES.indexOf(m) >= 0){
      mode = m;
      sqCache.clear();
      if (m === 'morph' || m === 'cosine') PALETTES.setSource(m === 'cosine' ? 'cosine' : 'ui');
    }
    return mode;
  },
  get morphT(){ return morphT; },
  setMorphT(t){ morphT = t; PALETTES.morphTo(t, MORPH_PERIOD); },
  paletteCount(){ return PALETTES.count(); },
  morphLabel(){ return PALETTES.label(); },
  MORPH_PERIOD,
  get hold(){ return HOLD; },
  setHold(v){
    HOLD = Math.max(0, Math.min(0.48, v));
    buildLUT(); sqCache.clear();
    return HOLD;
  },
};
})();

/* ---- breeds.js ---- */
// BREEDS — lifted verbatim from ~/Tinytown/collection/dog-park/v07.html
// (primitives at lines 55-59, dogShadow at 378, the BR registry at 386-905).
//
// Do not tidy these draw functions. They are the dog-park dogs and they should
// stay diff-able against that file — with two deliberate exceptions, marked
// DIVERGED below and not yet pushed back into dog-park:
//   dachshund — body 14 -> 24 long (w 18 -> 32). It was a short dog.
//   newf      — oval + random fur discs replaced with a real body, chest, legs,
//               head and tail. It rendered as a black amoeba. Everything this piece adds — the rainbow,
// the walk bob, the machine — happens outside, by baking each pose to an
// offscreen canvas and recolouring the bitmap.
window.DOGPARK = (function(){
'use strict';
let ctx = null;
let SHADOWS = true;
const SHADOW = 'rgba(40,30,20,0.22)';

function r(x,y,w,h,c){ctx.fillStyle=c;ctx.fillRect(x|0,y|0,w|0,h|0)}
function p(x,y,c){ctx.fillStyle=c;ctx.fillRect(x|0,y|0,1,1)}
function disc(cx,cy,rr,c){for(let dy=-rr;dy<=rr;dy++){const sp=Math.round(Math.sqrt(rr*rr-dy*dy));r(cx-sp,cy+dy,sp*2,1,c)}}
function oval(cx,cy,rx,ry,c){for(let dy=-ry;dy<=ry;dy++){const sp=Math.round(rx*Math.sqrt(Math.max(0,1-(dy*dy)/(ry*ry))));r(cx-sp,cy+dy,sp*2,1,c)}}
function rng(s){let x=s|0;return()=>{x=(x*1664525+1013904223)|0;return((x>>>0)/4294967296)}}

function dogShadow(cx, gy, w){
  if (!SHADOWS) return;              // off while baking — the scene draws its own
  ctx.fillStyle = SHADOW;
  ctx.beginPath();
  ctx.ellipse(cx, gy+1, w/2, Math.max(1.5, w*0.10), 0, 0, Math.PI*2);
  ctx.fill();
}

const BR = {};

BR.chihuahua = {name:"chihuahua", w:9, h:8, size:'tiny',
  draw(cx,gy,t,mood,dir){
    dogShadow(cx,gy,9);
    const C1='#fff5dd', C2='#d8c8a8', C3='#7a6240', N='#1a0a04';
    const dy = mood==='squat'?2:0;
    r(cx-3,gy-5+dy,6,3,C1);
    r(cx-3,gy-5+dy,6,1,C2);
    // legs
    r(cx-2,gy-2+dy,1,2,C2); r(cx+1,gy-2+dy,1,2,C2);
    r(cx-3,gy-2+dy,1,2,C2); r(cx+2,gy-2+dy,1,2,C2);
    // head
    r(cx+4*dir,gy-7+dy,3,3,C1);
    p(cx+4*dir,gy-7+dy,C2);
    // big ears
    r(cx+3*dir,gy-9+dy,1,3,C2);
    r(cx+5*dir,gy-9+dy,1,3,C2);
    // eye
    p(cx+5*dir,gy-6+dy,N);
    // nose
    p(cx+6*dir,gy-5+dy,N);
    // perky tail
    r(cx-3*dir,gy-7+dy,1,3,C2);
    p(cx-4*dir,gy-7+dy,C2);
  }
};

BR.dachshund = {name:"dachshund", w:32, h:7, size:'small',
  draw(cx,gy,t,mood,dir){
    dogShadow(cx,gy,32);
    const C1='#8a4a1a', C2='#5a2a10', C3='#2a1006', N='#1a0802';
    const dy = mood==='squat'?2:0;
    // body — 24 long against 3 tall. The breed IS this ratio, so it is the one
    // number worth pushing; at 14 long it was just a short dog.
    r(cx-12,gy-4+dy,24,3,C1);
    r(cx-12,gy-4+dy,24,1,C2);
    r(cx-12,gy-2+dy,24,1,C2);
    // legs pushed out to the corners — the span between them is what reads as
    // length. Bunched in the middle and the dog goes back to looking stubby.
    r(cx-11,gy-1+dy,1,2,C2); r(cx-8,gy-1+dy,1,2,C2);
    r(cx+8,gy-1+dy,1,2,C2);  r(cx+11,gy-1+dy,1,2,C2);
    // head
    r(cx+12*dir,gy-5+dy,4,3,C1);
    r(cx+12*dir,gy-5+dy,4,1,C2);
    r(cx+15*dir,gy-4+dy,2,2,C1);
    p(cx+16*dir,gy-3+dy,N);
    r(cx+12*dir,gy-3+dy,2,2,C2);
    p(cx+14*dir,gy-4+dy,N);
    // tail — carried straight out, which lengthens the silhouette again
    r(cx-14*dir,gy-3+dy,3,1,C2);
    p(cx-16*dir,gy-3+dy,C2);
  }
};

BR.dachshundxl = {name:"dachshund, long", w:86, h:8, size:'small',
  draw(cx,gy,t,mood,dir){
    dogShadow(cx,gy,86);
    const C1='#8a4a1a', C2='#5a2a10', C3='#2a1006', N='#1a0802';
    const dy = mood==='squat'?2:0;
    // 76 long against 3 tall. Absurd on purpose. The regular dachshund is the
    // breed; this one is the joke, and a joke about length only lands well past
    // where you would sensibly have stopped. It is now the longest animal in
    // the cast by some margin — longer than the great dane is tall.
    r(cx-38,gy-4+dy,76,3,C1);
    r(cx-38,gy-4+dy,76,1,C2);
    r(cx-38,gy-2+dy,76,1,C2);
    // two sags. 76 pixels of unsupported dog cannot pretend to be a straight
    // line, and one dip in the middle just looks like a mistake.
    r(cx-26,gy-1+dy,20,1,C2);
    r(cx+6,gy-1+dy,20,1,C2);
    // legs at the extremes only, nothing in between to hold any of it up
    r(cx-37,gy-1+dy,1,2,C2); r(cx-34,gy-1+dy,1,2,C2);
    r(cx+34,gy-1+dy,1,2,C2); r(cx+37,gy-1+dy,1,2,C2);
    // head
    r(cx+38*dir,gy-5+dy,4,3,C1);
    r(cx+38*dir,gy-5+dy,4,1,C2);
    r(cx+41*dir,gy-4+dy,2,2,C1);
    p(cx+42*dir,gy-3+dy,N);
    r(cx+38*dir,gy-3+dy,2,2,C2);
    p(cx+40*dir,gy-4+dy,N);
    // tail, a very long way from the head
    r(cx-40*dir,gy-3+dy,3,1,C2);
    p(cx-42*dir,gy-3+dy,C2);
  }
};

BR.corgi = {name:"corgi", w:13, h:9, size:'small',
  draw(cx,gy,t,mood,dir){
    dogShadow(cx,gy,13);
    const C1='#dca658', C2='#a87238', C3='#6a4218', N='#1a0a04', WH='#fff5dd';
    const dy = mood==='squat'?2:0;
    r(cx-5,gy-6+dy,10,5,C1);
    r(cx-5,gy-6+dy,10,1,C2);
    r(cx-5,gy-2+dy,10,1,C2);
    r(cx-1,gy-4+dy,3,3,WH);
    r(cx-4,gy-1+dy,2,2,C2); r(cx+3,gy-1+dy,2,2,C2); r(cx-1,gy-1+dy,2,2,C2);
    p(cx-4,gy,WH); p(cx-3,gy,WH); p(cx+3,gy,WH); p(cx+4,gy,WH);
    r(cx+5*dir,gy-9+dy,4,4,C1);
    p(cx+5*dir,gy-9+dy,C2);
    r(cx+5*dir,gy-11+dy,1,2,C2);
    r(cx+7*dir,gy-11+dy,1,2,C2);
    p(cx+6*dir,gy-7+dy,WH);
    p(cx+6*dir,gy-6+dy,WH);
    p(cx+7*dir,gy-8+dy,N);
    p(cx+8*dir,gy-7+dy,N);
    p(cx-6*dir,gy-5+dy,C2);
    p(cx-6*dir,gy-4+dy,C2);
  }
};

BR.poodle = {name:"poodle", w:14, h:14, size:'medium',
  draw(cx,gy,t,mood,dir){
    dogShadow(cx,gy,14);
    const F1='#fdf6e4', F2='#e6dcc0', F3='#b8a888', N='#2a1a0c';
    const dy = mood==='squat'?2:0;
    disc(cx,gy-5+dy,5,F1);
    disc(cx-3,gy-5+dy,3,F2);
    disc(cx+3,gy-5+dy,3,F2);
    r(cx-3,gy-2+dy,1,3,F3); r(cx+3,gy-2+dy,1,3,F3);
    r(cx-3,gy-1+dy,2,2,F1); r(cx+2,gy-1+dy,2,2,F1);
    disc(cx+2*dir,gy-3+dy,2,F1);
    disc(cx+5*dir,gy-9+dy,3,F1);
    disc(cx+5*dir,gy-11+dy,2,F1);
    r(cx+7*dir,gy-8+dy,3,2,F2);
    p(cx+9*dir,gy-7+dy,N);
    p(cx+6*dir,gy-9+dy,N);
    r(cx+4*dir,gy-7+dy,1,3,F2);
    disc(cx-5*dir,gy-7+dy,2,F1);
  }
};

BR.beagle = {name:"beagle", w:14, h:10, size:'medium',
  draw(cx,gy,t,mood,dir){
    dogShadow(cx,gy,14);
    const C1='#f0deb0', C2='#b48a4a', C3='#5a3814', BRN='#7a4818';
    const dy = mood==='squat'?2:0;
    r(cx-5,gy-7+dy,11,5,C1);
    r(cx-5,gy-7+dy,11,1,C2);
    r(cx-3,gy-7+dy,6,3,BRN);
    p(cx-3,gy-4+dy,BRN); p(cx+2,gy-4+dy,BRN);
    r(cx-4,gy-2+dy,2,3,C1); r(cx+3,gy-2+dy,2,3,C1); r(cx-1,gy-2+dy,2,3,C1);
    r(cx-6*dir,gy-7+dy,3,1,C1);
    p(cx-7*dir,gy-8+dy,C1);
    r(cx+5*dir,gy-9+dy,4,4,C1);
    r(cx+5*dir,gy-9+dy,4,1,BRN);
    r(cx+4*dir,gy-8+dy,1,4,BRN);
    r(cx+9*dir,gy-8+dy,1,4,BRN);
    p(cx+4*dir,gy-4+dy,C3); p(cx+9*dir,gy-4+dy,C3);
    r(cx+8*dir,gy-7+dy,2,2,C1);
    p(cx+9*dir,gy-6+dy,C3);
    p(cx+7*dir,gy-7+dy,C3);
  }
};

BR.golden = {name:"golden retriever", w:22, h:16, size:'large',
  draw(cx,gy,t,mood,dir){
    dogShadow(cx,gy,22);
    const C1='#e8c078', C2='#b88848', C3='#7a5418', N='#1a0a04';
    const dy = mood==='squat'?2:0;
    r(cx-8,gy-10+dy,16,7,C1);
    r(cx-8,gy-10+dy,16,1,C2);
    r(cx-8,gy-4+dy,16,1,C2);
    p(cx-5,gy-3+dy,C1); p(cx-2,gy-3+dy,C1); p(cx+2,gy-3+dy,C1); p(cx+5,gy-3+dy,C1);
    r(cx-7,gy-3+dy,2,4,C2); r(cx+5,gy-3+dy,2,4,C2); r(cx-2,gy-3+dy,2,4,C2);
    r(cx-7,gy,2,1,N); r(cx-2,gy,2,1,N); r(cx+5,gy,2,1,N);
    r(cx-9*dir,gy-9+dy,3,2,C1);
    r(cx-11*dir,gy-8+dy,2,2,C1);
    p(cx-12*dir,gy-7+dy,C2);
    r(cx+8*dir,gy-13+dy,5,5,C1);
    r(cx+8*dir,gy-13+dy,5,1,C2);
    r(cx+7*dir,gy-11+dy,1,4,C2);
    r(cx+13*dir,gy-11+dy,1,4,C2);
    r(cx+12*dir,gy-11+dy,3,3,C1);
    p(cx+14*dir,gy-10+dy,N);
    p(cx+14*dir,gy-9+dy,N);
    p(cx+11*dir,gy-12+dy,N);
    r(cx+8*dir,gy-9+dy,4,1,'#e85a4a');
  }
};

BR.bulldog = {name:"bulldog", w:14, h:10, size:'medium',
  draw(cx,gy,t,mood,dir){
    dogShadow(cx,gy,14);
    const C1='#e8d4a0', C2='#b8a070', C3='#7a6240', WH='#fff5dd', N='#1a0a04';
    const dy = mood==='squat'?2:0;
    r(cx-5,gy-7+dy,10,5,C1);
    r(cx-5,gy-7+dy,10,1,C2);
    r(cx,gy-4+dy,3,3,WH);
    r(cx-4,gy-2+dy,2,3,C2); r(cx+3,gy-2+dy,2,3,C2); r(cx-1,gy-2+dy,2,3,C2);
    r(cx+4*dir,gy-9+dy,6,5,C1);
    r(cx+4*dir,gy-9+dy,6,1,C2);
    r(cx+5*dir,gy-7+dy,4,1,C3);
    p(cx+4*dir,gy-9+dy,C3);
    p(cx+9*dir,gy-9+dy,C3);
    r(cx+5*dir,gy-5+dy,4,1,C1);
    p(cx+5*dir,gy-4+dy,C2); p(cx+9*dir,gy-4+dy,C2);
    r(cx+7*dir,gy-7+dy,2,2,C2);
    p(cx+7*dir,gy-7+dy,N);
    p(cx+6*dir,gy-8+dy,N); p(cx+9*dir,gy-8+dy,N);
    p(cx-6*dir,gy-5+dy,C2);
  }
};

BR.dalmatian = {name:"dalmatian", w:18, h:14, size:'large',
  draw(cx,gy,t,mood,dir){
    dogShadow(cx,gy,18);
    const WH='#fff8e8', GR='#d0c8b0', BK='#1a1208';
    const dy = mood==='squat'?2:0;
    r(cx-7,gy-9+dy,14,6,WH);
    r(cx-7,gy-9+dy,14,1,GR);
    p(cx-5,gy-7+dy,BK); p(cx-2,gy-8+dy,BK); p(cx+1,gy-6+dy,BK);
    p(cx+4,gy-7+dy,BK); p(cx-3,gy-5+dy,BK); p(cx+3,gy-4+dy,BK);
    r(cx-6,gy-3+dy,2,4,WH); r(cx+4,gy-3+dy,2,4,WH); r(cx-1,gy-3+dy,2,4,WH);
    p(cx-5,gy-1+dy,BK); p(cx+5,gy-1+dy,BK);
    r(cx-9*dir,gy-9+dy,3,1,WH);
    p(cx-11*dir,gy-9+dy,WH);
    p(cx-10*dir,gy-9+dy,BK);
    r(cx+7*dir,gy-13+dy,5,5,WH);
    r(cx+7*dir,gy-13+dy,5,1,GR);
    r(cx+6*dir,gy-12+dy,1,4,BK);
    r(cx+11*dir,gy-12+dy,1,4,BK);
    r(cx+11*dir,gy-11+dy,2,2,WH);
    p(cx+12*dir,gy-10+dy,BK);
    p(cx+9*dir,gy-12+dy,BK);
    p(cx+10*dir,gy-12+dy,BK);
  }
};

// Giraffe-tall greyhound — super long legs, small body high up, long neck
BR.greyhound = {name:"greyhound", w:18, h:30, size:'large',
  draw(cx,gy,t,mood,dir){
    dogShadow(cx,gy,16);
    const C1='#a89880', C2='#7a6a52', C3='#4a3a26', N='#1a0a04';
    const dy = mood==='squat'?2:0;
    // very long thin legs (16 tall)
    r(cx-6, gy-16+dy, 1, 16, C2); r(cx-5, gy-16+dy, 1, 16, C3);
    r(cx-3, gy-16+dy, 1, 16, C2); r(cx-2, gy-16+dy, 1, 16, C3);
    r(cx+3, gy-16+dy, 1, 16, C2); r(cx+4, gy-16+dy, 1, 16, C3);
    r(cx+6, gy-16+dy, 1, 16, C2); r(cx+7, gy-16+dy, 1, 16, C3);
    // paws (tiny dark)
    p(cx-6, gy-1, N); p(cx-3, gy-1, N); p(cx+3, gy-1, N); p(cx+6, gy-1, N);
    // small narrow body — tucked tummy
    r(cx-7, gy-21+dy, 14, 5, C1);
    r(cx-7, gy-21+dy, 14, 1, C2);
    r(cx-7, gy-17+dy, 14, 1, C3);
    // tucked underline
    r(cx-3, gy-17+dy, 8, 1, C2);
    // long tail curving
    r(cx-9*dir, gy-20+dy, 3, 1, C2);
    p(cx-11*dir, gy-19+dy, C2);
    p(cx-11*dir, gy-18+dy, C2);
    // long neck (4-5 tall)
    r(cx+5*dir, gy-25+dy, 2, 5, C1);
    p(cx+5*dir, gy-25+dy, C2);
    // small head at top
    r(cx+6*dir, gy-28+dy, 4, 3, C1);
    p(cx+6*dir, gy-28+dy, C2);
    // long snout (pointing forward)
    r(cx+10*dir, gy-27+dy, 2, 2, C1);
    p(cx+11*dir, gy-26+dy, N);
    // pinned-back ear
    r(cx+7*dir, gy-29+dy, 2, 1, C2);
    p(cx+8*dir, gy-30+dy, C3);
    // eye
    p(cx+9*dir, gy-27+dy, N);
  }
};

BR.greatdane = {name:"great dane", w:60, h:60, size:'giant',
  draw(cx,gy,t,mood,dir){
    dogShadow(cx,gy,60);
    const C1='#7c6850', C2='#5a4830', C3='#352816', N='#0a0402';
    const dy = mood==='squat'?4:0;
    r(cx-22,gy-40+dy,42,20,C1);
    r(cx-22,gy-40+dy,42,2,C2);
    r(cx-22,gy-22+dy,42,2,C2);
    for(let i=0;i<8;i++){
      const sx = cx-18+i*5;
      r(sx,gy-38+dy,1,14,C3);
      r(sx+2,gy-36+dy,1,10,C3);
    }
    r(cx-12,gy-20+dy,26,2,C2);
    r(cx-19,gy-20+dy,4,20,C2);
    r(cx-19,gy-20+dy,4,1,C1);
    r(cx+15,gy-20+dy,4,20,C2);
    r(cx+15,gy-20+dy,4,1,C1);
    r(cx-7,gy-20+dy,4,20,C2);
    r(cx+3,gy-20+dy,4,20,C2);
    r(cx-19,gy-1+dy,4,1,N);
    r(cx+15,gy-1+dy,4,1,N);
    r(cx-7,gy-1+dy,4,1,N);
    r(cx+3,gy-1+dy,4,1,N);
    r(cx-24*dir,gy-38+dy,4,2,C1);
    r(cx-28*dir,gy-36+dy,4,2,C1);
    r(cx-31*dir,gy-32+dy,2,4,C2);
    r(cx+18*dir,gy-46+dy,6,8,C1);
    r(cx+18*dir,gy-46+dy,6,1,C2);
    r(cx+22*dir,gy-52+dy,10,8,C1);
    r(cx+22*dir,gy-52+dy,10,1,C2);
    r(cx+22*dir,gy-46+dy,10,1,C2);
    r(cx+22*dir,gy-54+dy,2,3,C2);
    r(cx+28*dir,gy-54+dy,2,3,C2);
    p(cx+22*dir,gy-54+dy,C3); p(cx+29*dir,gy-54+dy,C3);
    r(cx+32*dir,gy-50+dy,5,5,C1);
    r(cx+32*dir,gy-50+dy,5,1,C2);
    p(cx+36*dir,gy-49+dy,N); p(cx+36*dir,gy-48+dy,N);
    p(cx+28*dir,gy-50+dy,N); p(cx+27*dir,gy-50+dy,N);
    r(cx+18*dir,gy-40+dy,3,6,'#e8d8b8');
  }
};

BR.saint = {name:"saint bernard", w:56, h:50, size:'giant',
  draw(cx,gy,t,mood,dir){
    dogShadow(cx,gy,56);
    const WH='#f8edd4', BR1='#9a5e28', BRD='#6a3e14', BRDK='#3a2008', N='#0a0402';
    const dy = mood==='squat'?4:0;
    r(cx-22,gy-32+dy,40,22,WH);
    r(cx-22,gy-32+dy,40,2,'#dccaaa');
    r(cx-15,gy-32+dy,24,14,BR1);
    r(cx-15,gy-32+dy,24,1,BRD);
    r(cx-15,gy-19+dy,24,1,BRD);
    for(let i=0;i<14;i++){
      const fx = cx-22 + i*3;
      p(fx, gy-33+dy, WH);
      p(fx+1, gy-34+dy, WH);
    }
    r(cx-19,gy-12+dy,5,13,WH);
    r(cx+12,gy-12+dy,5,13,WH);
    r(cx-7,gy-12+dy,5,13,WH);
    r(cx+2,gy-12+dy,5,13,WH);
    r(cx-19,gy-6+dy,5,5,BR1);
    r(cx+12,gy-6+dy,5,5,BR1);
    r(cx-19,gy-1+dy,5,1,BRDK);
    r(cx+12,gy-1+dy,5,1,BRDK);
    r(cx-7,gy-1+dy,5,1,BRDK);
    r(cx+2,gy-1+dy,5,1,BRDK);
    r(cx-24*dir,gy-28+dy,4,4,WH);
    r(cx-28*dir,gy-26+dy,3,3,BR1);
    p(cx-30*dir,gy-25+dy,BR1);
    r(cx+16*dir,gy-42+dy,11,10,BR1);
    r(cx+16*dir,gy-42+dy,11,1,BRD);
    r(cx+20*dir,gy-41+dy,3,9,WH);
    r(cx+15*dir,gy-40+dy,2,6,BRD);
    r(cx+26*dir,gy-40+dy,2,6,BRD);
    r(cx+24*dir,gy-36+dy,5,4,WH);
    p(cx+28*dir,gy-35+dy,N); p(cx+28*dir,gy-34+dy,N);
    p(cx+25*dir,gy-32+dy,BR1); p(cx+27*dir,gy-32+dy,BR1);
    p(cx+22*dir,gy-39+dy,N); p(cx+25*dir,gy-39+dy,N);
    p(cx+22*dir,gy-38+dy,N); p(cx+25*dir,gy-38+dy,N);
    r(cx+13*dir,gy-22+dy,4,3,BRD);
    r(cx+13*dir,gy-22+dy,4,1,BR1);
    p(cx+14*dir,gy-23+dy,'#c8c8c8');
  }
};

BR.sheepdog = {name:"sheepdog", w:52, h:44, size:'giant',
  draw(cx,gy,t,mood,dir){
    dogShadow(cx,gy,52);
    const F1='#f0e8d4', F2='#d0c4a8', F3='#a09478', F4='#5a4e36', GR='#7a6c54';
    const dy = mood==='squat'?4:0;
    const seed = rng(cx*13+7);
    oval(cx,gy-22+dy,22,14,F1);
    oval(cx-8,gy-24+dy,10,8,GR);
    oval(cx+10,gy-22+dy,8,6,GR);
    for(let i=0;i<40;i++){
      const ang = (i/40)*Math.PI*2;
      const rr = 20 + (seed()*5)|0;
      const fx = cx + Math.cos(ang)*rr;
      const fy = gy-22+dy + Math.sin(ang)*rr*0.6;
      disc(fx|0, fy|0, 2, F1);
    }
    r(cx-16,gy-8+dy,4,9,F2);
    r(cx+12,gy-8+dy,4,9,F2);
    r(cx-5,gy-8+dy,4,9,F2);
    r(cx+1,gy-8+dy,4,9,F2);
    r(cx-16,gy-1+dy,4,1,F4);
    r(cx+12,gy-1+dy,4,1,F4);
    r(cx-5,gy-1+dy,4,1,F4);
    r(cx+1,gy-1+dy,4,1,F4);
    disc(cx+18*dir,gy-32+dy,10,F1);
    disc(cx+18*dir,gy-30+dy,11,F1);
    disc(cx+20*dir,gy-30+dy,5,GR);
    for(let i=0;i<14;i++){
      const sx = cx+10*dir + i*dir;
      const len = 4 + (i%3);
      r(sx, gy-28+dy, 1, len, F2);
    }
    for(let i=0;i<14;i++){
      const sx = cx+10*dir + i*dir + 1;
      r(sx, gy-27+dy, 1, 5, F1);
    }
    p(cx+22*dir,gy-26+dy,F4); p(cx+23*dir,gy-26+dy,F4);
    p(cx+22*dir,gy-25+dy,'#e88898');
    disc(cx-22*dir,gy-26+dy,4,F1);
    disc(cx-22*dir,gy-26+dy,2,GR);
  }
};

BR.husky = {name:"husky", w:20, h:16, size:'large',
  draw(cx,gy,t,mood,dir){
    dogShadow(cx,gy,20);
    const BK='#3a342a', GR='#9a948a', WH='#fff5e8', N='#1a0a04', BLUE='#7ac0e4';
    const dy = mood==='squat'?2:0;
    r(cx-7,gy-11+dy,14,4,GR);
    r(cx-7,gy-11+dy,14,1,BK);
    r(cx-7,gy-7+dy,14,4,WH);
    r(cx-7,gy-11+dy,4,2,BK);
    r(cx+3,gy-11+dy,4,2,BK);
    r(cx-6,gy-3+dy,2,4,WH); r(cx+4,gy-3+dy,2,4,WH); r(cx-1,gy-3+dy,2,4,WH);
    p(cx-5,gy-1+dy,N); p(cx+5,gy-1+dy,N);
    r(cx-9*dir,gy-12+dy,3,2,GR);
    r(cx-10*dir,gy-11+dy,1,3,GR);
    p(cx-9*dir,gy-13+dy,WH);
    r(cx+7*dir,gy-14+dy,5,5,GR);
    r(cx+7*dir,gy-14+dy,5,1,BK);
    p(cx+7*dir,gy-15+dy,GR); p(cx+8*dir,gy-16+dy,BK);
    p(cx+11*dir,gy-15+dy,GR); p(cx+11*dir,gy-16+dy,BK);
    r(cx+9*dir,gy-12+dy,2,2,WH);
    r(cx+11*dir,gy-11+dy,2,2,WH);
    p(cx+12*dir,gy-10+dy,N);
    p(cx+9*dir,gy-13+dy,BLUE); p(cx+11*dir,gy-13+dy,BLUE);
  }
};

BR.shiba = {name:"shiba inu", w:13, h:12, size:'small',
  draw(cx,gy,t,mood,dir){
    dogShadow(cx,gy,13);
    // red shiba — deep auburn body
    const C1='#c83020', C2='#8a1a14', C3='#5a0a08', WH='#fff5dd', N='#1a0a04';
    const dy = mood==='squat'?2:0;
    r(cx-5,gy-8+dy,10,5,C1);
    r(cx-5,gy-8+dy,10,1,C2);
    r(cx-3,gy-5+dy,6,2,WH);
    r(cx-4,gy-3+dy,2,4,C1); r(cx+3,gy-3+dy,2,4,C1); r(cx-1,gy-3+dy,2,4,C1);
    p(cx-4,gy,WH); p(cx+4,gy,WH); p(cx-1,gy,WH);
    r(cx-6*dir,gy-10+dy,1,2,C1);
    p(cx-6*dir,gy-11+dy,C1); p(cx-7*dir,gy-11+dy,C1);
    p(cx-8*dir,gy-10+dy,C1); p(cx-7*dir,gy-9+dy,C2);
    r(cx+5*dir,gy-11+dy,4,4,C1);
    r(cx+5*dir,gy-11+dy,4,1,C2);
    p(cx+5*dir,gy-12+dy,C2); p(cx+8*dir,gy-12+dy,C2);
    r(cx+8*dir,gy-9+dy,2,2,WH);
    p(cx+9*dir,gy-8+dy,N);
    p(cx+6*dir,gy-10+dy,N); p(cx+7*dir,gy-10+dy,N);
  }
};

BR.collie = {name:"border collie", w:18, h:13, size:'medium',
  draw(cx,gy,t,mood,dir){
    dogShadow(cx,gy,18);
    const BK='#1a1208', WH='#fff5e8', N='#000000';
    const dy = mood==='squat'?2:0;
    r(cx-7,gy-9+dy,14,5,BK);
    r(cx-7,gy-6+dy,14,2,WH);
    r(cx-6,gy-4+dy,2,5,WH); r(cx+4,gy-4+dy,2,5,WH); r(cx-1,gy-4+dy,2,5,WH);
    p(cx-5,gy-1+dy,N); p(cx+5,gy-1+dy,N);
    r(cx-9*dir,gy-7+dy,3,2,BK);
    r(cx-12*dir,gy-6+dy,3,2,BK);
    p(cx-12*dir,gy-5+dy,WH);
    r(cx+7*dir,gy-12+dy,5,5,BK);
    r(cx+9*dir,gy-12+dy,1,5,WH);
    p(cx+7*dir,gy-13+dy,BK); p(cx+11*dir,gy-13+dy,BK);
    r(cx+11*dir,gy-9+dy,2,2,WH);
    p(cx+12*dir,gy-8+dy,N);
    p(cx+8*dir,gy-10+dy,'#7ac0e4');
    p(cx+10*dir,gy-10+dy,N);
  }
};

BR.pug = {name:"pug", w:10, h:8, size:'small',
  draw(cx,gy,t,mood,dir){
    dogShadow(cx,gy,10);
    const C1='#e8d4a0', C2='#b89870', BK='#1a1208', WR='#7a6240';
    const dy = mood==='squat'?2:0;
    r(cx-4,gy-6+dy,8,4,C1);
    r(cx-4,gy-6+dy,8,1,C2);
    r(cx-3,gy-2+dy,1,2,C2); r(cx-1,gy-2+dy,1,2,C2);
    r(cx+1,gy-2+dy,1,2,C2); r(cx+3,gy-2+dy,1,2,C2);
    p(cx-5*dir,gy-5+dy,C2); p(cx-5*dir,gy-6+dy,C2);
    r(cx+4*dir,gy-8+dy,4,4,C1);
    r(cx+4*dir,gy-7+dy,4,2,BK);
    p(cx+4*dir,gy-8+dy,BK); p(cx+7*dir,gy-8+dy,BK);
    r(cx+5*dir,gy-6+dy,2,1,C1);
    p(cx+6*dir,gy-6+dy,BK);
    p(cx+5*dir,gy-7+dy,BK); p(cx+7*dir,gy-7+dy,BK);
    r(cx+5*dir,gy-5+dy,2,1,WR);
  }
};

BR.newf = {name:"newfoundland", w:54, h:48, size:'giant',
  draw(cx,gy,t,mood,dir){
    dogShadow(cx,gy,54);
    const BK='#1f1710', DK='#0d0805', SH='#3a2e22', BRN='#4a3826', WH='#e8dcc4', N='#000000';
    const dy = mood==='squat'?4:0;

    // Body is a heavy block, not an oval. The oval plus a ring of random fur
    // discs is what made this breed read as a black amoeba — nothing in the
    // silhouette said dog, because the legs and chest were inside the blob.
    r(cx-22,gy-32+dy,40,22,BK);
    r(cx-22,gy-32+dy,40,2,DK);
    r(cx-22,gy-12+dy,40,2,DK);
    r(cx-18,gy-31+dy,32,1,SH);            // the coat is oily and takes a hard line

    // shaggy: ticks along the topline, heavier fringe hanging under the belly
    for(let i=0;i<13;i++){ const fx=cx-21+i*3; p(fx,gy-33+dy,BK); p(fx+1,gy-34+dy,DK); }
    for(let i=0;i<12;i++){ const fx=cx-20+i*3; r(fx,gy-11+dy,2,2,DK); }

    // deep chest, dropped below the barrel — this is the newf tell
    r(cx+8,gy-24+dy,12,14,BK);
    r(cx+8,gy-24+dy,12,1,SH);
    r(cx+14,gy-20+dy,4,8,WH);             // white chest flash

    // four thick legs
    r(cx-19,gy-12+dy,6,13,BK);
    r(cx-8,gy-12+dy,6,13,BK);
    r(cx+2,gy-12+dy,6,13,BK);
    r(cx+12,gy-12+dy,6,13,BK);
    r(cx-19,gy-12+dy,6,1,SH); r(cx+12,gy-12+dy,6,1,SH);
    r(cx-19,gy-1+dy,6,1,N); r(cx-8,gy-1+dy,6,1,N);
    r(cx+2,gy-1+dy,6,1,N);  r(cx+12,gy-1+dy,6,1,N);

    // plumed tail — hangs heavy, never curls over the back
    r(cx-26*dir,gy-30+dy,5,5,BK);
    r(cx-29*dir,gy-27+dy,5,9,BK);
    r(cx-29*dir,gy-27+dy,5,1,SH);
    r(cx-28*dir,gy-19+dy,3,3,DK);

    // head — broad and blocky, carried low
    r(cx+16*dir,gy-42+dy,13,11,BK);
    r(cx+16*dir,gy-42+dy,13,1,DK);
    r(cx+18*dir,gy-41+dy,9,1,SH);
    r(cx+15*dir,gy-40+dy,2,5,DK);         // small ears, set close
    r(cx+28*dir,gy-40+dy,2,5,DK);
    r(cx+26*dir,gy-36+dy,6,5,BRN);        // broad square muzzle
    r(cx+26*dir,gy-36+dy,6,1,DK);
    r(cx+30*dir,gy-35+dy,2,2,N);
    // eye is ink plus a catchlight — a plain black pupil vanishes on this coat
    p(cx+21*dir,gy-38+dy,N); p(cx+21*dir,gy-39+dy,WH);
    p(cx+25*dir,gy-38+dy,N);
    r(cx+14*dir,gy-32+dy,4,4,DK);         // ruff at the shoulder
  }
};

BR.lab = {name:"black lab", w:22, h:16, size:'large',
  draw(cx,gy,t,mood,dir){
    dogShadow(cx,gy,22);
    const C1='#1a1208', C2='#0a0604', C3='#2a2018', N='#000000', SH='#3a2e22';
    const dy = mood==='squat'?2:0;
    // body — sleek lab
    r(cx-8,gy-10+dy,16,7,C1);
    r(cx-8,gy-10+dy,16,1,C2);
    r(cx-8,gy-4+dy,16,1,C2);
    // sheen highlight along top
    r(cx-6,gy-10+dy,12,1,SH);
    // legs
    r(cx-7,gy-3+dy,2,4,C1); r(cx+5,gy-3+dy,2,4,C1); r(cx-2,gy-3+dy,2,4,C1);
    r(cx-7,gy,2,1,N); r(cx-2,gy,2,1,N); r(cx+5,gy,2,1,N);
    // otter tail — straight, strong
    r(cx-9*dir,gy-9+dy,3,2,C1);
    r(cx-11*dir,gy-8+dy,2,2,C1);
    p(cx-12*dir,gy-7+dy,C2);
    // head — broad, blocky
    r(cx+8*dir,gy-13+dy,5,5,C1);
    r(cx+8*dir,gy-13+dy,5,1,C2);
    // floppy ears (lab-style)
    r(cx+7*dir,gy-11+dy,1,4,C2);
    r(cx+13*dir,gy-11+dy,1,4,C2);
    // muzzle
    r(cx+12*dir,gy-11+dy,3,3,C1);
    r(cx+12*dir,gy-11+dy,3,1,C2);
    p(cx+14*dir,gy-10+dy,N);
    p(cx+14*dir,gy-9+dy,N);
    // amber eye (signature lab look)
    p(cx+11*dir,gy-12+dy,'#a87238');
    // red collar
    r(cx+8*dir,gy-9+dy,4,1,'#c0382a');
  }
};


const BREED_LIST = ['chihuahua','dachshund','dachshundxl','corgi','poodle','beagle','golden','bulldog',
  'dalmatian','greyhound','greatdane','saint','sheepdog','husky','shiba','collie','pug','newf','lab'];

return {
  BR, BREED_LIST,
  setCtx(c){ ctx = c; },
  setShadows(v){ SHADOWS = v; },
};
})();

/* ---- cats.js ---- */
// CATS — five of them, drawn in the dog-park idiom so they stand in the same cast.
//
// Written for this site, not lifted: dog-park has no cats. Same primitives and
// the same conventions as breeds.js (body rect, a shade line top and bottom,
// legs, head hung off *dir, ink eye) so a cat and a dog bake identically and
// the rainbow pass cannot tell them apart.
//
// The concept needs them. Shelter day is dogs one day and cats the next, so a
// cast with no cats only tells half of it.
//
// What separates a cat from a small dog at this size, in order of how much work
// each does: the pointed ears, the tail carried UP, the small round head set
// high and forward, and the body being longer and lower than a dog of the same
// height. Get the ears and the tail right and it reads as a cat at 13 pixels.
window.CATPARK = (function(){
'use strict';
let ctx = null;
let SHADOWS = true;
const SHADOW = 'rgba(40,30,20,0.22)';

function r(x,y,w,h,c){ctx.fillStyle=c;ctx.fillRect(x|0,y|0,w|0,h|0)}
function p(x,y,c){ctx.fillStyle=c;ctx.fillRect(x|0,y|0,1,1)}
function disc(cx,cy,rr,c){for(let dy=-rr;dy<=rr;dy++){const sp=Math.round(Math.sqrt(rr*rr-dy*dy));r(cx-sp,cy+dy,sp*2,1,c)}}

function catShadow(cx, gy, w){
  if (!SHADOWS) return;
  ctx.fillStyle = SHADOW;
  ctx.beginPath();
  ctx.ellipse(cx, gy+1, w/2, Math.max(1.5, w*0.10), 0, 0, Math.PI*2);
  ctx.fill();
}

const BR = {};

BR.tabby = {name:"tabby", w:20, h:14, size:'small',
  draw(cx,gy,t,mood,dir){
    catShadow(cx,gy,20);
    const C1='#b09068', C2='#8a6c48', C3='#5a4228', WH='#f4ece0', N='#1a1008', EY='#9ac44e';
    const dy = mood==='squat'?2:0;
    r(cx-6,gy-8+dy,12,5,C1);
    r(cx-6,gy-8+dy,12,1,C2);
    r(cx-6,gy-4+dy,12,1,C2);
    r(cx-4,gy-7+dy,1,3,C3); r(cx-1,gy-7+dy,1,3,C3); r(cx+2,gy-7+dy,1,3,C3);
    r(cx-5,gy-3+dy,2,3,C1); r(cx-1,gy-3+dy,2,3,C1); r(cx+3,gy-3+dy,2,3,C1);
    r(cx-5,gy-1+dy,2,1,C2); r(cx-1,gy-1+dy,2,1,C2); r(cx+3,gy-1+dy,2,1,C2);
    r(cx+6*dir,gy-11+dy,5,4,C1);
    r(cx+6*dir,gy-11+dy,5,1,C2);
    r(cx+6*dir,gy-12+dy,2,1,C1); p(cx+6*dir,gy-13+dy,C2);
    r(cx+9*dir,gy-12+dy,2,1,C1); p(cx+10*dir,gy-13+dy,C2);
    p(cx+9*dir,gy-10+dy,EY);
    r(cx+7*dir,gy-8+dy,3,1,WH);
    p(cx+11*dir,gy-9+dy,N);
    // tail: the base has to OVERLAP the body, not sit a row above it, or the
    // cat reads as a cat next to a stick
    r(cx-8*dir,gy-8+dy,3,2,C1);
    r(cx-9*dir,gy-14+dy,2,7,C1);
    p(cx-9*dir,gy-15+dy,C3);
  }
};

BR.tuxedo = {name:"tuxedo", w:13, h:17, size:'small',
  draw(cx,gy,t,mood,dir){
    catShadow(cx,gy,12);
    const BK='#2a2a30', DK='#16161a', WH='#f6f2ea', N='#0a0a0c', EY='#e8c84a';
    const dy = mood==='squat'?2:0;
    // sitting upright — the cast needs one that is tall rather than long
    r(cx-4,gy-11+dy,8,10,BK);
    r(cx-4,gy-11+dy,8,1,DK);
    r(cx-1,gy-8+dy,4,7,WH);              // shirt front
    r(cx-4,gy-2+dy,3,2,WH); r(cx+1,gy-2+dy,3,2,WH);   // white socks
    r(cx-4,gy-1+dy,3,1,DK); r(cx+1,gy-1+dy,3,1,DK);
    r(cx+1*dir,gy-16+dy,5,5,BK);
    r(cx+1*dir,gy-16+dy,5,1,DK);
    r(cx+1*dir,gy-17+dy,2,1,BK); p(cx+1*dir,gy-18+dy,DK);
    r(cx+4*dir,gy-17+dy,2,1,BK); p(cx+5*dir,gy-18+dy,DK);
    p(cx+4*dir,gy-15+dy,EY);
    r(cx+2*dir,gy-13+dy,3,1,WH);
    p(cx+6*dir,gy-14+dy,N);
    // tail curled round the feet, the way a sitting cat parks it
    r(cx-7*dir,gy-2+dy,4,2,BK);
    r(cx-8*dir,gy-5+dy,2,4,BK);
  }
};

BR.ginger = {name:"ginger", w:22, h:15, size:'medium',
  draw(cx,gy,t,mood,dir){
    catShadow(cx,gy,22);
    const C1='#e0a054', C2='#b87830', C3='#7a4c18', WH='#fdf0dc', N='#2a1408', EY='#7ab84e';
    const dy = mood==='squat'?2:0;
    r(cx-7,gy-9+dy,14,6,C1);
    r(cx-7,gy-9+dy,14,1,C2);
    r(cx-7,gy-4+dy,14,1,C2);
    r(cx-5,gy-8+dy,1,4,C2); r(cx-2,gy-8+dy,1,4,C2); r(cx+1,gy-8+dy,1,4,C2);
    r(cx-4,gy-5+dy,8,2,WH);              // pale belly
    r(cx-6,gy-3+dy,2,3,C1); r(cx-1,gy-3+dy,2,3,C1); r(cx+4,gy-3+dy,2,3,C1);
    r(cx-6,gy-1+dy,2,1,WH); r(cx-1,gy-1+dy,2,1,WH); r(cx+4,gy-1+dy,2,1,WH);
    r(cx+7*dir,gy-13+dy,6,5,C1);
    r(cx+7*dir,gy-13+dy,6,1,C2);
    r(cx+7*dir,gy-14+dy,2,1,C1); p(cx+7*dir,gy-15+dy,C2);
    r(cx+11*dir,gy-14+dy,2,1,C1); p(cx+12*dir,gy-15+dy,C2);
    p(cx+11*dir,gy-12+dy,EY);
    r(cx+8*dir,gy-9+dy,4,1,WH);
    p(cx+13*dir,gy-10+dy,N);
    // big plumed tail, up and joined at the hip
    r(cx-9*dir,gy-9+dy,3,2,C1);
    r(cx-11*dir,gy-16+dy,3,8,C1);
    r(cx-11*dir,gy-16+dy,3,1,C3);
  }
};

BR.calico = {name:"calico", w:19, h:13, size:'small',
  draw(cx,gy,t,mood,dir){
    catShadow(cx,gy,19);
    const WH='#f6f0e4', OR='#d8913e', BK='#3a3028', C2='#cdc3b0', N='#1a1008', EY='#e8b23a';
    const dy = mood==='squat'?2:0;
    r(cx-6,gy-8+dy,12,5,WH);
    r(cx-6,gy-8+dy,12,1,C2);
    r(cx-6,gy-4+dy,12,1,C2);
    // the patches ARE the breed — three colours, hard edges, no blending
    r(cx-5,gy-8+dy,4,3,OR);
    r(cx+1,gy-7+dy,3,4,BK);
    p(cx-1,gy-6+dy,BK); p(cx+5,gy-8+dy,OR);
    r(cx-5,gy-3+dy,2,3,WH); r(cx-1,gy-3+dy,2,3,WH); r(cx+3,gy-3+dy,2,3,WH);
    r(cx-5,gy-1+dy,2,1,C2); r(cx-1,gy-1+dy,2,1,C2); r(cx+3,gy-1+dy,2,1,C2);
    r(cx+6*dir,gy-11+dy,5,4,WH);
    r(cx+6*dir,gy-11+dy,5,1,C2);
    r(cx+6*dir,gy-11+dy,2,2,OR);
    r(cx+6*dir,gy-12+dy,2,1,OR); p(cx+6*dir,gy-13+dy,BK);
    r(cx+9*dir,gy-12+dy,2,1,WH); p(cx+10*dir,gy-13+dy,C2);
    p(cx+9*dir,gy-10+dy,EY);
    p(cx+11*dir,gy-9+dy,N);
    r(cx-8*dir,gy-8+dy,3,2,OR);
    r(cx-9*dir,gy-13+dy,2,6,BK);
  }
};

BR.loaf = {name:"loaf", w:15, h:8, size:'tiny',
  draw(cx,gy,t,mood,dir){
    catShadow(cx,gy,15);
    const C1='#8f8f98', C2='#6b6b74', C3='#46464e', WH='#eceaf0', N='#14141a';
    // paws tucked, no legs at all — the shape is the joke, so nothing sticks out
    r(cx-6,gy-4+dy0(mood),12,4,C1);
    r(cx-6,gy-4+dy0(mood),12,1,C2);
    r(cx-6,gy-1+dy0(mood),12,1,C2);
    r(cx-4,gy-2+dy0(mood),8,1,WH);
    r(cx+4*dir,gy-7+dy0(mood),4,4,C1);
    r(cx+4*dir,gy-7+dy0(mood),4,1,C2);
    r(cx+4*dir,gy-8+dy0(mood),2,1,C1); p(cx+4*dir,gy-9+dy0(mood),C3);
    r(cx+6*dir,gy-8+dy0(mood),2,1,C1); p(cx+7*dir,gy-9+dy0(mood),C3);
    // eyes shut — a loafed cat is never looking at you
    r(cx+5*dir,gy-6+dy0(mood),2,1,N);
    p(cx+8*dir,gy-5+dy0(mood),N);
    r(cx-8*dir,gy-2+dy0(mood),3,1,C2);
  }
};
function dy0(mood){ return mood === 'squat' ? 1 : 0; }

const CAT_LIST = ['tabby','tuxedo','ginger','calico','loaf'];

return {
  BR, CAT_LIST,
  setCtx(c){ ctx = c; },
  setShadows(v){ SHADOWS = v; },
};
})();

/* ---- motion.js ---- */
// MOTION — legs, crouches and jumps, GENERATED off a baked sprite bitmap.
//
// The dog-park draw code in breeds.js has one pose per breed and never uses
// its time argument, and its only other mood, `squat`, is a two-pixel
// translation of the whole dog. So nothing here touches a draw function.
// Given any baked bitmap of an animal standing on its feet row, this finds
// the legs and makes the frames itself — for all 24 breeds and the cats
// alike — which is how the site's hero and the reel's carousel walk the
// same walk without either owning it.
//
// THE LEGS. Going up from the feet row, the first row filled across more
// than half the box is the belly; every row under it is leg. Each run of
// filled pixels in the feet row is one leg. A walk frame clears the leg zone
// under each run and repaints it swung sideways — the feet furthest, the
// hips hardly — front and back legs in opposite phase, the forward leg
// lifted a pixel off the ground at mid-swing. Six frames a cycle, keyed to
// DISTANCE WALKED, with a stride that grows with the legs: a chihuahua
// scurries, a great dane plods. The body rises a pixel on the frames where
// the legs pass.
//
// THE CROUCH is the body dropped onto shortened legs — the top rows of the
// leg zone go under the body. It is the take-off, the tuck in the air, and
// the landing of THE JUMP: 0.8s, a crouch, an arc on the crouch frame, a
// crouch, 7–15px high by leg length.
window.RRMotion = (function(){
'use strict';
const WALK_N = 6, JUMP_S = 0.8;
const data = new WeakMap();                 // canvas → its ImageData, read once

function pixels(cv){
  let d = data.get(cv);
  if (!d){ d = cv.getContext('2d').getImageData(0, 0, cv.width, cv.height); data.set(cv, d); }
  return d;
}

// Where the legs are on a bitmap — measured, so it works on any bake.
function legs(cv){
  const img = pixels(cv), W = cv.width, H = cv.height, d = img.data;
  const on = (x, y) => d[(y * W + x) * 4 + 3] > 8;
  let x0 = W, y0 = H, x1 = -1, y1 = -1;
  for (let y = 0; y < H; y++) for (let x = 0; x < W; x++) if (on(x, y)){
    if (x < x0) x0 = x; if (y < y0) y0 = y; if (x > x1) x1 = x; if (y > y1) y1 = y;
  }
  if (x1 < 0) return {belly: 0, fy: 0, runs: [], legRows: 0, amp: 1, crouch: 0, stride: 10, jump: 7, bbox: null};
  const bw = x1 - x0 + 1, fy = y1;
  let belly = fy;
  for (let y = fy; y >= y0; y--){
    let n = 0;
    for (let x = x0; x <= x1; x++) if (on(x, y)) n++;
    if (n >= bw * 0.5){ belly = y; break; }
  }
  const runs = [];
  for (let x = x0; x <= x1; x++){
    if (!on(x, fy)) continue;
    let xe = x; while (xe + 1 <= x1 && on(xe + 1, fy)) xe++;
    runs.push({x0: x, x1: xe}); x = xe;
  }
  const legRows = fy - belly;
  return {belly, fy, runs: legRows > 0 ? runs : [], legRows,
          amp: legRows <= 2 ? 1 : legRows <= 6 ? 2 : 3,
          crouch: legRows <= 0 ? 0 : legRows <= 2 ? 1 : legRows <= 8 ? 2 : 3,
          stride: 10 + legRows * 1.4,
          jump: 7 + Math.min(8, legRows * 0.4),
          bbox: {x0, y0, x1, y1}};
}
function toCanvas(img){
  const c = document.createElement('canvas'); c.width = img.width; c.height = img.height;
  c.getContext('2d').putImageData(img, 0, 0);
  return c;
}
// walk frame k of WALK_N, as a new canvas (the base if there are no legs)
function walk(cv, L, k){
  if (!L.runs.length) return cv;
  const W = cv.width, base = pixels(cv);
  const out = new ImageData(new Uint8ClampedArray(base.data), W, cv.height);
  const d = out.data, src = base.data;
  L.runs.forEach(function(r){
    for (let y = L.belly + 1; y <= L.fy; y++) for (let x = r.x0; x <= r.x1; x++){
      const i = (y * W + x) * 4; d[i] = d[i + 1] = d[i + 2] = d[i + 3] = 0;
    }
  });
  const ph = k / WALK_N * Math.PI * 2;
  L.runs.forEach(function(r, ri){
    const sw = Math.sin(ph + (ri % 2) * Math.PI);
    const lift = sw > 0.6 ? 1 : 0;
    for (let y = L.belly + 1; y <= L.fy; y++){
      const dx = Math.round(L.amp * sw * (y - L.belly) / L.legRows);
      for (let x = r.x0; x <= r.x1; x++){
        const si = (y * W + x) * 4; if (src[si + 3] <= 8) continue;
        const nx = x + dx, ny = y - lift;
        if (nx < 0 || nx >= W || ny < 0) continue;
        const di = (ny * W + nx) * 4;
        d[di] = src[si]; d[di + 1] = src[si + 1]; d[di + 2] = src[si + 2]; d[di + 3] = src[si + 3];
      }
    }
  });
  return toCanvas(out);
}
// the crouch, as a new canvas (the base if there are no legs)
function crouch(cv, L){
  if (!L.crouch || !L.bbox) return cv;
  const W = cv.width, base = pixels(cv), c = L.crouch;
  const out = new ImageData(W, cv.height), d = out.data, src = base.data;
  for (let y = L.bbox.y0; y <= L.fy; y++) for (let x = 0; x < W; x++){
    const si = (y * W + x) * 4; if (src[si + 3] <= 8) continue;
    const ny = y <= L.belly ? y + c : y;
    if (y > L.belly && y <= L.belly + c) continue;
    const di = (ny * W + x) * 4;
    d[di] = src[si]; d[di + 1] = src[si + 1]; d[di + 2] = src[si + 2]; d[di + 3] = src[si + 3];
  }
  return toCanvas(out);
}
function walkK(p, L){ return Math.floor((((p / L.stride) % 1) + 1) % 1 * WALK_N) % WALK_N; }
function walkBob(k){ return k % 3 === 0 ? 1 : 0; }
// where a jump is at time s in [0,1): the lift, and that the crouch frame is the one to draw
function jumpAt(L, s){
  if (s < 0 || s >= 1) return null;
  const air = s >= 0.15 && s < 0.85;
  return {lift: air ? Math.round(L.jump * Math.sin(Math.PI * (s - 0.15) / 0.7)) : 0, crouch: true};
}
return {WALK_N, JUMP_S, legs, walk, crouch, walkK, walkBob, jumpAt};
})();

/* ---- machine.js ---- */
// THE MACHINE — the parade engine, mounted on a canvas.
//
// Extracted from machine.html so the front page can run it as its hero without
// keeping a second copy of it. machine.html is now a full-bleed shell around
// this, and index.html embeds the same engine at a smaller size.
//
//   RRMachine.mount(canvas, {
//     mode, hold,          // starting pattern and crispness, else remembered
//     keys: false,         // don't bind the keyboard (a hero should not)
//     storeKey: 'hero',    // where preferences are remembered, per role
//     onMode, onHold, onPalette, onPause,
//   })
//
// Returns { toggle, cycleMode, setMode, setHold, fit, mode, hold, paused }.
// Needs sprites.js (for the four lights), gradients.js, palettes.js,
// rainbow.js and breeds.js loaded first.
window.RRMachine = (function(){
'use strict';

function mount(canvas, opts){
  opts = opts || {};
  const KEY = 'rr.' + (opts.storeKey || 'machine');
  const say = (k, v) => { if (opts[k]) opts[k](v); };

'use strict';
// The cast is dogs AND cats. cats.js is optional — if it is not on the page the
// machine is a dog machine, exactly as before.
const SRC = {};
DOGPARK.BREED_LIST.forEach(function(k){ SRC[k] = DOGPARK; });
if (window.CATPARK) CATPARK.CAT_LIST.forEach(function(k){ SRC[k] = CATPARK; });

const BR = {};
Object.keys(SRC).forEach(function(k){ BR[k] = SRC[k].BR[k]; });

// All eighteen breeds, plus the cats. The giants and the greyhound were held
// out of an earlier pass for reading oddly on their own — but that was a
// judgement about them in isolation, and in a line at true scale the size
// spread is the whole idea.
const BREEDS = Object.keys(SRC);
const REDUCED = matchMedia('(prefers-reduced-motion: reduce)').matches;

// ---------------------------------------------------------------- stage
// Logical pixels, all integers. The cube is sized off the biggest dog left in
// the cast (22x16) — it has to swallow one whole, or the change of colour
// happens in front of you instead of inside the machine.
//
// The STAGE WIDTH IS NOT FIXED. Pixel art needs a whole-number upscale, and a
// fixed logical width means the scale is whatever the window happens to allow —
// on a narrow pane that rounded down to 2x and the whole thing went tiny with
// the width unused either side. So the scale is chosen first, from a target
// physical size, and the logical width falls out of it. A wide window gets a
// longer line of dogs; a narrow one gets fewer dogs at the same size, which is
// the right thing to lose.
// ALL EIGHTEEN BREEDS, AT TRUE RELATIVE SIZE. A chihuahua is 8 pixels tall and
// a great dane is 60; that ratio is the point and nothing here normalises it.
//
// Which means the stage cannot be a set of constants any more. The machine has
// to swallow the largest animal in the cast whole — if a great dane's head is
// still showing when it crosses the middle, you watch it change colour and the
// trick is gone. So the geometry is MEASURED from the baked sprites at startup
// and everything else falls out of it. Add a breed, or redraw one bigger, and
// the room grows to fit without anyone editing a number.
// THE PORTAL IS A SQUARE. It was a disc, and a disc is a lamp; a square is a
// frame, and what comes out of this machine is a photograph. The dogs walk
// into the shape of the thing they are about to become. Flip it back to
// 'disc' and every consumer below follows without another edit.
const SHAPE = 'cube';                      // 'disc' or 'cube' — everything follows
const MAX_SCALE = 9;                       // past this, more dogs beats bigger dogs
let LH = 92, GROUND = 84;
let BOX = 106, BOX_TOP = 0, MIN_SPAN = 240;
let LW = 270, BX0 = 118, BX1 = 152, BCX = 135;
const SPEED = 19, GAP = 8;                 // logical px/sec, and the queue gap

const cv = canvas;
const ctx = cv.getContext('2d');
let SCALE = 4;
// Integer only. A fractional device ratio lands sprite pixels on half device
// pixels and the pixel art shimmers; the gradient wants the resolution, the
// dogs want the grid, and this is what keeps both honest.
const DPR = Math.max(1, Math.min(3, Math.round(window.devicePixelRatio || 1)));
function fit(){
  const host = cv.parentElement || document.body;
  const availW = Math.max(140, innerWidth - 12);
  const availH = Math.max(60, (host.clientHeight || innerHeight) - 12);
  let s = Math.max(2, Math.min(MAX_SCALE, Math.floor(availH / LH)));
  while (s > 2 && availW / s < MIN_SPAN) s--;   // never so big the line has nowhere to stand
  SCALE = s;
  LW = Math.max(BOX + 40, Math.floor(availW / SCALE));
  BX0 = (LW - BOX) >> 1; BX1 = BX0 + BOX; BCX = (BX0 + BX1) >> 1;
  cv.width = LW * SCALE * DPR; cv.height = LH * SCALE * DPR;
  cv.style.width = (LW * SCALE) + 'px'; cv.style.height = (LH * SCALE) + 'px';
  ctx.setTransform(SCALE * DPR, 0, 0, SCALE * DPR, 0, 0);
  ctx.imageSmoothingEnabled = false;
}
addEventListener('resize', fit);

// ---------------------------------------------------------------- palette
const LIGHTS = ['red','blue','green','yellow'].map(k => RR.LIGHTS[k]);
const INK = '#111114';

// ---------------------------------------------------------------- baking
// Each breed is drawn once, at a fixed local origin, into its own canvas. The
// rainbow version is the same bitmap put through RINGS.stamp() — recolouring
// the pixels afterwards means all 18 dog-park breeds get the treatment without
// a single line of their draw code being touched.
const PAD = 8;
const cache = new Map();

// The fur drifts like the machine does. That cannot be one baked still, and it
// cannot be a getImageData pass per dog per frame either, so the cycle is baked
// into RINGS.STEPS phases per breed and the loop just picks the current one.
// Twenty-four steps of a 4s cycle is a step every 167ms — at four or five
// screen pixels per logical pixel the drift is chunky anyway, and stepping it
// costs nothing that a smooth version would have bought. The machine's own face
// is cached on the same steps, so the cube and the fur drift in lockstep.
const phaseStep = now => Math.floor(now / RINGS.DRIFT_MS * RINGS.STEPS) % RINGS.STEPS;
// The portal keeps its own clock — 11s, to match the CSS orb in the header.
const orbStep  = now => Math.floor(now / RINGS.ORB.driftMs * RINGS.STEPS) % RINGS.STEPS;

// THE LEGS MOVE (7 Sep 2026). `frame` picks a walk frame (0–5) or the
// crouch (-1) generated off the plain bake by motion.js — the same frames
// the carousel walks — and the rainbow is stamped onto that frame. No
// frame given means the plain standing bake, which is what the metrics
// are measured on.
const legsCache = new Map();
function legsOf(key){
  let L = legsCache.get(key);
  if (!L){ L = RRMotion.legs(baked(key, false, 0, 0).cv); legsCache.set(key, L); }
  return L;
}
function baked(key, rainbow, step, stamp, frame){
  const id = key + (frame === undefined ? '' : '@' + frame) + (rainbow ? '#' + RINGS.mode + '#' + step + '#' + (stamp || 0) : '');
  if (cache.has(id)) return cache.get(id);
  const b = BR[key];
  const W = b.w + PAD * 2, H = b.h + PAD * 2;
  let c = document.createElement('canvas'); c.width = W; c.height = H;
  let g = c.getContext('2d');
  g.imageSmoothingEnabled = false;
  const ax = PAD + Math.round(b.w / 2), ay = H - PAD;
  if (frame === undefined){
    const src = SRC[key];
    src.setCtx(g); src.setShadows(false);
    b.draw(ax, ay, 0, 'walk', 1);
  } else {
    const base = baked(key, false, 0, 0).cv, L = legsOf(key);
    const f = frame < 0 ? RRMotion.crouch(base, L) : RRMotion.walk(base, L, frame);
    g.drawImage(f, 0, 0);
  }
  if (rainbow){
    const keep = RINGS.morphT;
    if (stamp) RINGS.setMorphT(stamp);           // the palette this dog walked into
    RINGS.stamp(g, W, H, step / RINGS.STEPS);
    if (stamp) RINGS.setMorphT(keep);
  }
  const o = { cv: c, ax, ay, w: b.w, h: b.h };
  cache.set(id, o);
  return o;
}

// The declared w/h under-report — several dog-park breeds draw a tail or a
// muzzle past their own box. Measure the baked alpha instead, or the queue
// overlaps and a dog's nose ends up in the dog ahead.
const metrics = new Map();
function reach(key){
  if (metrics.has(key)) return metrics.get(key);
  const b = baked(key, false, 0, 0), g = b.cv.getContext('2d');
  const W = b.cv.width, H = b.cv.height;
  const d = g.getImageData(0, 0, W, H).data;
  let lo = W, hi = 0;
  for (let y = 0; y < H; y++) for (let x = 0; x < W; x++){
    if (d[(y*W+x)*4+3] > 8){ if (x < lo) lo = x; if (x > hi) hi = x; }
  }
  let top = H;
  for (let y = 0; y < H; y++){
    for (let x = 0; x < W; x++) if (d[(y*W+x)*4+3] > 8){ top = y; break; }
    if (top < H) break;
  }
  const m = { back: b.ax - lo, front: hi - b.ax + 1, w: hi - lo + 1, tall: b.ay - top };
  metrics.set(key, m);
  return m;
}

// Size the room to ONE animal — the tallest — and let the long one walk through.
//
// This used to take the worst of every dimension across all eighteen breeds:
// the greatest height from one dog and the greatest length from another. The
// greatest length is the dachshund, which is barely a hand tall and about as
// long as a great dane, and feeding its width into hypot() blew the orb up to
// swallow a shape no single animal actually has. A bigger orb means a taller
// stage, a taller stage means a smaller integer scale, and the entire parade
// came out miniature to protect one sausage dog.
//
// So the orb is sized to the TALLEST breed's own box — one animal, its own two
// numbers — and the dachshund simply is not covered end to end when it crosses.
// It walks through. That is the right thing to lose: nobody watching is
// checking whether a dachshund's tail cleared the disc, and everything else on
// the stage got half again bigger for it.
//
// MIN_SPAN still uses the widest breed, because the queue does have to stand
// somewhere and the dachshund needs the floor even if it does not need the orb.
function sizeStage(){
  let tall = null, widest = 1;
  BREEDS.forEach(function(k){
    const m = reach(k);
    widest = Math.max(widest, m.back, m.front);
    if (!tall || m.tall > tall.tall) tall = m;
  });
  const hw = Math.max(tall.back, tall.front), ht = tall.tall;
  // A wider margin than the old 1.06 — with the dachshund out of the maths the
  // disc had room to be generous, and Paul wanted the portal bigger, not just
  // the dogs.
  const R = Math.ceil(Math.hypot(hw, ht / 2) * 1.2) + 2;
  BOX = R * 2;
  const cy = Math.round(ht / 2);           // orb centre, above the ground line
  // HEADROOM FOR WHAT HE SAYS. The room used to be sized to the orb and the
  // tallest dog. The photographer is taller than any of them and he has a
  // speech bubble above his cap, so the ceiling was landing at y=-1 and the
  // bubble was being cut off by the top of the canvas. This is the space above
  // his hat, and nothing else claims it.
  const HEADROOM = 22;
  GROUND = R + cy + 4 + HEADROOM;          // room for the orb's top above it
  LH = GROUND + 8;                         // and a little under it for shadows
  BOX_TOP = GROUND - cy - R;
  MIN_SPAN = BOX + widest * 2 + 40;        // never so tight the queue cannot stand
}

// ---------------------------------------------------------------- the queue
let bag = [];
function nextBreed(){
  if (!bag.length){                                  // shuffled bag: all 18 before a repeat
    bag = BREEDS.slice();      // shuffled bag: the whole cast before a repeat
    for (let i = bag.length - 1; i > 0; i--){ const j = Math.random() * (i+1) | 0; [bag[i],bag[j]] = [bag[j],bag[i]]; }
  }
  return bag.pop();
}


// dogs[0] is the one nearest the machine. New arrivals go on the end.
const dogs = [];
function spawn(){
  const key = nextBreed();
  const d = { key, x: 0, rainbow: false, dist: Math.random() * 40, moving: true, out: false, jumpT: 0 };
  const tail = dogs[dogs.length - 1];
  const behind = tail ? tail.x - (reach(tail.key).back + reach(key).front + GAP) : BX0 - 40;
  d.x = Math.min(behind, -reach(key).front - 6);
  dogs.push(d);
}

// Who is mid-transformation. Only a dog that has not yet crossed the middle
// holds the door — once it is rainbow it is on its way out and the next one can
// come in behind it. Both are hidden by the front face while that overlaps.
function busyDog(){
  for (const d of dogs){
    if (d.rainbow) continue;
    if (d.x + reach(d.key).front > BX0 + 2 && d.x - reach(d.key).back < BX1) return d;
  }
  return null;
}

// ---------------------------------------------------------------- sparks
const sparks = [];
function fire(){
  for (let i = 0; i < 9; i++){
    sparks.push({
      x: BCX + (Math.random() - 0.5) * (BOX - 20),
      y: BOX_TOP + Math.random() * 3,
      vx: (Math.random() - 0.5) * 14,
      vy: -10 - Math.random() * 14,
      life: 0.5 + Math.random() * 0.3, t: 0,
      c: LIGHTS[Math.random() * 4 | 0],
    });
  }
  flash = 1;
}
let flash = 0;
let palShown = '';

// ---------------------------------------------------------------- draw
function ellipseShadow(cx, w){
  const rx = Math.max(2, w * 0.5);
  ctx.fillStyle = 'rgba(17,17,20,0.09)';
  ctx.beginPath();
  ctx.ellipse(cx, GROUND + 1, rx, Math.max(1.2, w * 0.09), 0, 0, Math.PI * 2);
  ctx.fill();
}

// THE PHOTOGRAPHER. He stands on the far side of the orb — the side the dogs
// come OUT of — with the camera on a tripod aimed back into it. He is drawn
// BEFORE the dogs so they walk in front of him rather than behind, which is
// what actually happens in a room.
//
// HE PRESSES ON `fire()`. That call already exists: it is what runs the moment
// a dog reaches the centre of the orb and turns rainbow, and it is what sets
// `flash`. So the shutter, the flash and the dog coming out colour are one
// event rather than three things timed to look like one. While flash is high
// his whole body lifts a pixel — the recoil of leaning on the button.
// WHAT HE SAYS lives in content.js, under `greeter` — the names, the lines and
// the asides, with the notes on why each is worded the way it is. It moved out
// of here when the reel needed the same man saying the same things: two copies
// of a voice is how a voice stops being one. This reads it, and falls back to
// silence rather than to invented copy if content.js is not on the page.
const GR = (window.CONTENT && CONTENT.greeter) || {names: [], lines: [], asides: []};
const GREETER_NAMES = GR.names, GREETER_LINES = GR.lines, GREETER_ASIDES = GR.asides;

let bubble = null;
function speak(){
  let text;
  if (!GREETER_LINES.length && !GREETER_ASIDES.length) return;   // no copy, no bubble
  if (!GREETER_LINES.length || Math.random() < 0.34){
    text = GREETER_ASIDES[(Math.random() * GREETER_ASIDES.length) | 0];
  } else {
    const n = GREETER_NAMES[(Math.random() * GREETER_NAMES.length) | 0];
    // No good boy / good girl any more — he does not guess at anybody's
    // anything, and the line was the one tired thing he said.
    const line = GREETER_LINES[(Math.random() * GREETER_LINES.length) | 0];
    text = line.replace('{n}', n);
  }
  // LOTS OF EXCLAMATION POINTS. Paul, 7 Sep 2026: "when he talks, there
  // should be lots of exclamation points after everything he says." A
  // question keeps its mark and gets them anyway; a full stop or a single
  // bang comes off first so nothing reads ".!!!". Three to five, by the
  // line's own length, so the same line always shouts the same amount.
  text = text.replace(/[.!\s]+$/, '');
  text += '!!!'.slice(0, 3) + '!!'.slice(0, text.length % 3);
  bubble = { text: text, t: 0 };
}

// A HARD BUBBLE WITH A STEPPED TAIL — the house shape, drawn on the pixel grid
// rather than with a curve, so it belongs to the same world as the sprites. The
// text is NDot, which is the site's own dot-matrix face, so it is not a
// smooth-edged label sitting on top of pixel art.
// IN FRONT OF THE ORB, not over his head. He is at the right-hand edge of the
// room and the bubble was reaching out over nothing; the orb is the brightest
// thing on the stage and a white box on top of it is the one place the eye is
// already looking. Drawn AFTER the disc so it sits on it rather than under.
function drawBubble(dt, manX, manTop){
  if (!bubble || !greeterAt.on) return;
  bubble.t += dt;
  const LIFE = 2.6, FADE = 0.45;
  if (bubble.t > LIFE){ bubble = null; return; }
  const a = bubble.t > LIFE - FADE ? (LIFE - bubble.t) / FADE : Math.min(1, bubble.t / 0.12);

  ctx.save();
  ctx.globalAlpha = a;
  ctx.font = '7px NDot, monospace';
  ctx.textBaseline = 'top';
  const tw = Math.ceil(ctx.measureText(bubble.text).width);
  const bw = tw + 8, bh = 13;
  // It hangs off his cap and reaches LEFT, over the orb, because there is room
  // there and none to his right — he is already against the edge of the room.
  // Higher off the cap than it was, and clamped: whatever the room works out
  // to, the bubble stays inside it rather than being clipped by the ceiling.
  // ABOVE HIM, READING LEFT. It belongs to the man, so it hangs off his cap and
  // runs back over the orb rather than sitting on the orb's own middle — the
  // tail is what ties it to him and it only has a short way to travel.
  //
  // He is 93 rows tall in a room with 22 of ceiling, so there is not quite the
  // headroom to clear his hat outright. It takes what there is and clamps to
  // the top of the canvas, which lands the tail on the brim — touching his cap
  // rather than floating above it. Raising the ceiling instead would cost the
  // whole parade an integer step of scale, which is a bad trade for four
  // pixels of air.
  const bx = Math.round(Math.min(LW - bw - 2, Math.max(2, manX + 22 - bw)));
  const by = Math.round(Math.max(2, manTop - bh - 4));
  ctx.fillStyle = '#f7f4ed';
  ctx.fillRect(bx, by, bw, bh);
  ctx.fillStyle = INK;
  ctx.fillRect(bx, by - 1, bw, 1); ctx.fillRect(bx, by + bh, bw, 1);
  ctx.fillRect(bx - 1, by, 1, bh); ctx.fillRect(bx + bw, by, 1, bh);
  // the tail, three steps down toward the brim of his cap
  const tx = bx + bw - 11;
  ctx.fillStyle = '#f7f4ed';
  ctx.fillRect(tx, by + bh, 5, 1); ctx.fillRect(tx + 1, by + bh + 1, 4, 1);
  ctx.fillRect(tx + 2, by + bh + 2, 3, 1);
  ctx.fillStyle = INK;
  ctx.fillRect(tx - 1, by + bh, 1, 1); ctx.fillRect(tx, by + bh + 1, 1, 1);
  ctx.fillRect(tx + 1, by + bh + 2, 1, 1); ctx.fillRect(tx + 2, by + bh + 3, 3, 1);
  ctx.fillRect(tx + 5, by + bh, 1, 1); ctx.fillRect(tx + 5, by + bh + 1, 1, 1);
  ctx.fillStyle = INK;
  ctx.fillText(bubble.text, bx + 4, by + 3);
  ctx.restore();
}

// He is baked in TWO pieces. Everything but the shirt goes in one canvas; the
// shirt goes in another as a silhouette, and every frame a moving gradient is
// poured through that silhouette and stamped on top. That is why 'r' carries no
// real colour in the palette — it is a mask, not a garment.
let greeterCv = null, greeterShirt = null, greeterTmp = null, greeterToy = null;
const greeterAt = { x: 0, y: 0, on: false };

// A BROADER MAN, WITH LEGS. Paul, 7 Sep 2026, on the site's hero: "the
// photographer, me, he needs to be wider, and his legs need to be thicker."
// The sprite in sprites.js is untouched — it is generated, and the reel
// reads it too — so the width is put on at bake time, the way the carousel
// already does it (head ×1.3, body ×1.7 about the spine at column 22.5,
// everything left of column 18 — the camera, the tripod, the hand — left
// where it stands so the toy and the shutter still line up). Then the legs:
// on every row that has two of them, each grows a pixel outward and a pixel
// inward, so a three-pixel leg with a two-pixel gap ends up seven wide with
// one pixel of daylight between — the width of the hips above.
function broadRows(rows){
  const CX = 22.5, out = rows.map(r => r.split(''));
  rows.forEach(function(r, y){
    // The head grows a little, the body a lot. The body may grow LEFT as far
    // as column 15 — two pixels of daylight from the camera's back edge at 13
    // — so it broadens on both sides of the spine rather than only away from
    // the lens; the head stays clipped at 18 because the cap's brim (rows 6–7)
    // runs left of there and must not be wiped.
    const head = y <= 16, F = head ? 1.3 : 5 / 3, lo = head ? 18 : 15;
    for (let x = lo; x < r.length; x++) out[y][x] = '.';
    for (let x = 18; x < r.length; x++){
      const ch = r[x]; if (ch === '.') continue;
      const a = Math.round(CX + (x - 0.5 - CX) * F), b = Math.round(CX + (x + 0.5 - CX) * F);
      for (let d = Math.max(lo, a); d < Math.min(r.length, Math.max(b, a + 1)); d++) out[y][d] = ch;
    }
  });
  // the arm: rows 21–22 carry it; give it a row each side
  [20, 23].forEach(function(y){
    for (let x = 14; x <= 17; x++) if (out[21][x] === 'r' && out[y][x] === '.') out[y][x] = 'r';
  });
  return out.map(a => a.join(''));
}
function thickLegs(rows){
  return rows.map(function(r){
    const runs = []; let s = -1;
    for (let x = 0; x <= r.length; x++){
      const on = x < r.length && r[x] === 'p';
      if (on && s < 0) s = x;
      if (!on && s >= 0){ runs.push([s, x - 1]); s = -1; }
    }
    if (runs.length !== 2) return r;                 // hips, or no legs on this row
    const out = r.split(''), [L, R] = runs;
    const grow = function(x){ if (x >= 0 && x < out.length && out[x] === '.') out[x] = 'p'; };
    grow(L[0] - 1); grow(R[1] + 1);                  // outward
    if (R[0] - L[1] - 1 >= 3){ grow(L[1] + 1); grow(R[0] - 1); }   // inward, keeping daylight
    return out.join('');
  });
}

function bakeGreeter(){
  if (greeterCv) return;
  const rows = thickLegs(broadRows(RR.GREETER)), GW = RR.GREETER_W, GH = rows.length, pal = RR.GREETER_PAL;
  const mk = () => { const c = document.createElement('canvas'); c.width = GW; c.height = GH;
                     const g = c.getContext('2d'); g.imageSmoothingEnabled = false; return [c, g]; };
  const [cb, gb] = mk(), [cs, gs] = mk(), [ct] = mk(), [cy, gy] = mk();
  for (let y = 0; y < GH; y++){
    const row = rows[y];
    for (let x = 0; x < GW; x++){
      const ch = row[x];
      if (!ch || ch === '.') continue;
      if (ch === 'r'){ gs.fillStyle = '#fff'; gs.fillRect(x, y, 1, 1); }
      else if (pal[ch]){ gb.fillStyle = pal[ch]; gb.fillRect(x, y, 1, 1); }
    }
  }
  // the raised arm and the toy, same grid, same anchor
  const trows = RR.GREETER_TOY || [];
  for (let y = 0; y < trows.length; y++){
    const row = trows[y];
    for (let x = 0; x < GW; x++){
      const ch = row[x];
      if (ch && ch !== '.' && pal[ch]){ gy.fillStyle = pal[ch]; gy.fillRect(x, y, 1, 1); }
    }
  }
  greeterCv = cb; greeterShirt = cs; greeterTmp = ct; greeterToy = cy;
}

// THE SHIRT RUNS THE LOOP BACKWARDS. The orb drifts one way; the shirt drifts
// the other, so the two are never travelling together and the eye can tell
// which is which. It also breathes — the ramp squeezes and opens on its own
// slower cycle, so the bands are not a conveyor belt of even stripes.
const SHIRT_COLS = ['#ffc93a', '#31e39a', '#3b4eea', '#ff2e88'];
function paintShirt(now){
  const GW = greeterTmp.width, GH = greeterTmp.height;
  const g = greeterTmp.getContext('2d');
  g.clearRect(0, 0, GW, GH);
  const phase = ((-now / 2400) % 1 + 1) % 1;          // reverse
  const squeeze = 0.72 + 0.28 * (0.5 + 0.5 * Math.sin(now / 900));   // the pulse
  const span = GH * squeeze;
  const off = phase * span;
  const lg = g.createLinearGradient(0, -off, 0, span * 2 - off);
  for (let k = 0; k <= 8; k++) lg.addColorStop(k / 8, SHIRT_COLS[k % 4]);
  g.fillStyle = lg;
  g.fillRect(0, 0, GW, GH);
  g.globalCompositeOperation = 'destination-in';
  g.drawImage(greeterShirt, 0, 0);
  g.globalCompositeOperation = 'source-over';
}

function drawGreeter(now){
  if (!RR.GREETER) return;
  bakeGreeter();
  // Just clear of the orb's right edge, and never off the end of the room —
  // at a narrow window the stage shrinks and he would otherwise walk out of it.
  const x = Math.min(BX1 + 8, LW - greeterCv.width - 2);
  if (x < BX1 + 2){ greeterAt.on = false; return; }   // no room for him; the orb wins
  const press = flash > 0.45 ? 1 : 0;      // he leans in as the shutter goes
  const y = Math.round(GROUND - greeterCv.height + 1 - press);
  greeterAt.x = x; greeterAt.y = y; greeterAt.on = true;
  ellipseShadow(x + greeterCv.width - 12, 14);
  ctx.drawImage(greeterCv, Math.round(x), y);
  if (!REDUCED) paintShirt(now); else paintShirt(0);
  ctx.drawImage(greeterTmp, Math.round(x), y);
  // THE OTHER HAND GOES UP WHILE HE IS TALKING. You squeak a toy to make a dog
  // look at you, and he is mid-sentence to a dog — so the arm is up for as long
  // as the bubble is, which means it goes up for a couple of seconds after each
  // animal reaches the orb and comes down on its own. It is drawn over the
  // shirt, not under it, because the shoulder of the raised arm IS shirt.
  if (greeterToy && bubble) ctx.drawImage(greeterToy, Math.round(x), y);
}

// THE RIM, AND WHERE THE FLASH GOES. The flash used to flood the whole disc
// white, which wiped out the gradient at the exact moment the dog was turning
// colour — the one frame worth looking at. It lights the BORDER instead: a ring
// that is already a partial gradient of the four lights, with white added into
// it as the shutter goes. The disc underneath is never touched.
function drawRim(){
  const r = BOX / 2, cx = BCX, cy = BOX_TOP + r;
  const lit = Math.min(1, flash);
  const g = ctx.createLinearGradient(cx - r, cy - r, cx + r, cy + r);
  const mix = (hex) => hex;
  g.addColorStop(0.00, mix('#ffc93a'));
  g.addColorStop(0.34, mix('#31e39a'));
  g.addColorStop(0.67, mix('#3b4eea'));
  g.addColorStop(1.00, mix('#ff2e88'));
  ctx.save();
  ctx.globalAlpha = 0.30 + 0.35 * lit;
  ctx.lineWidth = 1 + 1.6 * lit;
  ctx.strokeStyle = g;
  // THE RIM FOLLOWS THE SHAPE. It stroked an arc unconditionally, which on a
  // square portal drew a circle floating inside the frame — the one place the
  // disc geometry was hard-coded rather than read from SHAPE.
  const edge = () => {
    ctx.beginPath();
    if (SHAPE === 'disc') ctx.arc(cx, cy, r - 0.5, 0, Math.PI * 2);
    else ctx.rect(BX0 + 0.5, BOX_TOP + 0.5, BOX - 1, BOX - 1);
    ctx.stroke();
  };
  edge();
  if (lit > 0.02){
    // the white, ADDED — lighter, not painted over
    ctx.globalCompositeOperation = 'lighter';
    ctx.globalAlpha = lit * 0.85;
    ctx.lineWidth = 1 + 2.2 * lit;
    ctx.strokeStyle = '#ffffff';
    edge();
  }
  ctx.restore();
}

// BACK TO A PLAIN PULSE. There was a stepped version here that walked one
// colour at a time and lingered on some of them; it worked, and it was not what
// the piece wanted. The cat and the dog on the tickets simply pulse, and the
// orb is the same object at another size, so it pulses too — one continuous
// drift, no rhythm of its own to notice.
function orbPhase(now){ return now / RINGS.ORB.driftMs; }

function drawBox(now){
  ctx.fillStyle = 'rgba(17,17,20,0.09)';
  ctx.beginPath();
  ctx.ellipse(BCX, GROUND + 1, BOX * 0.34, 2, 0, 0, Math.PI * 2);
  ctx.fill();
  if (RINGS.mode === 'morph' || RINGS.mode === 'cosine' || RINGS.mode === 'blend'){
    // full device resolution, and the phase runs continuously — a smooth
    // gradient stepping 24 times a cycle reads as a stutter
    RINGS.squareGradient(ctx, BX0, BOX_TOP, BOX, orbPhase(now), SHAPE === 'disc');
  } else {
    ctx.drawImage(RINGS.squareCanvas(BOX, orbStep(now), SHAPE === 'disc'), BX0, BOX_TOP);
  }
  drawRim();
  // No outline on the disc — the reference has none, and a hard ring round a
  // soft orb kills the whole thing.
  if (SHAPE !== 'disc'){
    ctx.fillStyle = INK;
    ctx.fillRect(BX0 - 1, BOX_TOP - 1, BOX + 2, 1);
    ctx.fillRect(BX0 - 1, BOX_TOP + BOX, BOX + 2, 1);
    ctx.fillRect(BX0 - 1, BOX_TOP, 1, BOX);
    ctx.fillRect(BX1, BOX_TOP, 1, BOX);
  }
}

function frame(dt, now){
  ctx.clearRect(0, 0, LW, LH);
  if (RINGS.mode === 'morph' || RINGS.mode === 'cosine'){
    RINGS.setMorphT(now / 1000);
    if (cache.size > 500) cache.clear();      // dogs retire, their bakes should too
    const nm = RINGS.morphLabel();
    if (nm !== palShown){ palShown = nm; say('onPalette', nm); }
  }

  const busy = busyDog();
  for (let i = 0; i < dogs.length; i++){
    const d = dogs[i];
    let limit = Infinity;
    const ahead = dogs[i - 1];
    if (ahead) limit = ahead.x - (reach(ahead.key).back + reach(d.key).front + GAP);
    // one dog through the machine at a time — everybody else waits outside
    if (!d.rainbow && busy && busy !== d) limit = Math.min(limit, BX0 - reach(d.key).front - 1);
    const nx = Math.min(d.x + SPEED * dt, limit);
    d.moving = nx - d.x > SPEED * dt * 0.35;
    if (d.moving) d.dist += nx - d.x;               // the walk cycle is keyed to distance
    d.x = nx;
    // A LEAP ON THE WAY OUT: the moment its back clears the box, a dog that
    // has just been made rainbow jumps once — the reveal, not the entrance,
    // because inside the box nobody would see it
    if (d.rainbow && !d.out && d.x - reach(d.key).back > BX1){ d.out = true; d.jumpT = now; }
    if (!d.rainbow && d.x >= BCX){
      d.rainbow = true;
      // quantised so two dogs a moment apart share a bake instead of each
      // minting 24 canvases of their own
      d.stamp = Math.round(RINGS.morphT * 4) / 4;   // quantised: neighbours share a bake
      fire();
      speak();
      // ONE DOG THROUGH, ONE PHOTOGRAPH OUT. The machine does not know what a
      // reel is; it says that a sitting just happened and the page decides
      // what to do with that. Nothing breaks if nobody is listening.
      say('onRainbow', d.key);
    }
  }

  // retire whoever has walked off the right, and top the line up on the left
  while (dogs.length && dogs[0].x - reach(dogs[0].key).back > LW + 14) dogs.shift();
  const tail = dogs[dogs.length - 1];
  if (!tail || tail.x > -reach(tail.key).front - 8) spawn();

  drawGreeter(now);

  const step = phaseStep(now);
  for (const d of dogs){
    let frame, lift = 0;
    if (REDUCED){ frame = undefined; }
    else {
      const L = legsOf(d.key);
      const j = d.jumpT ? RRMotion.jumpAt(L, (now - d.jumpT) / (RRMotion.JUMP_S * 1000)) : null;
      if (j){ frame = -1; lift = j.lift; }
      else { const k = d.moving ? RRMotion.walkK(d.dist, L) : 0; frame = k; lift = d.moving ? RRMotion.walkBob(k) : 0; }
    }
    const b = baked(d.key, d.rainbow, step, d.stamp, frame);
    ellipseShadow(d.x, reach(d.key).w);
    ctx.drawImage(b.cv, Math.round(d.x - b.ax), Math.round(GROUND - b.ay - lift));
  }

  drawBox(now);
  drawBubble(dt, greeterAt.x, greeterAt.y);

  for (let i = sparks.length - 1; i >= 0; i--){
    const s = sparks[i];
    s.t += dt;
    if (s.t > s.life){ sparks.splice(i, 1); continue; }
    s.x += s.vx * dt; s.y += s.vy * dt; s.vy += 26 * dt;
    ctx.globalAlpha = 1 - s.t / s.life;
    ctx.fillStyle = s.c;
    ctx.fillRect(Math.round(s.x), Math.round(s.y), 1, 1);
    ctx.globalAlpha = 1;
  }
  flash = Math.max(0, flash - dt * 5.5);
}

// ---------------------------------------------------------------- run

sizeStage();
fit();
// prime the line so it opens mid-scene rather than empty
for (let i = 0; i < 8; i++) spawn();
for (let i = 0; i < 900; i++) frame(1 / 60, 0);
sparks.length = 0; flash = 0;

let paused = REDUCED, last = performance.now();
function loop(now){
  const dt = Math.min(0.05, (now - last) / 1000); last = now;
  if (!paused) frame(dt, now);
  requestAnimationFrame(loop);
}
if (REDUCED) frame(0, 0);                    // one still frame, then hold
requestAnimationFrame(loop);

// G cycles blend → dither → band. Every patterned dog is re-baked, because the
// bake cache is keyed on the mode.
function setMode(m){
  RINGS.setMode(m);
  cache.clear(); metrics.clear();
  say('onMode', m);
  palShown = '';
  say('onPalette', '');
  try { localStorage.setItem(KEY + '.mode', m); } catch (e) {}
}
const qs = new URLSearchParams(location.search);
let saved = opts.mode || qs.get('mode');
if (!saved){ try { saved = localStorage.getItem(KEY + '.mode'); } catch (e) {} }
setMode(RINGS.MODES.indexOf(saved) >= 0 ? saved : 'blend');
// [ and ] are the crispness dial — how much of each ring is flat colour rather
// than transition. Live, because this is a taste setting and a round trip per
// guess is no way to find it.
function setHold(v){
  RINGS.setHold(v);
  cache.clear(); metrics.clear();
  say('onHold', Math.round(RINGS.hold * 100));
  try { localStorage.setItem(KEY + '.hold', String(RINGS.hold)); } catch (e) {}
}

{
  let hv = opts.hold !== undefined ? String(opts.hold) : qs.get('hold');
  if (hv === null){ try { hv = localStorage.getItem(KEY + '.hold'); } catch (e) {} }
  // 0 is the melt — no flat plateau at any stop, the whole radius is transition.
  // That is the soft-orb look. Press ] for flat fields with clean edges instead.
  setHold(hv === null ? 0 : parseFloat(hv));
}
function nextMode(){ return RINGS.MODES[(RINGS.MODES.indexOf(RINGS.mode) + 1) % RINGS.MODES.length]; }
function toggle(){ paused = !paused; say('onPause', paused); last = performance.now(); return paused; }

if (opts.keys !== false){
  addEventListener('keydown', e => {
    if (e.target && /^(INPUT|TEXTAREA|SELECT)$/.test(e.target.tagName)) return;
    if (e.code === 'Space'){ e.preventDefault(); toggle(); }
    if (e.key === 'g' || e.key === 'G') setMode(nextMode());
    if (e.key === '[') setHold(RINGS.hold - 0.02);
    if (e.key === ']') setHold(RINGS.hold + 0.02);
    if (opts.onKey) opts.onKey(e);
  });
}

return {
  toggle, nextMode, fit,
  // what sizeStage() worked out — the room is measured, so it is worth being
  // able to read it back
  geometry: () => ({ LW, LH, GROUND, BOX, BOX_TOP, BCX, MIN_SPAN, SCALE, breeds: BREEDS.length,
                     biggest: BREEDS.map(k => ({ k, ...reach(k) })).sort((a,b) => b.tall - a.tall)[0] }),
  setMode, setHold,
  cycleMode: () => setMode(nextMode()),
  get mode(){ return RINGS.mode; },
  get hold(){ return RINGS.hold; },
  get paused(){ return paused; },
};

}

return { mount };
})();
